// eslint-disable-next-line no-unused-vars
var pokedex = {
    "Bulbasaur": {
        "hp": 45,
        "atk": 49,
        "def": 49,
        "spa": 65,
        "spd": 65,
        "spe": 45
    },
    "Ivysaur": {
        "hp": 60,
        "atk": 62,
        "def": 63,
        "spa": 80,
        "spd": 80,
        "spe": 60
    },
    "Venusaur": {
        "hp": 80,
        "atk": 82,
        "def": 83,
        "spa": 100,
        "spd": 100,
        "spe": 80
    },
    "Venusaur-Mega": {
        "hp": 80,
        "atk": 100,
        "def": 123,
        "spa": 122,
        "spd": 120,
        "spe": 80
    },
    "Venusaur-Gmax": {
        "hp": 80,
        "atk": 82,
        "def": 83,
        "spa": 100,
        "spd": 100,
        "spe": 80
    },
    "Charmander": {
        "hp": 39,
        "atk": 52,
        "def": 43,
        "spa": 60,
        "spd": 50,
        "spe": 65
    },
    "Charmeleon": {
        "hp": 58,
        "atk": 64,
        "def": 58,
        "spa": 80,
        "spd": 65,
        "spe": 80
    },
    "Charizard": {
        "hp": 78,
        "atk": 84,
        "def": 78,
        "spa": 109,
        "spd": 85,
        "spe": 100
    },
    "Charizard-Mega-X": {
        "hp": 78,
        "atk": 130,
        "def": 111,
        "spa": 130,
        "spd": 85,
        "spe": 100
    },
    "Charizard-Mega-Y": {
        "hp": 78,
        "atk": 104,
        "def": 78,
        "spa": 159,
        "spd": 115,
        "spe": 100
    },
    "Charizard-Gmax": {
        "hp": 78,
        "atk": 84,
        "def": 78,
        "spa": 109,
        "spd": 85,
        "spe": 100
    },
    "Squirtle": {
        "hp": 44,
        "atk": 48,
        "def": 65,
        "spa": 50,
        "spd": 64,
        "spe": 43
    },
    "Wartortle": {
        "hp": 59,
        "atk": 63,
        "def": 80,
        "spa": 65,
        "spd": 80,
        "spe": 58
    },
    "Blastoise": {
        "hp": 79,
        "atk": 83,
        "def": 100,
        "spa": 85,
        "spd": 105,
        "spe": 78
    },
    "Blastoise-Mega": {
        "hp": 79,
        "atk": 103,
        "def": 120,
        "spa": 135,
        "spd": 115,
        "spe": 78
    },
    "Blastoise-Gmax": {
        "hp": 79,
        "atk": 83,
        "def": 100,
        "spa": 85,
        "spd": 105,
        "spe": 78
    },
    "Caterpie": {
        "hp": 45,
        "atk": 30,
        "def": 35,
        "spa": 20,
        "spd": 20,
        "spe": 45
    },
    "Metapod": {
        "hp": 50,
        "atk": 20,
        "def": 55,
        "spa": 25,
        "spd": 25,
        "spe": 30
    },
    "Butterfree": {
        "hp": 60,
        "atk": 45,
        "def": 50,
        "spa": 90,
        "spd": 80,
        "spe": 70
    },
    "Butterfree-Gmax": {
        "hp": 60,
        "atk": 45,
        "def": 50,
        "spa": 90,
        "spd": 80,
        "spe": 70
    },
    "Weedle": {
        "hp": 40,
        "atk": 35,
        "def": 30,
        "spa": 20,
        "spd": 20,
        "spe": 50
    },
    "Kakuna": {
        "hp": 45,
        "atk": 25,
        "def": 50,
        "spa": 25,
        "spd": 25,
        "spe": 35
    },
    "Beedrill": {
        "hp": 65,
        "atk": 90,
        "def": 40,
        "spa": 45,
        "spd": 80,
        "spe": 75
    },
    "Beedrill-Mega": {
        "hp": 65,
        "atk": 150,
        "def": 40,
        "spa": 15,
        "spd": 80,
        "spe": 145
    },
    "Pidgey": {
        "hp": 40,
        "atk": 45,
        "def": 40,
        "spa": 35,
        "spd": 35,
        "spe": 56
    },
    "Pidgeotto": {
        "hp": 63,
        "atk": 60,
        "def": 55,
        "spa": 50,
        "spd": 50,
        "spe": 71
    },
    "Pidgeot": {
        "hp": 83,
        "atk": 80,
        "def": 75,
        "spa": 70,
        "spd": 70,
        "spe": 101
    },
    "Pidgeot-Mega": {
        "hp": 83,
        "atk": 80,
        "def": 80,
        "spa": 135,
        "spd": 80,
        "spe": 121
    },
    "Rattata": {
        "hp": 30,
        "atk": 56,
        "def": 35,
        "spa": 25,
        "spd": 35,
        "spe": 72
    },
    "Rattata-Alola": {
        "hp": 30,
        "atk": 56,
        "def": 35,
        "spa": 25,
        "spd": 35,
        "spe": 72
    },
    "Raticate": {
        "hp": 55,
        "atk": 81,
        "def": 60,
        "spa": 50,
        "spd": 70,
        "spe": 97
    },
    "Raticate-Alola": {
        "hp": 75,
        "atk": 71,
        "def": 70,
        "spa": 40,
        "spd": 80,
        "spe": 77
    },
    "Raticate-Alola-Totem": {
        "hp": 75,
        "atk": 71,
        "def": 70,
        "spa": 40,
        "spd": 80,
        "spe": 77
    },
    "Spearow": {
        "hp": 40,
        "atk": 60,
        "def": 30,
        "spa": 31,
        "spd": 31,
        "spe": 70
    },
    "Fearow": {
        "hp": 65,
        "atk": 90,
        "def": 65,
        "spa": 61,
        "spd": 61,
        "spe": 100
    },
    "Ekans": {
        "hp": 35,
        "atk": 60,
        "def": 44,
        "spa": 40,
        "spd": 54,
        "spe": 55
    },
    "Arbok": {
        "hp": 60,
        "atk": 95,
        "def": 69,
        "spa": 65,
        "spd": 79,
        "spe": 80
    },
    "Pikachu": {
        "hp": 35,
        "atk": 55,
        "def": 40,
        "spa": 50,
        "spd": 50,
        "spe": 90
    },
    "Pikachu-Cosplay": {
        "hp": 35,
        "atk": 55,
        "def": 40,
        "spa": 50,
        "spd": 50,
        "spe": 90
    },
    "Pikachu-Rock-Star": {
        "hp": 35,
        "atk": 55,
        "def": 40,
        "spa": 50,
        "spd": 50,
        "spe": 90
    },
    "Pikachu-Belle": {
        "hp": 35,
        "atk": 55,
        "def": 40,
        "spa": 50,
        "spd": 50,
        "spe": 90
    },
    "Pikachu-Pop-Star": {
        "hp": 35,
        "atk": 55,
        "def": 40,
        "spa": 50,
        "spd": 50,
        "spe": 90
    },
    "Pikachu-PhD": {
        "hp": 35,
        "atk": 55,
        "def": 40,
        "spa": 50,
        "spd": 50,
        "spe": 90
    },
    "Pikachu-Libre": {
        "hp": 35,
        "atk": 55,
        "def": 40,
        "spa": 50,
        "spd": 50,
        "spe": 90
    },
    "Pikachu-Original": {
        "hp": 35,
        "atk": 55,
        "def": 40,
        "spa": 50,
        "spd": 50,
        "spe": 90
    },
    "Pikachu-Hoenn": {
        "hp": 35,
        "atk": 55,
        "def": 40,
        "spa": 50,
        "spd": 50,
        "spe": 90
    },
    "Pikachu-Sinnoh": {
        "hp": 35,
        "atk": 55,
        "def": 40,
        "spa": 50,
        "spd": 50,
        "spe": 90
    },
    "Pikachu-Unova": {
        "hp": 35,
        "atk": 55,
        "def": 40,
        "spa": 50,
        "spd": 50,
        "spe": 90
    },
    "Pikachu-Kalos": {
        "hp": 35,
        "atk": 55,
        "def": 40,
        "spa": 50,
        "spd": 50,
        "spe": 90
    },
    "Pikachu-Alola": {
        "hp": 35,
        "atk": 55,
        "def": 40,
        "spa": 50,
        "spd": 50,
        "spe": 90
    },
    "Pikachu-Partner": {
        "hp": 35,
        "atk": 55,
        "def": 40,
        "spa": 50,
        "spd": 50,
        "spe": 90
    },
    "Pikachu-Starter": {
        "hp": 45,
        "atk": 80,
        "def": 50,
        "spa": 75,
        "spd": 60,
        "spe": 120
    },
    "Pikachu-Gmax": {
        "hp": 35,
        "atk": 55,
        "def": 40,
        "spa": 50,
        "spd": 50,
        "spe": 90
    },
    "Pikachu-World": {
        "hp": 35,
        "atk": 55,
        "def": 40,
        "spa": 50,
        "spd": 50,
        "spe": 90
    },
    "Raichu": {
        "hp": 60,
        "atk": 90,
        "def": 55,
        "spa": 90,
        "spd": 80,
        "spe": 110
    },
    "Raichu-Alola": {
        "hp": 60,
        "atk": 85,
        "def": 50,
        "spa": 95,
        "spd": 85,
        "spe": 110
    },
    "Sandshrew": {
        "hp": 50,
        "atk": 75,
        "def": 85,
        "spa": 20,
        "spd": 30,
        "spe": 40
    },
    "Sandshrew-Alola": {
        "hp": 50,
        "atk": 75,
        "def": 90,
        "spa": 10,
        "spd": 35,
        "spe": 40
    },
    "Sandslash": {
        "hp": 75,
        "atk": 100,
        "def": 110,
        "spa": 45,
        "spd": 55,
        "spe": 65
    },
    "Sandslash-Alola": {
        "hp": 75,
        "atk": 100,
        "def": 120,
        "spa": 25,
        "spd": 65,
        "spe": 65
    },
    "Nidoran-F": {
        "hp": 55,
        "atk": 47,
        "def": 52,
        "spa": 40,
        "spd": 40,
        "spe": 41
    },
    "Nidorina": {
        "hp": 70,
        "atk": 62,
        "def": 67,
        "spa": 55,
        "spd": 55,
        "spe": 56
    },
    "Nidoqueen": {
        "hp": 90,
        "atk": 92,
        "def": 87,
        "spa": 75,
        "spd": 85,
        "spe": 76
    },
    "Nidoran-M": {
        "hp": 46,
        "atk": 57,
        "def": 40,
        "spa": 40,
        "spd": 40,
        "spe": 50
    },
    "Nidorino": {
        "hp": 61,
        "atk": 72,
        "def": 57,
        "spa": 55,
        "spd": 55,
        "spe": 65
    },
    "Nidoking": {
        "hp": 81,
        "atk": 102,
        "def": 77,
        "spa": 85,
        "spd": 75,
        "spe": 85
    },
    "Clefairy": {
        "hp": 70,
        "atk": 45,
        "def": 48,
        "spa": 60,
        "spd": 65,
        "spe": 35
    },
    "Clefable": {
        "hp": 95,
        "atk": 70,
        "def": 73,
        "spa": 95,
        "spd": 90,
        "spe": 60
    },
    "Vulpix": {
        "hp": 38,
        "atk": 41,
        "def": 40,
        "spa": 50,
        "spd": 65,
        "spe": 65
    },
    "Vulpix-Alola": {
        "hp": 38,
        "atk": 41,
        "def": 40,
        "spa": 50,
        "spd": 65,
        "spe": 65
    },
    "Ninetales": {
        "hp": 73,
        "atk": 76,
        "def": 75,
        "spa": 81,
        "spd": 100,
        "spe": 100
    },
    "Ninetales-Alola": {
        "hp": 73,
        "atk": 67,
        "def": 75,
        "spa": 81,
        "spd": 100,
        "spe": 109
    },
    "Jigglypuff": {
        "hp": 115,
        "atk": 45,
        "def": 20,
        "spa": 45,
        "spd": 25,
        "spe": 20
    },
    "Wigglytuff": {
        "hp": 140,
        "atk": 70,
        "def": 45,
        "spa": 85,
        "spd": 50,
        "spe": 45
    },
    "Zubat": {
        "hp": 40,
        "atk": 45,
        "def": 35,
        "spa": 30,
        "spd": 40,
        "spe": 55
    },
    "Golbat": {
        "hp": 75,
        "atk": 80,
        "def": 70,
        "spa": 65,
        "spd": 75,
        "spe": 90
    },
    "Oddish": {
        "hp": 45,
        "atk": 50,
        "def": 55,
        "spa": 75,
        "spd": 65,
        "spe": 30
    },
    "Gloom": {
        "hp": 60,
        "atk": 65,
        "def": 70,
        "spa": 85,
        "spd": 75,
        "spe": 40
    },
    "Vileplume": {
        "hp": 75,
        "atk": 80,
        "def": 85,
        "spa": 110,
        "spd": 90,
        "spe": 50
    },
    "Paras": {
        "hp": 35,
        "atk": 70,
        "def": 55,
        "spa": 45,
        "spd": 55,
        "spe": 25
    },
    "Parasect": {
        "hp": 60,
        "atk": 95,
        "def": 80,
        "spa": 60,
        "spd": 80,
        "spe": 30
    },
    "Venonat": {
        "hp": 60,
        "atk": 55,
        "def": 50,
        "spa": 40,
        "spd": 55,
        "spe": 45
    },
    "Venomoth": {
        "hp": 70,
        "atk": 65,
        "def": 60,
        "spa": 90,
        "spd": 75,
        "spe": 90
    },
    "Diglett": {
        "hp": 10,
        "atk": 55,
        "def": 25,
        "spa": 35,
        "spd": 45,
        "spe": 95
    },
    "Diglett-Alola": {
        "hp": 10,
        "atk": 55,
        "def": 30,
        "spa": 35,
        "spd": 45,
        "spe": 90
    },
    "Dugtrio": {
        "hp": 35,
        "atk": 100,
        "def": 50,
        "spa": 50,
        "spd": 70,
        "spe": 120
    },
    "Dugtrio-Alola": {
        "hp": 35,
        "atk": 100,
        "def": 60,
        "spa": 50,
        "spd": 70,
        "spe": 110
    },
    "Meowth": {
        "hp": 40,
        "atk": 45,
        "def": 35,
        "spa": 40,
        "spd": 40,
        "spe": 90
    },
    "Meowth-Alola": {
        "hp": 40,
        "atk": 35,
        "def": 35,
        "spa": 50,
        "spd": 40,
        "spe": 90
    },
    "Meowth-Galar": {
        "hp": 50,
        "atk": 65,
        "def": 55,
        "spa": 40,
        "spd": 40,
        "spe": 40
    },
    "Meowth-Gmax": {
        "hp": 40,
        "atk": 45,
        "def": 35,
        "spa": 40,
        "spd": 40,
        "spe": 90
    },
    "Persian": {
        "hp": 65,
        "atk": 70,
        "def": 60,
        "spa": 65,
        "spd": 65,
        "spe": 115
    },
    "Persian-Alola": {
        "hp": 65,
        "atk": 60,
        "def": 60,
        "spa": 75,
        "spd": 65,
        "spe": 115
    },
    "Psyduck": {
        "hp": 50,
        "atk": 52,
        "def": 48,
        "spa": 65,
        "spd": 50,
        "spe": 55
    },
    "Golduck": {
        "hp": 80,
        "atk": 82,
        "def": 78,
        "spa": 95,
        "spd": 80,
        "spe": 85
    },
    "Mankey": {
        "hp": 40,
        "atk": 80,
        "def": 35,
        "spa": 35,
        "spd": 45,
        "spe": 70
    },
    "Primeape": {
        "hp": 65,
        "atk": 105,
        "def": 60,
        "spa": 60,
        "spd": 70,
        "spe": 95
    },
    "Growlithe": {
        "hp": 55,
        "atk": 70,
        "def": 45,
        "spa": 70,
        "spd": 50,
        "spe": 60
    },
    "Growlithe-Hisui": {
        "hp": 60,
        "atk": 75,
        "def": 45,
        "spa": 65,
        "spd": 50,
        "spe": 55
    },
    "Arcanine": {
        "hp": 90,
        "atk": 110,
        "def": 80,
        "spa": 100,
        "spd": 80,
        "spe": 95
    },
    "Arcanine-Hisui": {
        "hp": 95,
        "atk": 115,
        "def": 80,
        "spa": 95,
        "spd": 80,
        "spe": 90
    },
    "Poliwag": {
        "hp": 40,
        "atk": 50,
        "def": 40,
        "spa": 40,
        "spd": 40,
        "spe": 90
    },
    "Poliwhirl": {
        "hp": 65,
        "atk": 65,
        "def": 65,
        "spa": 50,
        "spd": 50,
        "spe": 90
    },
    "Poliwrath": {
        "hp": 90,
        "atk": 95,
        "def": 95,
        "spa": 70,
        "spd": 90,
        "spe": 70
    },
    "Abra": {
        "hp": 25,
        "atk": 20,
        "def": 15,
        "spa": 105,
        "spd": 55,
        "spe": 90
    },
    "Kadabra": {
        "hp": 40,
        "atk": 35,
        "def": 30,
        "spa": 120,
        "spd": 70,
        "spe": 105
    },
    "Alakazam": {
        "hp": 55,
        "atk": 50,
        "def": 45,
        "spa": 135,
        "spd": 95,
        "spe": 120
    },
    "Alakazam-Mega": {
        "hp": 55,
        "atk": 50,
        "def": 65,
        "spa": 175,
        "spd": 105,
        "spe": 150
    },
    "Machop": {
        "hp": 70,
        "atk": 80,
        "def": 50,
        "spa": 35,
        "spd": 35,
        "spe": 35
    },
    "Machoke": {
        "hp": 80,
        "atk": 100,
        "def": 70,
        "spa": 50,
        "spd": 60,
        "spe": 45
    },
    "Machamp": {
        "hp": 90,
        "atk": 130,
        "def": 80,
        "spa": 65,
        "spd": 85,
        "spe": 55
    },
    "Machamp-Gmax": {
        "hp": 90,
        "atk": 130,
        "def": 80,
        "spa": 65,
        "spd": 85,
        "spe": 55
    },
    "Bellsprout": {
        "hp": 50,
        "atk": 75,
        "def": 35,
        "spa": 70,
        "spd": 30,
        "spe": 40
    },
    "Weepinbell": {
        "hp": 65,
        "atk": 90,
        "def": 50,
        "spa": 85,
        "spd": 45,
        "spe": 55
    },
    "Victreebel": {
        "hp": 80,
        "atk": 105,
        "def": 65,
        "spa": 100,
        "spd": 70,
        "spe": 70
    },
    "Tentacool": {
        "hp": 40,
        "atk": 40,
        "def": 35,
        "spa": 50,
        "spd": 100,
        "spe": 70
    },
    "Tentacruel": {
        "hp": 80,
        "atk": 70,
        "def": 65,
        "spa": 80,
        "spd": 120,
        "spe": 100
    },
    "Geodude": {
        "hp": 40,
        "atk": 80,
        "def": 100,
        "spa": 30,
        "spd": 30,
        "spe": 20
    },
    "Geodude-Alola": {
        "hp": 40,
        "atk": 80,
        "def": 100,
        "spa": 30,
        "spd": 30,
        "spe": 20
    },
    "Graveler": {
        "hp": 55,
        "atk": 95,
        "def": 115,
        "spa": 45,
        "spd": 45,
        "spe": 35
    },
    "Graveler-Alola": {
        "hp": 55,
        "atk": 95,
        "def": 115,
        "spa": 45,
        "spd": 45,
        "spe": 35
    },
    "Golem": {
        "hp": 80,
        "atk": 120,
        "def": 130,
        "spa": 55,
        "spd": 65,
        "spe": 45
    },
    "Golem-Alola": {
        "hp": 80,
        "atk": 120,
        "def": 130,
        "spa": 55,
        "spd": 65,
        "spe": 45
    },
    "Ponyta": {
        "hp": 50,
        "atk": 85,
        "def": 55,
        "spa": 65,
        "spd": 65,
        "spe": 90
    },
    "Ponyta-Galar": {
        "hp": 50,
        "atk": 85,
        "def": 55,
        "spa": 65,
        "spd": 65,
        "spe": 90
    },
    "Rapidash": {
        "hp": 65,
        "atk": 100,
        "def": 70,
        "spa": 80,
        "spd": 80,
        "spe": 105
    },
    "Rapidash-Galar": {
        "hp": 65,
        "atk": 100,
        "def": 70,
        "spa": 80,
        "spd": 80,
        "spe": 105
    },
    "Slowpoke": {
        "hp": 90,
        "atk": 65,
        "def": 65,
        "spa": 40,
        "spd": 40,
        "spe": 15
    },
    "Slowpoke-Galar": {
        "hp": 90,
        "atk": 65,
        "def": 65,
        "spa": 40,
        "spd": 40,
        "spe": 15
    },
    "Slowbro": {
        "hp": 95,
        "atk": 75,
        "def": 110,
        "spa": 100,
        "spd": 80,
        "spe": 30
    },
    "Slowbro-Mega": {
        "hp": 95,
        "atk": 75,
        "def": 180,
        "spa": 130,
        "spd": 80,
        "spe": 30
    },
    "Slowbro-Galar": {
        "hp": 95,
        "atk": 100,
        "def": 95,
        "spa": 100,
        "spd": 70,
        "spe": 30
    },
    "Magnemite": {
        "hp": 25,
        "atk": 35,
        "def": 70,
        "spa": 95,
        "spd": 55,
        "spe": 45
    },
    "Magneton": {
        "hp": 50,
        "atk": 60,
        "def": 95,
        "spa": 120,
        "spd": 70,
        "spe": 70
    },
    "Farfetch\u2019d": {
        "hp": 52,
        "atk": 90,
        "def": 55,
        "spa": 58,
        "spd": 62,
        "spe": 60
    },
    "Farfetch\u2019d-Galar": {
        "hp": 52,
        "atk": 95,
        "def": 55,
        "spa": 58,
        "spd": 62,
        "spe": 55
    },
    "Doduo": {
        "hp": 35,
        "atk": 85,
        "def": 45,
        "spa": 35,
        "spd": 35,
        "spe": 75
    },
    "Dodrio": {
        "hp": 60,
        "atk": 110,
        "def": 70,
        "spa": 60,
        "spd": 60,
        "spe": 110
    },
    "Seel": {
        "hp": 65,
        "atk": 45,
        "def": 55,
        "spa": 45,
        "spd": 70,
        "spe": 45
    },
    "Dewgong": {
        "hp": 90,
        "atk": 70,
        "def": 80,
        "spa": 70,
        "spd": 95,
        "spe": 70
    },
    "Grimer": {
        "hp": 80,
        "atk": 80,
        "def": 50,
        "spa": 40,
        "spd": 50,
        "spe": 25
    },
    "Grimer-Alola": {
        "hp": 80,
        "atk": 80,
        "def": 50,
        "spa": 40,
        "spd": 50,
        "spe": 25
    },
    "Muk": {
        "hp": 105,
        "atk": 105,
        "def": 75,
        "spa": 65,
        "spd": 100,
        "spe": 50
    },
    "Muk-Alola": {
        "hp": 105,
        "atk": 105,
        "def": 75,
        "spa": 65,
        "spd": 100,
        "spe": 50
    },
    "Shellder": {
        "hp": 30,
        "atk": 65,
        "def": 100,
        "spa": 45,
        "spd": 25,
        "spe": 40
    },
    "Cloyster": {
        "hp": 50,
        "atk": 95,
        "def": 180,
        "spa": 85,
        "spd": 45,
        "spe": 70
    },
    "Gastly": {
        "hp": 30,
        "atk": 35,
        "def": 30,
        "spa": 100,
        "spd": 35,
        "spe": 80
    },
    "Haunter": {
        "hp": 45,
        "atk": 50,
        "def": 45,
        "spa": 115,
        "spd": 55,
        "spe": 95
    },
    "Gengar": {
        "hp": 60,
        "atk": 65,
        "def": 60,
        "spa": 130,
        "spd": 75,
        "spe": 110
    },
    "Gengar-Mega": {
        "hp": 60,
        "atk": 65,
        "def": 80,
        "spa": 170,
        "spd": 95,
        "spe": 130
    },
    "Gengar-Gmax": {
        "hp": 60,
        "atk": 65,
        "def": 60,
        "spa": 130,
        "spd": 75,
        "spe": 110
    },
    "Onix": {
        "hp": 35,
        "atk": 45,
        "def": 160,
        "spa": 30,
        "spd": 45,
        "spe": 70
    },
    "Drowzee": {
        "hp": 60,
        "atk": 48,
        "def": 45,
        "spa": 43,
        "spd": 90,
        "spe": 42
    },
    "Hypno": {
        "hp": 85,
        "atk": 73,
        "def": 70,
        "spa": 73,
        "spd": 115,
        "spe": 67
    },
    "Krabby": {
        "hp": 30,
        "atk": 105,
        "def": 90,
        "spa": 25,
        "spd": 25,
        "spe": 50
    },
    "Kingler": {
        "hp": 55,
        "atk": 130,
        "def": 115,
        "spa": 50,
        "spd": 50,
        "spe": 75
    },
    "Kingler-Gmax": {
        "hp": 55,
        "atk": 130,
        "def": 115,
        "spa": 50,
        "spd": 50,
        "spe": 75
    },
    "Voltorb": {
        "hp": 40,
        "atk": 30,
        "def": 50,
        "spa": 55,
        "spd": 55,
        "spe": 100
    },
    "Voltorb-Hisui": {
        "hp": 40,
        "atk": 30,
        "def": 50,
        "spa": 55,
        "spd": 55,
        "spe": 100
    },
    "Electrode": {
        "hp": 60,
        "atk": 50,
        "def": 70,
        "spa": 80,
        "spd": 80,
        "spe": 150
    },
    "Electrode-Hisui": {
        "hp": 60,
        "atk": 50,
        "def": 70,
        "spa": 80,
        "spd": 80,
        "spe": 150
    },
    "Exeggcute": {
        "hp": 60,
        "atk": 40,
        "def": 80,
        "spa": 60,
        "spd": 45,
        "spe": 40
    },
    "Exeggutor": {
        "hp": 95,
        "atk": 95,
        "def": 85,
        "spa": 125,
        "spd": 75,
        "spe": 55
    },
    "Exeggutor-Alola": {
        "hp": 95,
        "atk": 105,
        "def": 85,
        "spa": 125,
        "spd": 75,
        "spe": 45
    },
    "Cubone": {
        "hp": 50,
        "atk": 50,
        "def": 95,
        "spa": 40,
        "spd": 50,
        "spe": 35
    },
    "Marowak": {
        "hp": 60,
        "atk": 80,
        "def": 110,
        "spa": 50,
        "spd": 80,
        "spe": 45
    },
    "Marowak-Alola": {
        "hp": 60,
        "atk": 80,
        "def": 110,
        "spa": 50,
        "spd": 80,
        "spe": 45
    },
    "Marowak-Alola-Totem": {
        "hp": 60,
        "atk": 80,
        "def": 110,
        "spa": 50,
        "spd": 80,
        "spe": 45
    },
    "Hitmonlee": {
        "hp": 50,
        "atk": 120,
        "def": 53,
        "spa": 35,
        "spd": 110,
        "spe": 87
    },
    "Hitmonchan": {
        "hp": 50,
        "atk": 105,
        "def": 79,
        "spa": 35,
        "spd": 110,
        "spe": 76
    },
    "Lickitung": {
        "hp": 90,
        "atk": 55,
        "def": 75,
        "spa": 60,
        "spd": 75,
        "spe": 30
    },
    "Koffing": {
        "hp": 40,
        "atk": 65,
        "def": 95,
        "spa": 60,
        "spd": 45,
        "spe": 35
    },
    "Weezing": {
        "hp": 65,
        "atk": 90,
        "def": 120,
        "spa": 85,
        "spd": 70,
        "spe": 60
    },
    "Weezing-Galar": {
        "hp": 65,
        "atk": 90,
        "def": 120,
        "spa": 85,
        "spd": 70,
        "spe": 60
    },
    "Rhyhorn": {
        "hp": 80,
        "atk": 85,
        "def": 95,
        "spa": 30,
        "spd": 30,
        "spe": 25
    },
    "Rhydon": {
        "hp": 105,
        "atk": 130,
        "def": 120,
        "spa": 45,
        "spd": 45,
        "spe": 40
    },
    "Chansey": {
        "hp": 250,
        "atk": 5,
        "def": 5,
        "spa": 35,
        "spd": 105,
        "spe": 50
    },
    "Tangela": {
        "hp": 65,
        "atk": 55,
        "def": 115,
        "spa": 100,
        "spd": 40,
        "spe": 60
    },
    "Kangaskhan": {
        "hp": 105,
        "atk": 95,
        "def": 80,
        "spa": 40,
        "spd": 80,
        "spe": 90
    },
    "Kangaskhan-Mega": {
        "hp": 105,
        "atk": 125,
        "def": 100,
        "spa": 60,
        "spd": 100,
        "spe": 100
    },
    "Horsea": {
        "hp": 30,
        "atk": 40,
        "def": 70,
        "spa": 70,
        "spd": 25,
        "spe": 60
    },
    "Seadra": {
        "hp": 55,
        "atk": 65,
        "def": 95,
        "spa": 95,
        "spd": 45,
        "spe": 85
    },
    "Goldeen": {
        "hp": 45,
        "atk": 67,
        "def": 60,
        "spa": 35,
        "spd": 50,
        "spe": 63
    },
    "Seaking": {
        "hp": 80,
        "atk": 92,
        "def": 65,
        "spa": 65,
        "spd": 80,
        "spe": 68
    },
    "Staryu": {
        "hp": 30,
        "atk": 45,
        "def": 55,
        "spa": 70,
        "spd": 55,
        "spe": 85
    },
    "Starmie": {
        "hp": 60,
        "atk": 75,
        "def": 85,
        "spa": 100,
        "spd": 85,
        "spe": 115
    },
    "Mr. Mime": {
        "hp": 40,
        "atk": 45,
        "def": 65,
        "spa": 100,
        "spd": 120,
        "spe": 90
    },
    "Mr. Mime-Galar": {
        "hp": 50,
        "atk": 65,
        "def": 65,
        "spa": 90,
        "spd": 90,
        "spe": 100
    },
    "Scyther": {
        "hp": 70,
        "atk": 110,
        "def": 80,
        "spa": 55,
        "spd": 80,
        "spe": 105
    },
    "Jynx": {
        "hp": 65,
        "atk": 50,
        "def": 35,
        "spa": 115,
        "spd": 95,
        "spe": 95
    },
    "Electabuzz": {
        "hp": 65,
        "atk": 83,
        "def": 57,
        "spa": 95,
        "spd": 85,
        "spe": 105
    },
    "Magmar": {
        "hp": 65,
        "atk": 95,
        "def": 57,
        "spa": 100,
        "spd": 85,
        "spe": 93
    },
    "Pinsir": {
        "hp": 65,
        "atk": 125,
        "def": 100,
        "spa": 55,
        "spd": 70,
        "spe": 85
    },
    "Pinsir-Mega": {
        "hp": 65,
        "atk": 155,
        "def": 120,
        "spa": 65,
        "spd": 90,
        "spe": 105
    },
    "Tauros": {
        "hp": 75,
        "atk": 100,
        "def": 95,
        "spa": 40,
        "spd": 70,
        "spe": 110
    },
    "Tauros-Paldea-Combat": {
        "hp": 75,
        "atk": 110,
        "def": 105,
        "spa": 30,
        "spd": 70,
        "spe": 100
    },
    "Tauros-Paldea-Blaze": {
        "hp": 75,
        "atk": 110,
        "def": 105,
        "spa": 30,
        "spd": 70,
        "spe": 100
    },
    "Tauros-Paldea-Aqua": {
        "hp": 75,
        "atk": 110,
        "def": 105,
        "spa": 30,
        "spd": 70,
        "spe": 100
    },
    "Magikarp": {
        "hp": 20,
        "atk": 10,
        "def": 55,
        "spa": 15,
        "spd": 20,
        "spe": 80
    },
    "Gyarados": {
        "hp": 95,
        "atk": 125,
        "def": 79,
        "spa": 60,
        "spd": 100,
        "spe": 81
    },
    "Gyarados-Mega": {
        "hp": 95,
        "atk": 155,
        "def": 109,
        "spa": 70,
        "spd": 130,
        "spe": 81
    },
    "Lapras": {
        "hp": 130,
        "atk": 85,
        "def": 80,
        "spa": 85,
        "spd": 95,
        "spe": 60
    },
    "Lapras-Gmax": {
        "hp": 130,
        "atk": 85,
        "def": 80,
        "spa": 85,
        "spd": 95,
        "spe": 60
    },
    "Ditto": {
        "hp": 48,
        "atk": 48,
        "def": 48,
        "spa": 48,
        "spd": 48,
        "spe": 48
    },
    "Eevee": {
        "hp": 55,
        "atk": 55,
        "def": 50,
        "spa": 45,
        "spd": 65,
        "spe": 55
    },
    "Eevee-Starter": {
        "hp": 65,
        "atk": 75,
        "def": 70,
        "spa": 65,
        "spd": 85,
        "spe": 75
    },
    "Eevee-Gmax": {
        "hp": 55,
        "atk": 55,
        "def": 50,
        "spa": 45,
        "spd": 65,
        "spe": 55
    },
    "Vaporeon": {
        "hp": 130,
        "atk": 65,
        "def": 60,
        "spa": 110,
        "spd": 95,
        "spe": 65
    },
    "Jolteon": {
        "hp": 65,
        "atk": 65,
        "def": 60,
        "spa": 110,
        "spd": 95,
        "spe": 130
    },
    "Flareon": {
        "hp": 65,
        "atk": 130,
        "def": 60,
        "spa": 95,
        "spd": 110,
        "spe": 65
    },
    "Porygon": {
        "hp": 65,
        "atk": 60,
        "def": 70,
        "spa": 85,
        "spd": 75,
        "spe": 40
    },
    "Omanyte": {
        "hp": 35,
        "atk": 40,
        "def": 100,
        "spa": 90,
        "spd": 55,
        "spe": 35
    },
    "Omastar": {
        "hp": 70,
        "atk": 60,
        "def": 125,
        "spa": 115,
        "spd": 70,
        "spe": 55
    },
    "Kabuto": {
        "hp": 30,
        "atk": 80,
        "def": 90,
        "spa": 55,
        "spd": 45,
        "spe": 55
    },
    "Kabutops": {
        "hp": 60,
        "atk": 115,
        "def": 105,
        "spa": 65,
        "spd": 70,
        "spe": 80
    },
    "Aerodactyl": {
        "hp": 80,
        "atk": 105,
        "def": 65,
        "spa": 60,
        "spd": 75,
        "spe": 130
    },
    "Aerodactyl-Mega": {
        "hp": 80,
        "atk": 135,
        "def": 85,
        "spa": 70,
        "spd": 95,
        "spe": 150
    },
    "Snorlax": {
        "hp": 160,
        "atk": 110,
        "def": 65,
        "spa": 65,
        "spd": 110,
        "spe": 30
    },
    "Snorlax-Gmax": {
        "hp": 160,
        "atk": 110,
        "def": 65,
        "spa": 65,
        "spd": 110,
        "spe": 30
    },
    "Articuno": {
        "hp": 90,
        "atk": 85,
        "def": 100,
        "spa": 95,
        "spd": 125,
        "spe": 85
    },
    "Articuno-Galar": {
        "hp": 90,
        "atk": 85,
        "def": 85,
        "spa": 125,
        "spd": 100,
        "spe": 95
    },
    "Zapdos": {
        "hp": 90,
        "atk": 90,
        "def": 85,
        "spa": 125,
        "spd": 90,
        "spe": 100
    },
    "Zapdos-Galar": {
        "hp": 90,
        "atk": 125,
        "def": 90,
        "spa": 85,
        "spd": 90,
        "spe": 100
    },
    "Moltres": {
        "hp": 90,
        "atk": 100,
        "def": 90,
        "spa": 125,
        "spd": 85,
        "spe": 90
    },
    "Moltres-Galar": {
        "hp": 90,
        "atk": 85,
        "def": 90,
        "spa": 100,
        "spd": 125,
        "spe": 90
    },
    "Dratini": {
        "hp": 41,
        "atk": 64,
        "def": 45,
        "spa": 50,
        "spd": 50,
        "spe": 50
    },
    "Dragonair": {
        "hp": 61,
        "atk": 84,
        "def": 65,
        "spa": 70,
        "spd": 70,
        "spe": 70
    },
    "Dragonite": {
        "hp": 91,
        "atk": 134,
        "def": 95,
        "spa": 100,
        "spd": 100,
        "spe": 80
    },
    "Mewtwo": {
        "hp": 106,
        "atk": 110,
        "def": 90,
        "spa": 154,
        "spd": 90,
        "spe": 130
    },
    "Mewtwo-Mega-X": {
        "hp": 106,
        "atk": 190,
        "def": 100,
        "spa": 154,
        "spd": 100,
        "spe": 130
    },
    "Mewtwo-Mega-Y": {
        "hp": 106,
        "atk": 150,
        "def": 70,
        "spa": 194,
        "spd": 120,
        "spe": 140
    },
    "Mew": {
        "hp": 100,
        "atk": 100,
        "def": 100,
        "spa": 100,
        "spd": 100,
        "spe": 100
    },
    "Chikorita": {
        "hp": 45,
        "atk": 49,
        "def": 65,
        "spa": 49,
        "spd": 65,
        "spe": 45
    },
    "Bayleef": {
        "hp": 60,
        "atk": 62,
        "def": 80,
        "spa": 63,
        "spd": 80,
        "spe": 60
    },
    "Meganium": {
        "hp": 80,
        "atk": 82,
        "def": 100,
        "spa": 83,
        "spd": 100,
        "spe": 80
    },
    "Cyndaquil": {
        "hp": 39,
        "atk": 52,
        "def": 43,
        "spa": 60,
        "spd": 50,
        "spe": 65
    },
    "Quilava": {
        "hp": 58,
        "atk": 64,
        "def": 58,
        "spa": 80,
        "spd": 65,
        "spe": 80
    },
    "Typhlosion": {
        "hp": 78,
        "atk": 84,
        "def": 78,
        "spa": 109,
        "spd": 85,
        "spe": 100
    },
    "Typhlosion-Hisui": {
        "hp": 73,
        "atk": 84,
        "def": 78,
        "spa": 119,
        "spd": 85,
        "spe": 95
    },
    "Totodile": {
        "hp": 50,
        "atk": 65,
        "def": 64,
        "spa": 44,
        "spd": 48,
        "spe": 43
    },
    "Croconaw": {
        "hp": 65,
        "atk": 80,
        "def": 80,
        "spa": 59,
        "spd": 63,
        "spe": 58
    },
    "Feraligatr": {
        "hp": 85,
        "atk": 105,
        "def": 100,
        "spa": 79,
        "spd": 83,
        "spe": 78
    },
    "Sentret": {
        "hp": 35,
        "atk": 46,
        "def": 34,
        "spa": 35,
        "spd": 45,
        "spe": 20
    },
    "Furret": {
        "hp": 85,
        "atk": 76,
        "def": 64,
        "spa": 45,
        "spd": 55,
        "spe": 90
    },
    "Hoothoot": {
        "hp": 60,
        "atk": 30,
        "def": 30,
        "spa": 36,
        "spd": 56,
        "spe": 50
    },
    "Noctowl": {
        "hp": 100,
        "atk": 50,
        "def": 50,
        "spa": 86,
        "spd": 96,
        "spe": 70
    },
    "Ledyba": {
        "hp": 40,
        "atk": 20,
        "def": 30,
        "spa": 40,
        "spd": 80,
        "spe": 55
    },
    "Ledian": {
        "hp": 55,
        "atk": 35,
        "def": 50,
        "spa": 55,
        "spd": 110,
        "spe": 85
    },
    "Spinarak": {
        "hp": 40,
        "atk": 60,
        "def": 40,
        "spa": 40,
        "spd": 40,
        "spe": 30
    },
    "Ariados": {
        "hp": 70,
        "atk": 90,
        "def": 70,
        "spa": 60,
        "spd": 70,
        "spe": 40
    },
    "Crobat": {
        "hp": 85,
        "atk": 90,
        "def": 80,
        "spa": 70,
        "spd": 80,
        "spe": 130
    },
    "Chinchou": {
        "hp": 75,
        "atk": 38,
        "def": 38,
        "spa": 56,
        "spd": 56,
        "spe": 67
    },
    "Lanturn": {
        "hp": 125,
        "atk": 58,
        "def": 58,
        "spa": 76,
        "spd": 76,
        "spe": 67
    },
    "Pichu": {
        "hp": 20,
        "atk": 40,
        "def": 15,
        "spa": 35,
        "spd": 35,
        "spe": 60
    },
    "Pichu-Spiky-eared": {
        "hp": 20,
        "atk": 40,
        "def": 15,
        "spa": 35,
        "spd": 35,
        "spe": 60
    },
    "Cleffa": {
        "hp": 50,
        "atk": 25,
        "def": 28,
        "spa": 45,
        "spd": 55,
        "spe": 15
    },
    "Igglybuff": {
        "hp": 90,
        "atk": 30,
        "def": 15,
        "spa": 40,
        "spd": 20,
        "spe": 15
    },
    "Togepi": {
        "hp": 35,
        "atk": 20,
        "def": 65,
        "spa": 40,
        "spd": 65,
        "spe": 20
    },
    "Togetic": {
        "hp": 55,
        "atk": 40,
        "def": 85,
        "spa": 80,
        "spd": 105,
        "spe": 40
    },
    "Natu": {
        "hp": 40,
        "atk": 50,
        "def": 45,
        "spa": 70,
        "spd": 45,
        "spe": 70
    },
    "Xatu": {
        "hp": 65,
        "atk": 75,
        "def": 70,
        "spa": 95,
        "spd": 70,
        "spe": 95
    },
    "Mareep": {
        "hp": 55,
        "atk": 40,
        "def": 40,
        "spa": 65,
        "spd": 45,
        "spe": 35
    },
    "Flaaffy": {
        "hp": 70,
        "atk": 55,
        "def": 55,
        "spa": 80,
        "spd": 60,
        "spe": 45
    },
    "Ampharos": {
        "hp": 90,
        "atk": 75,
        "def": 85,
        "spa": 115,
        "spd": 90,
        "spe": 55
    },
    "Ampharos-Mega": {
        "hp": 90,
        "atk": 95,
        "def": 105,
        "spa": 165,
        "spd": 110,
        "spe": 45
    },
    "Bellossom": {
        "hp": 75,
        "atk": 80,
        "def": 95,
        "spa": 90,
        "spd": 100,
        "spe": 50
    },
    "Marill": {
        "hp": 70,
        "atk": 20,
        "def": 50,
        "spa": 20,
        "spd": 50,
        "spe": 40
    },
    "Azumarill": {
        "hp": 100,
        "atk": 50,
        "def": 80,
        "spa": 60,
        "spd": 80,
        "spe": 50
    },
    "Sudowoodo": {
        "hp": 70,
        "atk": 100,
        "def": 115,
        "spa": 30,
        "spd": 65,
        "spe": 30
    },
    "Politoed": {
        "hp": 90,
        "atk": 75,
        "def": 75,
        "spa": 90,
        "spd": 100,
        "spe": 70
    },
    "Hoppip": {
        "hp": 35,
        "atk": 35,
        "def": 40,
        "spa": 35,
        "spd": 55,
        "spe": 50
    },
    "Skiploom": {
        "hp": 55,
        "atk": 45,
        "def": 50,
        "spa": 45,
        "spd": 65,
        "spe": 80
    },
    "Jumpluff": {
        "hp": 75,
        "atk": 55,
        "def": 70,
        "spa": 55,
        "spd": 95,
        "spe": 110
    },
    "Aipom": {
        "hp": 55,
        "atk": 70,
        "def": 55,
        "spa": 40,
        "spd": 55,
        "spe": 85
    },
    "Sunkern": {
        "hp": 30,
        "atk": 30,
        "def": 30,
        "spa": 30,
        "spd": 30,
        "spe": 30
    },
    "Sunflora": {
        "hp": 75,
        "atk": 75,
        "def": 55,
        "spa": 105,
        "spd": 85,
        "spe": 30
    },
    "Yanma": {
        "hp": 65,
        "atk": 65,
        "def": 45,
        "spa": 75,
        "spd": 45,
        "spe": 95
    },
    "Wooper": {
        "hp": 55,
        "atk": 45,
        "def": 45,
        "spa": 25,
        "spd": 25,
        "spe": 15
    },
    "Wooper-Paldea": {
        "hp": 55,
        "atk": 45,
        "def": 45,
        "spa": 25,
        "spd": 25,
        "spe": 15
    },
    "Quagsire": {
        "hp": 95,
        "atk": 85,
        "def": 85,
        "spa": 65,
        "spd": 65,
        "spe": 35
    },
    "Espeon": {
        "hp": 65,
        "atk": 65,
        "def": 60,
        "spa": 130,
        "spd": 95,
        "spe": 110
    },
    "Umbreon": {
        "hp": 95,
        "atk": 65,
        "def": 110,
        "spa": 60,
        "spd": 130,
        "spe": 65
    },
    "Murkrow": {
        "hp": 60,
        "atk": 85,
        "def": 42,
        "spa": 85,
        "spd": 42,
        "spe": 91
    },
    "Slowking": {
        "hp": 95,
        "atk": 75,
        "def": 80,
        "spa": 100,
        "spd": 110,
        "spe": 30
    },
    "Slowking-Galar": {
        "hp": 95,
        "atk": 65,
        "def": 80,
        "spa": 110,
        "spd": 110,
        "spe": 30
    },
    "Misdreavus": {
        "hp": 60,
        "atk": 60,
        "def": 60,
        "spa": 85,
        "spd": 85,
        "spe": 85
    },
    "Unown": {
        "hp": 48,
        "atk": 72,
        "def": 48,
        "spa": 72,
        "spd": 48,
        "spe": 48
    },
    "Wobbuffet": {
        "hp": 190,
        "atk": 33,
        "def": 58,
        "spa": 33,
        "spd": 58,
        "spe": 33
    },
    "Girafarig": {
        "hp": 70,
        "atk": 80,
        "def": 65,
        "spa": 90,
        "spd": 65,
        "spe": 85
    },
    "Pineco": {
        "hp": 50,
        "atk": 65,
        "def": 90,
        "spa": 35,
        "spd": 35,
        "spe": 15
    },
    "Forretress": {
        "hp": 75,
        "atk": 90,
        "def": 140,
        "spa": 60,
        "spd": 60,
        "spe": 40
    },
    "Dunsparce": {
        "hp": 100,
        "atk": 70,
        "def": 70,
        "spa": 65,
        "spd": 65,
        "spe": 45
    },
    "Gligar": {
        "hp": 65,
        "atk": 75,
        "def": 105,
        "spa": 35,
        "spd": 65,
        "spe": 85
    },
    "Steelix": {
        "hp": 75,
        "atk": 85,
        "def": 200,
        "spa": 55,
        "spd": 65,
        "spe": 30
    },
    "Steelix-Mega": {
        "hp": 75,
        "atk": 125,
        "def": 230,
        "spa": 55,
        "spd": 95,
        "spe": 30
    },
    "Snubbull": {
        "hp": 60,
        "atk": 80,
        "def": 50,
        "spa": 40,
        "spd": 40,
        "spe": 30
    },
    "Granbull": {
        "hp": 90,
        "atk": 120,
        "def": 75,
        "spa": 60,
        "spd": 60,
        "spe": 45
    },
    "Qwilfish": {
        "hp": 65,
        "atk": 95,
        "def": 85,
        "spa": 55,
        "spd": 55,
        "spe": 85
    },
    "Qwilfish-Hisui": {
        "hp": 65,
        "atk": 95,
        "def": 85,
        "spa": 55,
        "spd": 55,
        "spe": 85
    },
    "Scizor": {
        "hp": 70,
        "atk": 130,
        "def": 100,
        "spa": 55,
        "spd": 80,
        "spe": 65
    },
    "Scizor-Mega": {
        "hp": 70,
        "atk": 150,
        "def": 140,
        "spa": 65,
        "spd": 100,
        "spe": 75
    },
    "Shuckle": {
        "hp": 20,
        "atk": 10,
        "def": 230,
        "spa": 10,
        "spd": 230,
        "spe": 5
    },
    "Heracross": {
        "hp": 80,
        "atk": 125,
        "def": 75,
        "spa": 40,
        "spd": 95,
        "spe": 85
    },
    "Heracross-Mega": {
        "hp": 80,
        "atk": 185,
        "def": 115,
        "spa": 40,
        "spd": 105,
        "spe": 75
    },
    "Sneasel": {
        "hp": 55,
        "atk": 95,
        "def": 55,
        "spa": 35,
        "spd": 75,
        "spe": 115
    },
    "Sneasel-Hisui": {
        "hp": 55,
        "atk": 95,
        "def": 55,
        "spa": 35,
        "spd": 75,
        "spe": 115
    },
    "Teddiursa": {
        "hp": 60,
        "atk": 80,
        "def": 50,
        "spa": 50,
        "spd": 50,
        "spe": 40
    },
    "Ursaring": {
        "hp": 90,
        "atk": 130,
        "def": 75,
        "spa": 75,
        "spd": 75,
        "spe": 55
    },
    "Slugma": {
        "hp": 40,
        "atk": 40,
        "def": 40,
        "spa": 70,
        "spd": 40,
        "spe": 20
    },
    "Magcargo": {
        "hp": 60,
        "atk": 50,
        "def": 120,
        "spa": 90,
        "spd": 80,
        "spe": 30
    },
    "Swinub": {
        "hp": 50,
        "atk": 50,
        "def": 40,
        "spa": 30,
        "spd": 30,
        "spe": 50
    },
    "Piloswine": {
        "hp": 100,
        "atk": 100,
        "def": 80,
        "spa": 60,
        "spd": 60,
        "spe": 50
    },
    "Corsola": {
        "hp": 65,
        "atk": 55,
        "def": 95,
        "spa": 65,
        "spd": 95,
        "spe": 35
    },
    "Corsola-Galar": {
        "hp": 60,
        "atk": 55,
        "def": 100,
        "spa": 65,
        "spd": 100,
        "spe": 30
    },
    "Remoraid": {
        "hp": 35,
        "atk": 65,
        "def": 35,
        "spa": 65,
        "spd": 35,
        "spe": 65
    },
    "Octillery": {
        "hp": 75,
        "atk": 105,
        "def": 75,
        "spa": 105,
        "spd": 75,
        "spe": 45
    },
    "Delibird": {
        "hp": 45,
        "atk": 55,
        "def": 45,
        "spa": 65,
        "spd": 45,
        "spe": 75
    },
    "Mantine": {
        "hp": 85,
        "atk": 40,
        "def": 70,
        "spa": 80,
        "spd": 140,
        "spe": 70
    },
    "Skarmory": {
        "hp": 65,
        "atk": 80,
        "def": 140,
        "spa": 40,
        "spd": 70,
        "spe": 70
    },
    "Houndour": {
        "hp": 45,
        "atk": 60,
        "def": 30,
        "spa": 80,
        "spd": 50,
        "spe": 65
    },
    "Houndoom": {
        "hp": 75,
        "atk": 90,
        "def": 50,
        "spa": 110,
        "spd": 80,
        "spe": 95
    },
    "Houndoom-Mega": {
        "hp": 75,
        "atk": 90,
        "def": 90,
        "spa": 140,
        "spd": 90,
        "spe": 115
    },
    "Kingdra": {
        "hp": 75,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 85
    },
    "Phanpy": {
        "hp": 90,
        "atk": 60,
        "def": 60,
        "spa": 40,
        "spd": 40,
        "spe": 40
    },
    "Donphan": {
        "hp": 90,
        "atk": 120,
        "def": 120,
        "spa": 60,
        "spd": 60,
        "spe": 50
    },
    "Porygon2": {
        "hp": 85,
        "atk": 80,
        "def": 90,
        "spa": 105,
        "spd": 95,
        "spe": 60
    },
    "Stantler": {
        "hp": 73,
        "atk": 95,
        "def": 62,
        "spa": 85,
        "spd": 65,
        "spe": 85
    },
    "Smeargle": {
        "hp": 55,
        "atk": 20,
        "def": 35,
        "spa": 20,
        "spd": 45,
        "spe": 75
    },
    "Tyrogue": {
        "hp": 35,
        "atk": 35,
        "def": 35,
        "spa": 35,
        "spd": 35,
        "spe": 35
    },
    "Hitmontop": {
        "hp": 50,
        "atk": 95,
        "def": 95,
        "spa": 35,
        "spd": 110,
        "spe": 70
    },
    "Smoochum": {
        "hp": 45,
        "atk": 30,
        "def": 15,
        "spa": 85,
        "spd": 65,
        "spe": 65
    },
    "Elekid": {
        "hp": 45,
        "atk": 63,
        "def": 37,
        "spa": 65,
        "spd": 55,
        "spe": 95
    },
    "Magby": {
        "hp": 45,
        "atk": 75,
        "def": 37,
        "spa": 70,
        "spd": 55,
        "spe": 83
    },
    "Miltank": {
        "hp": 95,
        "atk": 80,
        "def": 105,
        "spa": 40,
        "spd": 70,
        "spe": 100
    },
    "Blissey": {
        "hp": 255,
        "atk": 10,
        "def": 10,
        "spa": 75,
        "spd": 135,
        "spe": 55
    },
    "Raikou": {
        "hp": 90,
        "atk": 85,
        "def": 75,
        "spa": 115,
        "spd": 100,
        "spe": 115
    },
    "Entei": {
        "hp": 115,
        "atk": 115,
        "def": 85,
        "spa": 90,
        "spd": 75,
        "spe": 100
    },
    "Suicune": {
        "hp": 100,
        "atk": 75,
        "def": 115,
        "spa": 90,
        "spd": 115,
        "spe": 85
    },
    "Larvitar": {
        "hp": 50,
        "atk": 64,
        "def": 50,
        "spa": 45,
        "spd": 50,
        "spe": 41
    },
    "Pupitar": {
        "hp": 70,
        "atk": 84,
        "def": 70,
        "spa": 65,
        "spd": 70,
        "spe": 51
    },
    "Tyranitar": {
        "hp": 100,
        "atk": 134,
        "def": 110,
        "spa": 95,
        "spd": 100,
        "spe": 61
    },
    "Tyranitar-Mega": {
        "hp": 100,
        "atk": 164,
        "def": 150,
        "spa": 95,
        "spd": 120,
        "spe": 71
    },
    "Lugia": {
        "hp": 106,
        "atk": 90,
        "def": 130,
        "spa": 90,
        "spd": 154,
        "spe": 110
    },
    "Ho-Oh": {
        "hp": 106,
        "atk": 130,
        "def": 90,
        "spa": 110,
        "spd": 154,
        "spe": 90
    },
    "Celebi": {
        "hp": 100,
        "atk": 100,
        "def": 100,
        "spa": 100,
        "spd": 100,
        "spe": 100
    },
    "Treecko": {
        "hp": 40,
        "atk": 45,
        "def": 35,
        "spa": 65,
        "spd": 55,
        "spe": 70
    },
    "Grovyle": {
        "hp": 50,
        "atk": 65,
        "def": 45,
        "spa": 85,
        "spd": 65,
        "spe": 95
    },
    "Sceptile": {
        "hp": 70,
        "atk": 85,
        "def": 65,
        "spa": 105,
        "spd": 85,
        "spe": 120
    },
    "Sceptile-Mega": {
        "hp": 70,
        "atk": 110,
        "def": 75,
        "spa": 145,
        "spd": 85,
        "spe": 145
    },
    "Torchic": {
        "hp": 45,
        "atk": 60,
        "def": 40,
        "spa": 70,
        "spd": 50,
        "spe": 45
    },
    "Combusken": {
        "hp": 60,
        "atk": 85,
        "def": 60,
        "spa": 85,
        "spd": 60,
        "spe": 55
    },
    "Blaziken": {
        "hp": 80,
        "atk": 120,
        "def": 70,
        "spa": 110,
        "spd": 70,
        "spe": 80
    },
    "Blaziken-Mega": {
        "hp": 80,
        "atk": 160,
        "def": 80,
        "spa": 130,
        "spd": 80,
        "spe": 100
    },
    "Mudkip": {
        "hp": 50,
        "atk": 70,
        "def": 50,
        "spa": 50,
        "spd": 50,
        "spe": 40
    },
    "Marshtomp": {
        "hp": 70,
        "atk": 85,
        "def": 70,
        "spa": 60,
        "spd": 70,
        "spe": 50
    },
    "Swampert": {
        "hp": 100,
        "atk": 110,
        "def": 90,
        "spa": 85,
        "spd": 90,
        "spe": 60
    },
    "Swampert-Mega": {
        "hp": 100,
        "atk": 150,
        "def": 110,
        "spa": 95,
        "spd": 110,
        "spe": 70
    },
    "Poochyena": {
        "hp": 35,
        "atk": 55,
        "def": 35,
        "spa": 30,
        "spd": 30,
        "spe": 35
    },
    "Mightyena": {
        "hp": 70,
        "atk": 90,
        "def": 70,
        "spa": 60,
        "spd": 60,
        "spe": 70
    },
    "Zigzagoon": {
        "hp": 38,
        "atk": 30,
        "def": 41,
        "spa": 30,
        "spd": 41,
        "spe": 60
    },
    "Zigzagoon-Galar": {
        "hp": 38,
        "atk": 30,
        "def": 41,
        "spa": 30,
        "spd": 41,
        "spe": 60
    },
    "Linoone": {
        "hp": 78,
        "atk": 70,
        "def": 61,
        "spa": 50,
        "spd": 61,
        "spe": 100
    },
    "Linoone-Galar": {
        "hp": 78,
        "atk": 70,
        "def": 61,
        "spa": 50,
        "spd": 61,
        "spe": 100
    },
    "Wurmple": {
        "hp": 45,
        "atk": 45,
        "def": 35,
        "spa": 20,
        "spd": 30,
        "spe": 20
    },
    "Silcoon": {
        "hp": 50,
        "atk": 35,
        "def": 55,
        "spa": 25,
        "spd": 25,
        "spe": 15
    },
    "Beautifly": {
        "hp": 60,
        "atk": 70,
        "def": 50,
        "spa": 100,
        "spd": 50,
        "spe": 65
    },
    "Cascoon": {
        "hp": 50,
        "atk": 35,
        "def": 55,
        "spa": 25,
        "spd": 25,
        "spe": 15
    },
    "Dustox": {
        "hp": 60,
        "atk": 50,
        "def": 70,
        "spa": 50,
        "spd": 90,
        "spe": 65
    },
    "Lotad": {
        "hp": 40,
        "atk": 30,
        "def": 30,
        "spa": 40,
        "spd": 50,
        "spe": 30
    },
    "Lombre": {
        "hp": 60,
        "atk": 50,
        "def": 50,
        "spa": 60,
        "spd": 70,
        "spe": 50
    },
    "Ludicolo": {
        "hp": 80,
        "atk": 70,
        "def": 70,
        "spa": 90,
        "spd": 100,
        "spe": 70
    },
    "Seedot": {
        "hp": 40,
        "atk": 40,
        "def": 50,
        "spa": 30,
        "spd": 30,
        "spe": 30
    },
    "Nuzleaf": {
        "hp": 70,
        "atk": 70,
        "def": 40,
        "spa": 60,
        "spd": 40,
        "spe": 60
    },
    "Shiftry": {
        "hp": 90,
        "atk": 100,
        "def": 60,
        "spa": 90,
        "spd": 60,
        "spe": 80
    },
    "Taillow": {
        "hp": 40,
        "atk": 55,
        "def": 30,
        "spa": 30,
        "spd": 30,
        "spe": 85
    },
    "Swellow": {
        "hp": 60,
        "atk": 85,
        "def": 60,
        "spa": 75,
        "spd": 50,
        "spe": 125
    },
    "Wingull": {
        "hp": 40,
        "atk": 30,
        "def": 30,
        "spa": 55,
        "spd": 30,
        "spe": 85
    },
    "Pelipper": {
        "hp": 60,
        "atk": 50,
        "def": 100,
        "spa": 95,
        "spd": 70,
        "spe": 65
    },
    "Ralts": {
        "hp": 28,
        "atk": 25,
        "def": 25,
        "spa": 45,
        "spd": 35,
        "spe": 40
    },
    "Kirlia": {
        "hp": 38,
        "atk": 35,
        "def": 35,
        "spa": 65,
        "spd": 55,
        "spe": 50
    },
    "Gardevoir": {
        "hp": 68,
        "atk": 65,
        "def": 65,
        "spa": 125,
        "spd": 115,
        "spe": 80
    },
    "Gardevoir-Mega": {
        "hp": 68,
        "atk": 85,
        "def": 65,
        "spa": 165,
        "spd": 135,
        "spe": 100
    },
    "Surskit": {
        "hp": 40,
        "atk": 30,
        "def": 32,
        "spa": 50,
        "spd": 52,
        "spe": 65
    },
    "Masquerain": {
        "hp": 70,
        "atk": 60,
        "def": 62,
        "spa": 100,
        "spd": 82,
        "spe": 80
    },
    "Shroomish": {
        "hp": 60,
        "atk": 40,
        "def": 60,
        "spa": 40,
        "spd": 60,
        "spe": 35
    },
    "Breloom": {
        "hp": 60,
        "atk": 130,
        "def": 80,
        "spa": 60,
        "spd": 60,
        "spe": 70
    },
    "Slakoth": {
        "hp": 60,
        "atk": 60,
        "def": 60,
        "spa": 35,
        "spd": 35,
        "spe": 30
    },
    "Vigoroth": {
        "hp": 80,
        "atk": 80,
        "def": 80,
        "spa": 55,
        "spd": 55,
        "spe": 90
    },
    "Slaking": {
        "hp": 150,
        "atk": 160,
        "def": 100,
        "spa": 95,
        "spd": 65,
        "spe": 100
    },
    "Nincada": {
        "hp": 31,
        "atk": 45,
        "def": 90,
        "spa": 30,
        "spd": 30,
        "spe": 40
    },
    "Ninjask": {
        "hp": 61,
        "atk": 90,
        "def": 45,
        "spa": 50,
        "spd": 50,
        "spe": 160
    },
    "Shedinja": {
        "hp": 1,
        "atk": 90,
        "def": 45,
        "spa": 30,
        "spd": 30,
        "spe": 40
    },
    "Whismur": {
        "hp": 64,
        "atk": 51,
        "def": 23,
        "spa": 51,
        "spd": 23,
        "spe": 28
    },
    "Loudred": {
        "hp": 84,
        "atk": 71,
        "def": 43,
        "spa": 71,
        "spd": 43,
        "spe": 48
    },
    "Exploud": {
        "hp": 104,
        "atk": 91,
        "def": 63,
        "spa": 91,
        "spd": 73,
        "spe": 68
    },
    "Makuhita": {
        "hp": 72,
        "atk": 60,
        "def": 30,
        "spa": 20,
        "spd": 30,
        "spe": 25
    },
    "Hariyama": {
        "hp": 144,
        "atk": 120,
        "def": 60,
        "spa": 40,
        "spd": 60,
        "spe": 50
    },
    "Azurill": {
        "hp": 50,
        "atk": 20,
        "def": 40,
        "spa": 20,
        "spd": 40,
        "spe": 20
    },
    "Nosepass": {
        "hp": 30,
        "atk": 45,
        "def": 135,
        "spa": 45,
        "spd": 90,
        "spe": 30
    },
    "Skitty": {
        "hp": 50,
        "atk": 45,
        "def": 45,
        "spa": 35,
        "spd": 35,
        "spe": 50
    },
    "Delcatty": {
        "hp": 70,
        "atk": 65,
        "def": 65,
        "spa": 55,
        "spd": 55,
        "spe": 90
    },
    "Sableye": {
        "hp": 50,
        "atk": 75,
        "def": 75,
        "spa": 65,
        "spd": 65,
        "spe": 50
    },
    "Sableye-Mega": {
        "hp": 50,
        "atk": 85,
        "def": 125,
        "spa": 85,
        "spd": 115,
        "spe": 20
    },
    "Mawile": {
        "hp": 50,
        "atk": 85,
        "def": 85,
        "spa": 55,
        "spd": 55,
        "spe": 50
    },
    "Mawile-Mega": {
        "hp": 50,
        "atk": 105,
        "def": 125,
        "spa": 55,
        "spd": 95,
        "spe": 50
    },
    "Aron": {
        "hp": 50,
        "atk": 70,
        "def": 100,
        "spa": 40,
        "spd": 40,
        "spe": 30
    },
    "Lairon": {
        "hp": 60,
        "atk": 90,
        "def": 140,
        "spa": 50,
        "spd": 50,
        "spe": 40
    },
    "Aggron": {
        "hp": 70,
        "atk": 110,
        "def": 180,
        "spa": 60,
        "spd": 60,
        "spe": 50
    },
    "Aggron-Mega": {
        "hp": 70,
        "atk": 140,
        "def": 230,
        "spa": 60,
        "spd": 80,
        "spe": 50
    },
    "Meditite": {
        "hp": 30,
        "atk": 40,
        "def": 55,
        "spa": 40,
        "spd": 55,
        "spe": 60
    },
    "Medicham": {
        "hp": 60,
        "atk": 60,
        "def": 75,
        "spa": 60,
        "spd": 75,
        "spe": 80
    },
    "Medicham-Mega": {
        "hp": 60,
        "atk": 100,
        "def": 85,
        "spa": 80,
        "spd": 85,
        "spe": 100
    },
    "Electrike": {
        "hp": 40,
        "atk": 45,
        "def": 40,
        "spa": 65,
        "spd": 40,
        "spe": 65
    },
    "Manectric": {
        "hp": 70,
        "atk": 75,
        "def": 60,
        "spa": 105,
        "spd": 60,
        "spe": 105
    },
    "Manectric-Mega": {
        "hp": 70,
        "atk": 75,
        "def": 80,
        "spa": 135,
        "spd": 80,
        "spe": 135
    },
    "Plusle": {
        "hp": 60,
        "atk": 50,
        "def": 40,
        "spa": 85,
        "spd": 75,
        "spe": 95
    },
    "Minun": {
        "hp": 60,
        "atk": 40,
        "def": 50,
        "spa": 75,
        "spd": 85,
        "spe": 95
    },
    "Volbeat": {
        "hp": 65,
        "atk": 73,
        "def": 75,
        "spa": 47,
        "spd": 85,
        "spe": 85
    },
    "Illumise": {
        "hp": 65,
        "atk": 47,
        "def": 75,
        "spa": 73,
        "spd": 85,
        "spe": 85
    },
    "Roselia": {
        "hp": 50,
        "atk": 60,
        "def": 45,
        "spa": 100,
        "spd": 80,
        "spe": 65
    },
    "Gulpin": {
        "hp": 70,
        "atk": 43,
        "def": 53,
        "spa": 43,
        "spd": 53,
        "spe": 40
    },
    "Swalot": {
        "hp": 100,
        "atk": 73,
        "def": 83,
        "spa": 73,
        "spd": 83,
        "spe": 55
    },
    "Carvanha": {
        "hp": 45,
        "atk": 90,
        "def": 20,
        "spa": 65,
        "spd": 20,
        "spe": 65
    },
    "Sharpedo": {
        "hp": 70,
        "atk": 120,
        "def": 40,
        "spa": 95,
        "spd": 40,
        "spe": 95
    },
    "Sharpedo-Mega": {
        "hp": 70,
        "atk": 140,
        "def": 70,
        "spa": 110,
        "spd": 65,
        "spe": 105
    },
    "Wailmer": {
        "hp": 130,
        "atk": 70,
        "def": 35,
        "spa": 70,
        "spd": 35,
        "spe": 60
    },
    "Wailord": {
        "hp": 170,
        "atk": 90,
        "def": 45,
        "spa": 90,
        "spd": 45,
        "spe": 60
    },
    "Numel": {
        "hp": 60,
        "atk": 60,
        "def": 40,
        "spa": 65,
        "spd": 45,
        "spe": 35
    },
    "Camerupt": {
        "hp": 70,
        "atk": 100,
        "def": 70,
        "spa": 105,
        "spd": 75,
        "spe": 40
    },
    "Camerupt-Mega": {
        "hp": 70,
        "atk": 120,
        "def": 100,
        "spa": 145,
        "spd": 105,
        "spe": 20
    },
    "Torkoal": {
        "hp": 70,
        "atk": 85,
        "def": 140,
        "spa": 85,
        "spd": 70,
        "spe": 20
    },
    "Spoink": {
        "hp": 60,
        "atk": 25,
        "def": 35,
        "spa": 70,
        "spd": 80,
        "spe": 60
    },
    "Grumpig": {
        "hp": 80,
        "atk": 45,
        "def": 65,
        "spa": 90,
        "spd": 110,
        "spe": 80
    },
    "Spinda": {
        "hp": 60,
        "atk": 60,
        "def": 60,
        "spa": 60,
        "spd": 60,
        "spe": 60
    },
    "Trapinch": {
        "hp": 45,
        "atk": 100,
        "def": 45,
        "spa": 45,
        "spd": 45,
        "spe": 10
    },
    "Vibrava": {
        "hp": 50,
        "atk": 70,
        "def": 50,
        "spa": 50,
        "spd": 50,
        "spe": 70
    },
    "Flygon": {
        "hp": 80,
        "atk": 100,
        "def": 80,
        "spa": 80,
        "spd": 80,
        "spe": 100
    },
    "Cacnea": {
        "hp": 50,
        "atk": 85,
        "def": 40,
        "spa": 85,
        "spd": 40,
        "spe": 35
    },
    "Cacturne": {
        "hp": 70,
        "atk": 115,
        "def": 60,
        "spa": 115,
        "spd": 60,
        "spe": 55
    },
    "Swablu": {
        "hp": 45,
        "atk": 40,
        "def": 60,
        "spa": 40,
        "spd": 75,
        "spe": 50
    },
    "Altaria": {
        "hp": 75,
        "atk": 70,
        "def": 90,
        "spa": 70,
        "spd": 105,
        "spe": 80
    },
    "Altaria-Mega": {
        "hp": 75,
        "atk": 110,
        "def": 110,
        "spa": 110,
        "spd": 105,
        "spe": 80
    },
    "Zangoose": {
        "hp": 73,
        "atk": 115,
        "def": 60,
        "spa": 60,
        "spd": 60,
        "spe": 90
    },
    "Seviper": {
        "hp": 73,
        "atk": 100,
        "def": 60,
        "spa": 100,
        "spd": 60,
        "spe": 65
    },
    "Lunatone": {
        "hp": 90,
        "atk": 55,
        "def": 65,
        "spa": 95,
        "spd": 85,
        "spe": 70
    },
    "Solrock": {
        "hp": 90,
        "atk": 95,
        "def": 85,
        "spa": 55,
        "spd": 65,
        "spe": 70
    },
    "Barboach": {
        "hp": 50,
        "atk": 48,
        "def": 43,
        "spa": 46,
        "spd": 41,
        "spe": 60
    },
    "Whiscash": {
        "hp": 110,
        "atk": 78,
        "def": 73,
        "spa": 76,
        "spd": 71,
        "spe": 60
    },
    "Corphish": {
        "hp": 43,
        "atk": 80,
        "def": 65,
        "spa": 50,
        "spd": 35,
        "spe": 35
    },
    "Crawdaunt": {
        "hp": 63,
        "atk": 120,
        "def": 85,
        "spa": 90,
        "spd": 55,
        "spe": 55
    },
    "Baltoy": {
        "hp": 40,
        "atk": 40,
        "def": 55,
        "spa": 40,
        "spd": 70,
        "spe": 55
    },
    "Claydol": {
        "hp": 60,
        "atk": 70,
        "def": 105,
        "spa": 70,
        "spd": 120,
        "spe": 75
    },
    "Lileep": {
        "hp": 66,
        "atk": 41,
        "def": 77,
        "spa": 61,
        "spd": 87,
        "spe": 23
    },
    "Cradily": {
        "hp": 86,
        "atk": 81,
        "def": 97,
        "spa": 81,
        "spd": 107,
        "spe": 43
    },
    "Anorith": {
        "hp": 45,
        "atk": 95,
        "def": 50,
        "spa": 40,
        "spd": 50,
        "spe": 75
    },
    "Armaldo": {
        "hp": 75,
        "atk": 125,
        "def": 100,
        "spa": 70,
        "spd": 80,
        "spe": 45
    },
    "Feebas": {
        "hp": 20,
        "atk": 15,
        "def": 20,
        "spa": 10,
        "spd": 55,
        "spe": 80
    },
    "Milotic": {
        "hp": 95,
        "atk": 60,
        "def": 79,
        "spa": 100,
        "spd": 125,
        "spe": 81
    },
    "Castform": {
        "hp": 70,
        "atk": 70,
        "def": 70,
        "spa": 70,
        "spd": 70,
        "spe": 70
    },
    "Castform-Sunny": {
        "hp": 70,
        "atk": 70,
        "def": 70,
        "spa": 70,
        "spd": 70,
        "spe": 70
    },
    "Castform-Rainy": {
        "hp": 70,
        "atk": 70,
        "def": 70,
        "spa": 70,
        "spd": 70,
        "spe": 70
    },
    "Castform-Snowy": {
        "hp": 70,
        "atk": 70,
        "def": 70,
        "spa": 70,
        "spd": 70,
        "spe": 70
    },
    "Kecleon": {
        "hp": 60,
        "atk": 90,
        "def": 70,
        "spa": 60,
        "spd": 120,
        "spe": 40
    },
    "Shuppet": {
        "hp": 44,
        "atk": 75,
        "def": 35,
        "spa": 63,
        "spd": 33,
        "spe": 45
    },
    "Banette": {
        "hp": 64,
        "atk": 115,
        "def": 65,
        "spa": 83,
        "spd": 63,
        "spe": 65
    },
    "Banette-Mega": {
        "hp": 64,
        "atk": 165,
        "def": 75,
        "spa": 93,
        "spd": 83,
        "spe": 75
    },
    "Duskull": {
        "hp": 20,
        "atk": 40,
        "def": 90,
        "spa": 30,
        "spd": 90,
        "spe": 25
    },
    "Dusclops": {
        "hp": 40,
        "atk": 70,
        "def": 130,
        "spa": 60,
        "spd": 130,
        "spe": 25
    },
    "Tropius": {
        "hp": 99,
        "atk": 68,
        "def": 83,
        "spa": 72,
        "spd": 87,
        "spe": 51
    },
    "Chimecho": {
        "hp": 75,
        "atk": 50,
        "def": 80,
        "spa": 95,
        "spd": 90,
        "spe": 65
    },
    "Absol": {
        "hp": 65,
        "atk": 130,
        "def": 60,
        "spa": 75,
        "spd": 60,
        "spe": 75
    },
    "Absol-Mega": {
        "hp": 65,
        "atk": 150,
        "def": 60,
        "spa": 115,
        "spd": 60,
        "spe": 115
    },
    "Wynaut": {
        "hp": 95,
        "atk": 23,
        "def": 48,
        "spa": 23,
        "spd": 48,
        "spe": 23
    },
    "Snorunt": {
        "hp": 50,
        "atk": 50,
        "def": 50,
        "spa": 50,
        "spd": 50,
        "spe": 50
    },
    "Glalie": {
        "hp": 80,
        "atk": 80,
        "def": 80,
        "spa": 80,
        "spd": 80,
        "spe": 80
    },
    "Glalie-Mega": {
        "hp": 80,
        "atk": 120,
        "def": 80,
        "spa": 120,
        "spd": 80,
        "spe": 100
    },
    "Spheal": {
        "hp": 70,
        "atk": 40,
        "def": 50,
        "spa": 55,
        "spd": 50,
        "spe": 25
    },
    "Sealeo": {
        "hp": 90,
        "atk": 60,
        "def": 70,
        "spa": 75,
        "spd": 70,
        "spe": 45
    },
    "Walrein": {
        "hp": 110,
        "atk": 80,
        "def": 90,
        "spa": 95,
        "spd": 90,
        "spe": 65
    },
    "Clamperl": {
        "hp": 35,
        "atk": 64,
        "def": 85,
        "spa": 74,
        "spd": 55,
        "spe": 32
    },
    "Huntail": {
        "hp": 55,
        "atk": 104,
        "def": 105,
        "spa": 94,
        "spd": 75,
        "spe": 52
    },
    "Gorebyss": {
        "hp": 55,
        "atk": 84,
        "def": 105,
        "spa": 114,
        "spd": 75,
        "spe": 52
    },
    "Relicanth": {
        "hp": 100,
        "atk": 90,
        "def": 130,
        "spa": 45,
        "spd": 65,
        "spe": 55
    },
    "Luvdisc": {
        "hp": 43,
        "atk": 30,
        "def": 55,
        "spa": 40,
        "spd": 65,
        "spe": 97
    },
    "Bagon": {
        "hp": 45,
        "atk": 75,
        "def": 60,
        "spa": 40,
        "spd": 30,
        "spe": 50
    },
    "Shelgon": {
        "hp": 65,
        "atk": 95,
        "def": 100,
        "spa": 60,
        "spd": 50,
        "spe": 50
    },
    "Salamence": {
        "hp": 95,
        "atk": 135,
        "def": 80,
        "spa": 110,
        "spd": 80,
        "spe": 100
    },
    "Salamence-Mega": {
        "hp": 95,
        "atk": 145,
        "def": 130,
        "spa": 120,
        "spd": 90,
        "spe": 120
    },
    "Beldum": {
        "hp": 40,
        "atk": 55,
        "def": 80,
        "spa": 35,
        "spd": 60,
        "spe": 30
    },
    "Metang": {
        "hp": 60,
        "atk": 75,
        "def": 100,
        "spa": 55,
        "spd": 80,
        "spe": 50
    },
    "Metagross": {
        "hp": 80,
        "atk": 135,
        "def": 130,
        "spa": 95,
        "spd": 90,
        "spe": 70
    },
    "Metagross-Mega": {
        "hp": 80,
        "atk": 145,
        "def": 150,
        "spa": 105,
        "spd": 110,
        "spe": 110
    },
    "Regirock": {
        "hp": 80,
        "atk": 100,
        "def": 200,
        "spa": 50,
        "spd": 100,
        "spe": 50
    },
    "Regice": {
        "hp": 80,
        "atk": 50,
        "def": 100,
        "spa": 100,
        "spd": 200,
        "spe": 50
    },
    "Registeel": {
        "hp": 80,
        "atk": 75,
        "def": 150,
        "spa": 75,
        "spd": 150,
        "spe": 50
    },
    "Latias": {
        "hp": 80,
        "atk": 80,
        "def": 90,
        "spa": 110,
        "spd": 130,
        "spe": 110
    },
    "Latias-Mega": {
        "hp": 80,
        "atk": 100,
        "def": 120,
        "spa": 140,
        "spd": 150,
        "spe": 110
    },
    "Latios": {
        "hp": 80,
        "atk": 90,
        "def": 80,
        "spa": 130,
        "spd": 110,
        "spe": 110
    },
    "Latios-Mega": {
        "hp": 80,
        "atk": 130,
        "def": 100,
        "spa": 160,
        "spd": 120,
        "spe": 110
    },
    "Kyogre": {
        "hp": 100,
        "atk": 100,
        "def": 90,
        "spa": 150,
        "spd": 140,
        "spe": 90
    },
    "Kyogre-Primal": {
        "hp": 100,
        "atk": 150,
        "def": 90,
        "spa": 180,
        "spd": 160,
        "spe": 90
    },
    "Groudon": {
        "hp": 100,
        "atk": 150,
        "def": 140,
        "spa": 100,
        "spd": 90,
        "spe": 90
    },
    "Groudon-Primal": {
        "hp": 100,
        "atk": 180,
        "def": 160,
        "spa": 150,
        "spd": 90,
        "spe": 90
    },
    "Rayquaza": {
        "hp": 105,
        "atk": 150,
        "def": 90,
        "spa": 150,
        "spd": 90,
        "spe": 95
    },
    "Rayquaza-Mega": {
        "hp": 105,
        "atk": 180,
        "def": 100,
        "spa": 180,
        "spd": 100,
        "spe": 115
    },
    "Jirachi": {
        "hp": 100,
        "atk": 100,
        "def": 100,
        "spa": 100,
        "spd": 100,
        "spe": 100
    },
    "Deoxys": {
        "hp": 50,
        "atk": 150,
        "def": 50,
        "spa": 150,
        "spd": 50,
        "spe": 150
    },
    "Deoxys-Attack": {
        "hp": 50,
        "atk": 180,
        "def": 20,
        "spa": 180,
        "spd": 20,
        "spe": 150
    },
    "Deoxys-Defense": {
        "hp": 50,
        "atk": 70,
        "def": 160,
        "spa": 70,
        "spd": 160,
        "spe": 90
    },
    "Deoxys-Speed": {
        "hp": 50,
        "atk": 95,
        "def": 90,
        "spa": 95,
        "spd": 90,
        "spe": 180
    },
    "Turtwig": {
        "hp": 55,
        "atk": 68,
        "def": 64,
        "spa": 45,
        "spd": 55,
        "spe": 31
    },
    "Grotle": {
        "hp": 75,
        "atk": 89,
        "def": 85,
        "spa": 55,
        "spd": 65,
        "spe": 36
    },
    "Torterra": {
        "hp": 95,
        "atk": 109,
        "def": 105,
        "spa": 75,
        "spd": 85,
        "spe": 56
    },
    "Chimchar": {
        "hp": 44,
        "atk": 58,
        "def": 44,
        "spa": 58,
        "spd": 44,
        "spe": 61
    },
    "Monferno": {
        "hp": 64,
        "atk": 78,
        "def": 52,
        "spa": 78,
        "spd": 52,
        "spe": 81
    },
    "Infernape": {
        "hp": 76,
        "atk": 104,
        "def": 71,
        "spa": 104,
        "spd": 71,
        "spe": 108
    },
    "Piplup": {
        "hp": 53,
        "atk": 51,
        "def": 53,
        "spa": 61,
        "spd": 56,
        "spe": 40
    },
    "Prinplup": {
        "hp": 64,
        "atk": 66,
        "def": 68,
        "spa": 81,
        "spd": 76,
        "spe": 50
    },
    "Empoleon": {
        "hp": 84,
        "atk": 86,
        "def": 88,
        "spa": 111,
        "spd": 101,
        "spe": 60
    },
    "Starly": {
        "hp": 40,
        "atk": 55,
        "def": 30,
        "spa": 30,
        "spd": 30,
        "spe": 60
    },
    "Staravia": {
        "hp": 55,
        "atk": 75,
        "def": 50,
        "spa": 40,
        "spd": 40,
        "spe": 80
    },
    "Staraptor": {
        "hp": 85,
        "atk": 120,
        "def": 70,
        "spa": 50,
        "spd": 60,
        "spe": 100
    },
    "Bidoof": {
        "hp": 59,
        "atk": 45,
        "def": 40,
        "spa": 35,
        "spd": 40,
        "spe": 31
    },
    "Bibarel": {
        "hp": 79,
        "atk": 85,
        "def": 60,
        "spa": 55,
        "spd": 60,
        "spe": 71
    },
    "Kricketot": {
        "hp": 37,
        "atk": 25,
        "def": 41,
        "spa": 25,
        "spd": 41,
        "spe": 25
    },
    "Kricketune": {
        "hp": 77,
        "atk": 85,
        "def": 51,
        "spa": 55,
        "spd": 51,
        "spe": 65
    },
    "Shinx": {
        "hp": 45,
        "atk": 65,
        "def": 34,
        "spa": 40,
        "spd": 34,
        "spe": 45
    },
    "Luxio": {
        "hp": 60,
        "atk": 85,
        "def": 49,
        "spa": 60,
        "spd": 49,
        "spe": 60
    },
    "Luxray": {
        "hp": 80,
        "atk": 120,
        "def": 79,
        "spa": 95,
        "spd": 79,
        "spe": 70
    },
    "Budew": {
        "hp": 40,
        "atk": 30,
        "def": 35,
        "spa": 50,
        "spd": 70,
        "spe": 55
    },
    "Roserade": {
        "hp": 60,
        "atk": 70,
        "def": 65,
        "spa": 125,
        "spd": 105,
        "spe": 90
    },
    "Cranidos": {
        "hp": 67,
        "atk": 125,
        "def": 40,
        "spa": 30,
        "spd": 30,
        "spe": 58
    },
    "Rampardos": {
        "hp": 97,
        "atk": 165,
        "def": 60,
        "spa": 65,
        "spd": 50,
        "spe": 58
    },
    "Shieldon": {
        "hp": 30,
        "atk": 42,
        "def": 118,
        "spa": 42,
        "spd": 88,
        "spe": 30
    },
    "Bastiodon": {
        "hp": 60,
        "atk": 52,
        "def": 168,
        "spa": 47,
        "spd": 138,
        "spe": 30
    },
    "Burmy": {
        "hp": 40,
        "atk": 29,
        "def": 45,
        "spa": 29,
        "spd": 45,
        "spe": 36
    },
    "Wormadam": {
        "hp": 60,
        "atk": 59,
        "def": 85,
        "spa": 79,
        "spd": 105,
        "spe": 36
    },
    "Wormadam-Sandy": {
        "hp": 60,
        "atk": 79,
        "def": 105,
        "spa": 59,
        "spd": 85,
        "spe": 36
    },
    "Wormadam-Trash": {
        "hp": 60,
        "atk": 69,
        "def": 95,
        "spa": 69,
        "spd": 95,
        "spe": 36
    },
    "Mothim": {
        "hp": 70,
        "atk": 94,
        "def": 50,
        "spa": 94,
        "spd": 50,
        "spe": 66
    },
    "Combee": {
        "hp": 30,
        "atk": 30,
        "def": 42,
        "spa": 30,
        "spd": 42,
        "spe": 70
    },
    "Vespiquen": {
        "hp": 70,
        "atk": 80,
        "def": 102,
        "spa": 80,
        "spd": 102,
        "spe": 40
    },
    "Pachirisu": {
        "hp": 60,
        "atk": 45,
        "def": 70,
        "spa": 45,
        "spd": 90,
        "spe": 95
    },
    "Buizel": {
        "hp": 55,
        "atk": 65,
        "def": 35,
        "spa": 60,
        "spd": 30,
        "spe": 85
    },
    "Floatzel": {
        "hp": 85,
        "atk": 105,
        "def": 55,
        "spa": 85,
        "spd": 50,
        "spe": 115
    },
    "Cherubi": {
        "hp": 45,
        "atk": 35,
        "def": 45,
        "spa": 62,
        "spd": 53,
        "spe": 35
    },
    "Cherrim": {
        "hp": 70,
        "atk": 60,
        "def": 70,
        "spa": 87,
        "spd": 78,
        "spe": 85
    },
    "Cherrim-Sunshine": {
        "hp": 70,
        "atk": 60,
        "def": 70,
        "spa": 87,
        "spd": 78,
        "spe": 85
    },
    "Shellos": {
        "hp": 76,
        "atk": 48,
        "def": 48,
        "spa": 57,
        "spd": 62,
        "spe": 34
    },
    "Gastrodon": {
        "hp": 111,
        "atk": 83,
        "def": 68,
        "spa": 92,
        "spd": 82,
        "spe": 39
    },
    "Ambipom": {
        "hp": 75,
        "atk": 100,
        "def": 66,
        "spa": 60,
        "spd": 66,
        "spe": 115
    },
    "Drifloon": {
        "hp": 90,
        "atk": 50,
        "def": 34,
        "spa": 60,
        "spd": 44,
        "spe": 70
    },
    "Drifblim": {
        "hp": 150,
        "atk": 80,
        "def": 44,
        "spa": 90,
        "spd": 54,
        "spe": 80
    },
    "Buneary": {
        "hp": 55,
        "atk": 66,
        "def": 44,
        "spa": 44,
        "spd": 56,
        "spe": 85
    },
    "Lopunny": {
        "hp": 65,
        "atk": 76,
        "def": 84,
        "spa": 54,
        "spd": 96,
        "spe": 105
    },
    "Lopunny-Mega": {
        "hp": 65,
        "atk": 136,
        "def": 94,
        "spa": 54,
        "spd": 96,
        "spe": 135
    },
    "Mismagius": {
        "hp": 60,
        "atk": 60,
        "def": 60,
        "spa": 105,
        "spd": 105,
        "spe": 105
    },
    "Honchkrow": {
        "hp": 100,
        "atk": 125,
        "def": 52,
        "spa": 105,
        "spd": 52,
        "spe": 71
    },
    "Glameow": {
        "hp": 49,
        "atk": 55,
        "def": 42,
        "spa": 42,
        "spd": 37,
        "spe": 85
    },
    "Purugly": {
        "hp": 71,
        "atk": 82,
        "def": 64,
        "spa": 64,
        "spd": 59,
        "spe": 112
    },
    "Chingling": {
        "hp": 45,
        "atk": 30,
        "def": 50,
        "spa": 65,
        "spd": 50,
        "spe": 45
    },
    "Stunky": {
        "hp": 63,
        "atk": 63,
        "def": 47,
        "spa": 41,
        "spd": 41,
        "spe": 74
    },
    "Skuntank": {
        "hp": 103,
        "atk": 93,
        "def": 67,
        "spa": 71,
        "spd": 61,
        "spe": 84
    },
    "Bronzor": {
        "hp": 57,
        "atk": 24,
        "def": 86,
        "spa": 24,
        "spd": 86,
        "spe": 23
    },
    "Bronzong": {
        "hp": 67,
        "atk": 89,
        "def": 116,
        "spa": 79,
        "spd": 116,
        "spe": 33
    },
    "Bonsly": {
        "hp": 50,
        "atk": 80,
        "def": 95,
        "spa": 10,
        "spd": 45,
        "spe": 10
    },
    "Mime Jr.": {
        "hp": 20,
        "atk": 25,
        "def": 45,
        "spa": 70,
        "spd": 90,
        "spe": 60
    },
    "Happiny": {
        "hp": 100,
        "atk": 5,
        "def": 5,
        "spa": 15,
        "spd": 65,
        "spe": 30
    },
    "Chatot": {
        "hp": 76,
        "atk": 65,
        "def": 45,
        "spa": 92,
        "spd": 42,
        "spe": 91
    },
    "Spiritomb": {
        "hp": 50,
        "atk": 92,
        "def": 108,
        "spa": 92,
        "spd": 108,
        "spe": 35
    },
    "Gible": {
        "hp": 58,
        "atk": 70,
        "def": 45,
        "spa": 40,
        "spd": 45,
        "spe": 42
    },
    "Gabite": {
        "hp": 68,
        "atk": 90,
        "def": 65,
        "spa": 50,
        "spd": 55,
        "spe": 82
    },
    "Garchomp": {
        "hp": 108,
        "atk": 130,
        "def": 95,
        "spa": 80,
        "spd": 85,
        "spe": 102
    },
    "Garchomp-Mega": {
        "hp": 108,
        "atk": 170,
        "def": 115,
        "spa": 120,
        "spd": 95,
        "spe": 92
    },
    "Munchlax": {
        "hp": 135,
        "atk": 85,
        "def": 40,
        "spa": 40,
        "spd": 85,
        "spe": 5
    },
    "Riolu": {
        "hp": 40,
        "atk": 70,
        "def": 40,
        "spa": 35,
        "spd": 40,
        "spe": 60
    },
    "Lucario": {
        "hp": 70,
        "atk": 110,
        "def": 70,
        "spa": 115,
        "spd": 70,
        "spe": 90
    },
    "Lucario-Mega": {
        "hp": 70,
        "atk": 145,
        "def": 88,
        "spa": 140,
        "spd": 70,
        "spe": 112
    },
    "Hippopotas": {
        "hp": 68,
        "atk": 72,
        "def": 78,
        "spa": 38,
        "spd": 42,
        "spe": 32
    },
    "Hippowdon": {
        "hp": 108,
        "atk": 112,
        "def": 118,
        "spa": 68,
        "spd": 72,
        "spe": 47
    },
    "Skorupi": {
        "hp": 40,
        "atk": 50,
        "def": 90,
        "spa": 30,
        "spd": 55,
        "spe": 65
    },
    "Drapion": {
        "hp": 70,
        "atk": 90,
        "def": 110,
        "spa": 60,
        "spd": 75,
        "spe": 95
    },
    "Croagunk": {
        "hp": 48,
        "atk": 61,
        "def": 40,
        "spa": 61,
        "spd": 40,
        "spe": 50
    },
    "Toxicroak": {
        "hp": 83,
        "atk": 106,
        "def": 65,
        "spa": 86,
        "spd": 65,
        "spe": 85
    },
    "Carnivine": {
        "hp": 74,
        "atk": 100,
        "def": 72,
        "spa": 90,
        "spd": 72,
        "spe": 46
    },
    "Finneon": {
        "hp": 49,
        "atk": 49,
        "def": 56,
        "spa": 49,
        "spd": 61,
        "spe": 66
    },
    "Lumineon": {
        "hp": 69,
        "atk": 69,
        "def": 76,
        "spa": 69,
        "spd": 86,
        "spe": 91
    },
    "Mantyke": {
        "hp": 45,
        "atk": 20,
        "def": 50,
        "spa": 60,
        "spd": 120,
        "spe": 50
    },
    "Snover": {
        "hp": 60,
        "atk": 62,
        "def": 50,
        "spa": 62,
        "spd": 60,
        "spe": 40
    },
    "Abomasnow": {
        "hp": 90,
        "atk": 92,
        "def": 75,
        "spa": 92,
        "spd": 85,
        "spe": 60
    },
    "Abomasnow-Mega": {
        "hp": 90,
        "atk": 132,
        "def": 105,
        "spa": 132,
        "spd": 105,
        "spe": 30
    },
    "Weavile": {
        "hp": 70,
        "atk": 120,
        "def": 65,
        "spa": 45,
        "spd": 85,
        "spe": 125
    },
    "Magnezone": {
        "hp": 70,
        "atk": 70,
        "def": 115,
        "spa": 130,
        "spd": 90,
        "spe": 60
    },
    "Lickilicky": {
        "hp": 110,
        "atk": 85,
        "def": 95,
        "spa": 80,
        "spd": 95,
        "spe": 50
    },
    "Rhyperior": {
        "hp": 115,
        "atk": 140,
        "def": 130,
        "spa": 55,
        "spd": 55,
        "spe": 40
    },
    "Tangrowth": {
        "hp": 100,
        "atk": 100,
        "def": 125,
        "spa": 110,
        "spd": 50,
        "spe": 50
    },
    "Electivire": {
        "hp": 75,
        "atk": 123,
        "def": 67,
        "spa": 95,
        "spd": 85,
        "spe": 95
    },
    "Magmortar": {
        "hp": 75,
        "atk": 95,
        "def": 67,
        "spa": 125,
        "spd": 95,
        "spe": 83
    },
    "Togekiss": {
        "hp": 85,
        "atk": 50,
        "def": 95,
        "spa": 120,
        "spd": 115,
        "spe": 80
    },
    "Yanmega": {
        "hp": 86,
        "atk": 76,
        "def": 86,
        "spa": 116,
        "spd": 56,
        "spe": 95
    },
    "Leafeon": {
        "hp": 65,
        "atk": 110,
        "def": 130,
        "spa": 60,
        "spd": 65,
        "spe": 95
    },
    "Glaceon": {
        "hp": 65,
        "atk": 60,
        "def": 110,
        "spa": 130,
        "spd": 95,
        "spe": 65
    },
    "Gliscor": {
        "hp": 75,
        "atk": 95,
        "def": 125,
        "spa": 45,
        "spd": 75,
        "spe": 95
    },
    "Mamoswine": {
        "hp": 110,
        "atk": 130,
        "def": 80,
        "spa": 70,
        "spd": 60,
        "spe": 80
    },
    "Porygon-Z": {
        "hp": 85,
        "atk": 80,
        "def": 70,
        "spa": 135,
        "spd": 75,
        "spe": 90
    },
    "Gallade": {
        "hp": 68,
        "atk": 125,
        "def": 65,
        "spa": 65,
        "spd": 115,
        "spe": 80
    },
    "Gallade-Mega": {
        "hp": 68,
        "atk": 165,
        "def": 95,
        "spa": 65,
        "spd": 115,
        "spe": 110
    },
    "Probopass": {
        "hp": 60,
        "atk": 55,
        "def": 145,
        "spa": 75,
        "spd": 150,
        "spe": 40
    },
    "Dusknoir": {
        "hp": 45,
        "atk": 100,
        "def": 135,
        "spa": 65,
        "spd": 135,
        "spe": 45
    },
    "Froslass": {
        "hp": 70,
        "atk": 80,
        "def": 70,
        "spa": 80,
        "spd": 70,
        "spe": 110
    },
    "Rotom": {
        "hp": 50,
        "atk": 50,
        "def": 77,
        "spa": 95,
        "spd": 77,
        "spe": 91
    },
    "Rotom-Heat": {
        "hp": 50,
        "atk": 65,
        "def": 107,
        "spa": 105,
        "spd": 107,
        "spe": 86
    },
    "Rotom-Wash": {
        "hp": 50,
        "atk": 65,
        "def": 107,
        "spa": 105,
        "spd": 107,
        "spe": 86
    },
    "Rotom-Frost": {
        "hp": 50,
        "atk": 65,
        "def": 107,
        "spa": 105,
        "spd": 107,
        "spe": 86
    },
    "Rotom-Fan": {
        "hp": 50,
        "atk": 65,
        "def": 107,
        "spa": 105,
        "spd": 107,
        "spe": 86
    },
    "Rotom-Mow": {
        "hp": 50,
        "atk": 65,
        "def": 107,
        "spa": 105,
        "spd": 107,
        "spe": 86
    },
    "Uxie": {
        "hp": 75,
        "atk": 75,
        "def": 130,
        "spa": 75,
        "spd": 130,
        "spe": 95
    },
    "Mesprit": {
        "hp": 80,
        "atk": 105,
        "def": 105,
        "spa": 105,
        "spd": 105,
        "spe": 80
    },
    "Azelf": {
        "hp": 75,
        "atk": 125,
        "def": 70,
        "spa": 125,
        "spd": 70,
        "spe": 115
    },
    "Dialga": {
        "hp": 100,
        "atk": 120,
        "def": 120,
        "spa": 150,
        "spd": 100,
        "spe": 90
    },
    "Dialga-Origin": {
        "hp": 100,
        "atk": 100,
        "def": 120,
        "spa": 150,
        "spd": 120,
        "spe": 90
    },
    "Palkia": {
        "hp": 90,
        "atk": 120,
        "def": 100,
        "spa": 150,
        "spd": 120,
        "spe": 100
    },
    "Palkia-Origin": {
        "hp": 90,
        "atk": 100,
        "def": 100,
        "spa": 150,
        "spd": 120,
        "spe": 120
    },
    "Heatran": {
        "hp": 91,
        "atk": 90,
        "def": 106,
        "spa": 130,
        "spd": 106,
        "spe": 77
    },
    "Regigigas": {
        "hp": 110,
        "atk": 160,
        "def": 110,
        "spa": 80,
        "spd": 110,
        "spe": 100
    },
    "Giratina": {
        "hp": 150,
        "atk": 100,
        "def": 120,
        "spa": 100,
        "spd": 120,
        "spe": 90
    },
    "Giratina-Origin": {
        "hp": 150,
        "atk": 120,
        "def": 100,
        "spa": 120,
        "spd": 100,
        "spe": 90
    },
    "Cresselia": {
        "hp": 120,
        "atk": 70,
        "def": 110,
        "spa": 75,
        "spd": 120,
        "spe": 85
    },
    "Phione": {
        "hp": 80,
        "atk": 80,
        "def": 80,
        "spa": 80,
        "spd": 80,
        "spe": 80
    },
    "Manaphy": {
        "hp": 100,
        "atk": 100,
        "def": 100,
        "spa": 100,
        "spd": 100,
        "spe": 100
    },
    "Darkrai": {
        "hp": 70,
        "atk": 90,
        "def": 90,
        "spa": 135,
        "spd": 90,
        "spe": 125
    },
    "Shaymin": {
        "hp": 100,
        "atk": 100,
        "def": 100,
        "spa": 100,
        "spd": 100,
        "spe": 100
    },
    "Shaymin-Sky": {
        "hp": 100,
        "atk": 103,
        "def": 75,
        "spa": 120,
        "spd": 75,
        "spe": 127
    },
    "Arceus": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Arceus-Bug": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Arceus-Dark": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Arceus-Dragon": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Arceus-Electric": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Arceus-Fairy": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Arceus-Fighting": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Arceus-Fire": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Arceus-Flying": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Arceus-Ghost": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Arceus-Grass": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Arceus-Ground": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Arceus-Ice": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Arceus-Poison": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Arceus-Psychic": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Arceus-Rock": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Arceus-Steel": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Arceus-Water": {
        "hp": 120,
        "atk": 120,
        "def": 120,
        "spa": 120,
        "spd": 120,
        "spe": 120
    },
    "Victini": {
        "hp": 100,
        "atk": 100,
        "def": 100,
        "spa": 100,
        "spd": 100,
        "spe": 100
    },
    "Snivy": {
        "hp": 45,
        "atk": 45,
        "def": 55,
        "spa": 45,
        "spd": 55,
        "spe": 63
    },
    "Servine": {
        "hp": 60,
        "atk": 60,
        "def": 75,
        "spa": 60,
        "spd": 75,
        "spe": 83
    },
    "Serperior": {
        "hp": 75,
        "atk": 75,
        "def": 95,
        "spa": 75,
        "spd": 95,
        "spe": 113
    },
    "Tepig": {
        "hp": 65,
        "atk": 63,
        "def": 45,
        "spa": 45,
        "spd": 45,
        "spe": 45
    },
    "Pignite": {
        "hp": 90,
        "atk": 93,
        "def": 55,
        "spa": 70,
        "spd": 55,
        "spe": 55
    },
    "Emboar": {
        "hp": 110,
        "atk": 123,
        "def": 65,
        "spa": 100,
        "spd": 65,
        "spe": 65
    },
    "Oshawott": {
        "hp": 55,
        "atk": 55,
        "def": 45,
        "spa": 63,
        "spd": 45,
        "spe": 45
    },
    "Dewott": {
        "hp": 75,
        "atk": 75,
        "def": 60,
        "spa": 83,
        "spd": 60,
        "spe": 60
    },
    "Samurott": {
        "hp": 95,
        "atk": 100,
        "def": 85,
        "spa": 108,
        "spd": 70,
        "spe": 70
    },
    "Samurott-Hisui": {
        "hp": 90,
        "atk": 108,
        "def": 80,
        "spa": 100,
        "spd": 65,
        "spe": 85
    },
    "Patrat": {
        "hp": 45,
        "atk": 55,
        "def": 39,
        "spa": 35,
        "spd": 39,
        "spe": 42
    },
    "Watchog": {
        "hp": 60,
        "atk": 85,
        "def": 69,
        "spa": 60,
        "spd": 69,
        "spe": 77
    },
    "Lillipup": {
        "hp": 45,
        "atk": 60,
        "def": 45,
        "spa": 25,
        "spd": 45,
        "spe": 55
    },
    "Herdier": {
        "hp": 65,
        "atk": 80,
        "def": 65,
        "spa": 35,
        "spd": 65,
        "spe": 60
    },
    "Stoutland": {
        "hp": 85,
        "atk": 110,
        "def": 90,
        "spa": 45,
        "spd": 90,
        "spe": 80
    },
    "Purrloin": {
        "hp": 41,
        "atk": 50,
        "def": 37,
        "spa": 50,
        "spd": 37,
        "spe": 66
    },
    "Liepard": {
        "hp": 64,
        "atk": 88,
        "def": 50,
        "spa": 88,
        "spd": 50,
        "spe": 106
    },
    "Pansage": {
        "hp": 50,
        "atk": 53,
        "def": 48,
        "spa": 53,
        "spd": 48,
        "spe": 64
    },
    "Simisage": {
        "hp": 75,
        "atk": 98,
        "def": 63,
        "spa": 98,
        "spd": 63,
        "spe": 101
    },
    "Pansear": {
        "hp": 50,
        "atk": 53,
        "def": 48,
        "spa": 53,
        "spd": 48,
        "spe": 64
    },
    "Simisear": {
        "hp": 75,
        "atk": 98,
        "def": 63,
        "spa": 98,
        "spd": 63,
        "spe": 101
    },
    "Panpour": {
        "hp": 50,
        "atk": 53,
        "def": 48,
        "spa": 53,
        "spd": 48,
        "spe": 64
    },
    "Simipour": {
        "hp": 75,
        "atk": 98,
        "def": 63,
        "spa": 98,
        "spd": 63,
        "spe": 101
    },
    "Munna": {
        "hp": 76,
        "atk": 25,
        "def": 45,
        "spa": 67,
        "spd": 55,
        "spe": 24
    },
    "Musharna": {
        "hp": 116,
        "atk": 55,
        "def": 85,
        "spa": 107,
        "spd": 95,
        "spe": 29
    },
    "Pidove": {
        "hp": 50,
        "atk": 55,
        "def": 50,
        "spa": 36,
        "spd": 30,
        "spe": 43
    },
    "Tranquill": {
        "hp": 62,
        "atk": 77,
        "def": 62,
        "spa": 50,
        "spd": 42,
        "spe": 65
    },
    "Unfezant": {
        "hp": 80,
        "atk": 115,
        "def": 80,
        "spa": 65,
        "spd": 55,
        "spe": 93
    },
    "Blitzle": {
        "hp": 45,
        "atk": 60,
        "def": 32,
        "spa": 50,
        "spd": 32,
        "spe": 76
    },
    "Zebstrika": {
        "hp": 75,
        "atk": 100,
        "def": 63,
        "spa": 80,
        "spd": 63,
        "spe": 116
    },
    "Roggenrola": {
        "hp": 55,
        "atk": 75,
        "def": 85,
        "spa": 25,
        "spd": 25,
        "spe": 15
    },
    "Boldore": {
        "hp": 70,
        "atk": 105,
        "def": 105,
        "spa": 50,
        "spd": 40,
        "spe": 20
    },
    "Gigalith": {
        "hp": 85,
        "atk": 135,
        "def": 130,
        "spa": 60,
        "spd": 80,
        "spe": 25
    },
    "Woobat": {
        "hp": 65,
        "atk": 45,
        "def": 43,
        "spa": 55,
        "spd": 43,
        "spe": 72
    },
    "Swoobat": {
        "hp": 67,
        "atk": 57,
        "def": 55,
        "spa": 77,
        "spd": 55,
        "spe": 114
    },
    "Drilbur": {
        "hp": 60,
        "atk": 85,
        "def": 40,
        "spa": 30,
        "spd": 45,
        "spe": 68
    },
    "Excadrill": {
        "hp": 110,
        "atk": 135,
        "def": 60,
        "spa": 50,
        "spd": 65,
        "spe": 88
    },
    "Audino": {
        "hp": 103,
        "atk": 60,
        "def": 86,
        "spa": 60,
        "spd": 86,
        "spe": 50
    },
    "Audino-Mega": {
        "hp": 103,
        "atk": 60,
        "def": 126,
        "spa": 80,
        "spd": 126,
        "spe": 50
    },
    "Timburr": {
        "hp": 75,
        "atk": 80,
        "def": 55,
        "spa": 25,
        "spd": 35,
        "spe": 35
    },
    "Gurdurr": {
        "hp": 85,
        "atk": 105,
        "def": 85,
        "spa": 40,
        "spd": 50,
        "spe": 40
    },
    "Conkeldurr": {
        "hp": 105,
        "atk": 140,
        "def": 95,
        "spa": 55,
        "spd": 65,
        "spe": 45
    },
    "Tympole": {
        "hp": 50,
        "atk": 50,
        "def": 40,
        "spa": 50,
        "spd": 40,
        "spe": 64
    },
    "Palpitoad": {
        "hp": 75,
        "atk": 65,
        "def": 55,
        "spa": 65,
        "spd": 55,
        "spe": 69
    },
    "Seismitoad": {
        "hp": 105,
        "atk": 95,
        "def": 75,
        "spa": 85,
        "spd": 75,
        "spe": 74
    },
    "Throh": {
        "hp": 120,
        "atk": 100,
        "def": 85,
        "spa": 30,
        "spd": 85,
        "spe": 45
    },
    "Sawk": {
        "hp": 75,
        "atk": 125,
        "def": 75,
        "spa": 30,
        "spd": 75,
        "spe": 85
    },
    "Sewaddle": {
        "hp": 45,
        "atk": 53,
        "def": 70,
        "spa": 40,
        "spd": 60,
        "spe": 42
    },
    "Swadloon": {
        "hp": 55,
        "atk": 63,
        "def": 90,
        "spa": 50,
        "spd": 80,
        "spe": 42
    },
    "Leavanny": {
        "hp": 75,
        "atk": 103,
        "def": 80,
        "spa": 70,
        "spd": 80,
        "spe": 92
    },
    "Venipede": {
        "hp": 30,
        "atk": 45,
        "def": 59,
        "spa": 30,
        "spd": 39,
        "spe": 57
    },
    "Whirlipede": {
        "hp": 40,
        "atk": 55,
        "def": 99,
        "spa": 40,
        "spd": 79,
        "spe": 47
    },
    "Scolipede": {
        "hp": 60,
        "atk": 100,
        "def": 89,
        "spa": 55,
        "spd": 69,
        "spe": 112
    },
    "Cottonee": {
        "hp": 40,
        "atk": 27,
        "def": 60,
        "spa": 37,
        "spd": 50,
        "spe": 66
    },
    "Whimsicott": {
        "hp": 60,
        "atk": 67,
        "def": 85,
        "spa": 77,
        "spd": 75,
        "spe": 116
    },
    "Petilil": {
        "hp": 45,
        "atk": 35,
        "def": 50,
        "spa": 70,
        "spd": 50,
        "spe": 30
    },
    "Lilligant": {
        "hp": 70,
        "atk": 60,
        "def": 75,
        "spa": 110,
        "spd": 75,
        "spe": 90
    },
    "Lilligant-Hisui": {
        "hp": 70,
        "atk": 105,
        "def": 75,
        "spa": 50,
        "spd": 75,
        "spe": 105
    },
    "Basculin": {
        "hp": 70,
        "atk": 92,
        "def": 65,
        "spa": 80,
        "spd": 55,
        "spe": 98
    },
    "Basculin-Blue-Striped": {
        "hp": 70,
        "atk": 92,
        "def": 65,
        "spa": 80,
        "spd": 55,
        "spe": 98
    },
    "Basculin-White-Striped": {
        "hp": 70,
        "atk": 92,
        "def": 65,
        "spa": 80,
        "spd": 55,
        "spe": 98
    },
    "Sandile": {
        "hp": 50,
        "atk": 72,
        "def": 35,
        "spa": 35,
        "spd": 35,
        "spe": 65
    },
    "Krokorok": {
        "hp": 60,
        "atk": 82,
        "def": 45,
        "spa": 45,
        "spd": 45,
        "spe": 74
    },
    "Krookodile": {
        "hp": 95,
        "atk": 117,
        "def": 80,
        "spa": 65,
        "spd": 70,
        "spe": 92
    },
    "Darumaka": {
        "hp": 70,
        "atk": 90,
        "def": 45,
        "spa": 15,
        "spd": 45,
        "spe": 50
    },
    "Darumaka-Galar": {
        "hp": 70,
        "atk": 90,
        "def": 45,
        "spa": 15,
        "spd": 45,
        "spe": 50
    },
    "Darmanitan": {
        "hp": 105,
        "atk": 140,
        "def": 55,
        "spa": 30,
        "spd": 55,
        "spe": 95
    },
    "Darmanitan-Zen": {
        "hp": 105,
        "atk": 30,
        "def": 105,
        "spa": 140,
        "spd": 105,
        "spe": 55
    },
    "Darmanitan-Galar": {
        "hp": 105,
        "atk": 140,
        "def": 55,
        "spa": 30,
        "spd": 55,
        "spe": 95
    },
    "Darmanitan-Galar-Zen": {
        "hp": 105,
        "atk": 160,
        "def": 55,
        "spa": 30,
        "spd": 55,
        "spe": 135
    },
    "Maractus": {
        "hp": 75,
        "atk": 86,
        "def": 67,
        "spa": 106,
        "spd": 67,
        "spe": 60
    },
    "Dwebble": {
        "hp": 50,
        "atk": 65,
        "def": 85,
        "spa": 35,
        "spd": 35,
        "spe": 55
    },
    "Crustle": {
        "hp": 70,
        "atk": 105,
        "def": 125,
        "spa": 65,
        "spd": 75,
        "spe": 45
    },
    "Scraggy": {
        "hp": 50,
        "atk": 75,
        "def": 70,
        "spa": 35,
        "spd": 70,
        "spe": 48
    },
    "Scrafty": {
        "hp": 65,
        "atk": 90,
        "def": 115,
        "spa": 45,
        "spd": 115,
        "spe": 58
    },
    "Sigilyph": {
        "hp": 72,
        "atk": 58,
        "def": 80,
        "spa": 103,
        "spd": 80,
        "spe": 97
    },
    "Yamask": {
        "hp": 38,
        "atk": 30,
        "def": 85,
        "spa": 55,
        "spd": 65,
        "spe": 30
    },
    "Yamask-Galar": {
        "hp": 38,
        "atk": 55,
        "def": 85,
        "spa": 30,
        "spd": 65,
        "spe": 30
    },
    "Cofagrigus": {
        "hp": 58,
        "atk": 50,
        "def": 145,
        "spa": 95,
        "spd": 105,
        "spe": 30
    },
    "Tirtouga": {
        "hp": 54,
        "atk": 78,
        "def": 103,
        "spa": 53,
        "spd": 45,
        "spe": 22
    },
    "Carracosta": {
        "hp": 74,
        "atk": 108,
        "def": 133,
        "spa": 83,
        "spd": 65,
        "spe": 32
    },
    "Archen": {
        "hp": 55,
        "atk": 112,
        "def": 45,
        "spa": 74,
        "spd": 45,
        "spe": 70
    },
    "Archeops": {
        "hp": 75,
        "atk": 140,
        "def": 65,
        "spa": 112,
        "spd": 65,
        "spe": 110
    },
    "Trubbish": {
        "hp": 50,
        "atk": 50,
        "def": 62,
        "spa": 40,
        "spd": 62,
        "spe": 65
    },
    "Garbodor": {
        "hp": 80,
        "atk": 95,
        "def": 82,
        "spa": 60,
        "spd": 82,
        "spe": 75
    },
    "Garbodor-Gmax": {
        "hp": 80,
        "atk": 95,
        "def": 82,
        "spa": 60,
        "spd": 82,
        "spe": 75
    },
    "Zorua": {
        "hp": 40,
        "atk": 65,
        "def": 40,
        "spa": 80,
        "spd": 40,
        "spe": 65
    },
    "Zorua-Hisui": {
        "hp": 35,
        "atk": 60,
        "def": 40,
        "spa": 85,
        "spd": 40,
        "spe": 70
    },
    "Zoroark": {
        "hp": 60,
        "atk": 105,
        "def": 60,
        "spa": 120,
        "spd": 60,
        "spe": 105
    },
    "Zoroark-Hisui": {
        "hp": 55,
        "atk": 100,
        "def": 60,
        "spa": 125,
        "spd": 60,
        "spe": 110
    },
    "Minccino": {
        "hp": 55,
        "atk": 50,
        "def": 40,
        "spa": 40,
        "spd": 40,
        "spe": 75
    },
    "Cinccino": {
        "hp": 75,
        "atk": 95,
        "def": 60,
        "spa": 65,
        "spd": 60,
        "spe": 115
    },
    "Gothita": {
        "hp": 45,
        "atk": 30,
        "def": 50,
        "spa": 55,
        "spd": 65,
        "spe": 45
    },
    "Gothorita": {
        "hp": 60,
        "atk": 45,
        "def": 70,
        "spa": 75,
        "spd": 85,
        "spe": 55
    },
    "Gothitelle": {
        "hp": 70,
        "atk": 55,
        "def": 95,
        "spa": 95,
        "spd": 110,
        "spe": 65
    },
    "Solosis": {
        "hp": 45,
        "atk": 30,
        "def": 40,
        "spa": 105,
        "spd": 50,
        "spe": 20
    },
    "Duosion": {
        "hp": 65,
        "atk": 40,
        "def": 50,
        "spa": 125,
        "spd": 60,
        "spe": 30
    },
    "Reuniclus": {
        "hp": 110,
        "atk": 65,
        "def": 75,
        "spa": 125,
        "spd": 85,
        "spe": 30
    },
    "Ducklett": {
        "hp": 62,
        "atk": 44,
        "def": 50,
        "spa": 44,
        "spd": 50,
        "spe": 55
    },
    "Swanna": {
        "hp": 75,
        "atk": 87,
        "def": 63,
        "spa": 87,
        "spd": 63,
        "spe": 98
    },
    "Vanillite": {
        "hp": 36,
        "atk": 50,
        "def": 50,
        "spa": 65,
        "spd": 60,
        "spe": 44
    },
    "Vanillish": {
        "hp": 51,
        "atk": 65,
        "def": 65,
        "spa": 80,
        "spd": 75,
        "spe": 59
    },
    "Vanilluxe": {
        "hp": 71,
        "atk": 95,
        "def": 85,
        "spa": 110,
        "spd": 95,
        "spe": 79
    },
    "Deerling": {
        "hp": 60,
        "atk": 60,
        "def": 50,
        "spa": 40,
        "spd": 50,
        "spe": 75
    },
    "Sawsbuck": {
        "hp": 80,
        "atk": 100,
        "def": 70,
        "spa": 60,
        "spd": 70,
        "spe": 95
    },
    "Emolga": {
        "hp": 55,
        "atk": 75,
        "def": 60,
        "spa": 75,
        "spd": 60,
        "spe": 103
    },
    "Karrablast": {
        "hp": 50,
        "atk": 75,
        "def": 45,
        "spa": 40,
        "spd": 45,
        "spe": 60
    },
    "Escavalier": {
        "hp": 70,
        "atk": 135,
        "def": 105,
        "spa": 60,
        "spd": 105,
        "spe": 20
    },
    "Foongus": {
        "hp": 69,
        "atk": 55,
        "def": 45,
        "spa": 55,
        "spd": 55,
        "spe": 15
    },
    "Amoonguss": {
        "hp": 114,
        "atk": 85,
        "def": 70,
        "spa": 85,
        "spd": 80,
        "spe": 30
    },
    "Frillish": {
        "hp": 55,
        "atk": 40,
        "def": 50,
        "spa": 65,
        "spd": 85,
        "spe": 40
    },
    "Jellicent": {
        "hp": 100,
        "atk": 60,
        "def": 70,
        "spa": 85,
        "spd": 105,
        "spe": 60
    },
    "Alomomola": {
        "hp": 165,
        "atk": 75,
        "def": 80,
        "spa": 40,
        "spd": 45,
        "spe": 65
    },
    "Joltik": {
        "hp": 50,
        "atk": 47,
        "def": 50,
        "spa": 57,
        "spd": 50,
        "spe": 65
    },
    "Galvantula": {
        "hp": 70,
        "atk": 77,
        "def": 60,
        "spa": 97,
        "spd": 60,
        "spe": 108
    },
    "Ferroseed": {
        "hp": 44,
        "atk": 50,
        "def": 91,
        "spa": 24,
        "spd": 86,
        "spe": 10
    },
    "Ferrothorn": {
        "hp": 74,
        "atk": 94,
        "def": 131,
        "spa": 54,
        "spd": 116,
        "spe": 20
    },
    "Klink": {
        "hp": 40,
        "atk": 55,
        "def": 70,
        "spa": 45,
        "spd": 60,
        "spe": 30
    },
    "Klang": {
        "hp": 60,
        "atk": 80,
        "def": 95,
        "spa": 70,
        "spd": 85,
        "spe": 50
    },
    "Klinklang": {
        "hp": 60,
        "atk": 100,
        "def": 115,
        "spa": 70,
        "spd": 85,
        "spe": 90
    },
    "Tynamo": {
        "hp": 35,
        "atk": 55,
        "def": 40,
        "spa": 45,
        "spd": 40,
        "spe": 60
    },
    "Eelektrik": {
        "hp": 65,
        "atk": 85,
        "def": 70,
        "spa": 75,
        "spd": 70,
        "spe": 40
    },
    "Eelektross": {
        "hp": 85,
        "atk": 115,
        "def": 80,
        "spa": 105,
        "spd": 80,
        "spe": 50
    },
    "Elgyem": {
        "hp": 55,
        "atk": 55,
        "def": 55,
        "spa": 85,
        "spd": 55,
        "spe": 30
    },
    "Beheeyem": {
        "hp": 75,
        "atk": 75,
        "def": 75,
        "spa": 125,
        "spd": 95,
        "spe": 40
    },
    "Litwick": {
        "hp": 50,
        "atk": 30,
        "def": 55,
        "spa": 65,
        "spd": 55,
        "spe": 20
    },
    "Lampent": {
        "hp": 60,
        "atk": 40,
        "def": 60,
        "spa": 95,
        "spd": 60,
        "spe": 55
    },
    "Chandelure": {
        "hp": 60,
        "atk": 55,
        "def": 90,
        "spa": 145,
        "spd": 90,
        "spe": 80
    },
    "Axew": {
        "hp": 46,
        "atk": 87,
        "def": 60,
        "spa": 30,
        "spd": 40,
        "spe": 57
    },
    "Fraxure": {
        "hp": 66,
        "atk": 117,
        "def": 70,
        "spa": 40,
        "spd": 50,
        "spe": 67
    },
    "Haxorus": {
        "hp": 76,
        "atk": 147,
        "def": 90,
        "spa": 60,
        "spd": 70,
        "spe": 97
    },
    "Cubchoo": {
        "hp": 55,
        "atk": 70,
        "def": 40,
        "spa": 60,
        "spd": 40,
        "spe": 40
    },
    "Beartic": {
        "hp": 95,
        "atk": 130,
        "def": 80,
        "spa": 70,
        "spd": 80,
        "spe": 50
    },
    "Cryogonal": {
        "hp": 80,
        "atk": 50,
        "def": 50,
        "spa": 95,
        "spd": 135,
        "spe": 105
    },
    "Shelmet": {
        "hp": 50,
        "atk": 40,
        "def": 85,
        "spa": 40,
        "spd": 65,
        "spe": 25
    },
    "Accelgor": {
        "hp": 80,
        "atk": 70,
        "def": 40,
        "spa": 100,
        "spd": 60,
        "spe": 145
    },
    "Stunfisk": {
        "hp": 109,
        "atk": 66,
        "def": 84,
        "spa": 81,
        "spd": 99,
        "spe": 32
    },
    "Stunfisk-Galar": {
        "hp": 109,
        "atk": 81,
        "def": 99,
        "spa": 66,
        "spd": 84,
        "spe": 32
    },
    "Mienfoo": {
        "hp": 45,
        "atk": 85,
        "def": 50,
        "spa": 55,
        "spd": 50,
        "spe": 65
    },
    "Mienshao": {
        "hp": 65,
        "atk": 125,
        "def": 60,
        "spa": 95,
        "spd": 60,
        "spe": 105
    },
    "Druddigon": {
        "hp": 77,
        "atk": 120,
        "def": 90,
        "spa": 60,
        "spd": 90,
        "spe": 48
    },
    "Golett": {
        "hp": 59,
        "atk": 74,
        "def": 50,
        "spa": 35,
        "spd": 50,
        "spe": 35
    },
    "Golurk": {
        "hp": 89,
        "atk": 124,
        "def": 80,
        "spa": 55,
        "spd": 80,
        "spe": 55
    },
    "Pawniard": {
        "hp": 45,
        "atk": 85,
        "def": 70,
        "spa": 40,
        "spd": 40,
        "spe": 60
    },
    "Bisharp": {
        "hp": 65,
        "atk": 125,
        "def": 100,
        "spa": 60,
        "spd": 70,
        "spe": 70
    },
    "Bouffalant": {
        "hp": 95,
        "atk": 110,
        "def": 95,
        "spa": 40,
        "spd": 95,
        "spe": 55
    },
    "Rufflet": {
        "hp": 70,
        "atk": 83,
        "def": 50,
        "spa": 37,
        "spd": 50,
        "spe": 60
    },
    "Braviary": {
        "hp": 100,
        "atk": 123,
        "def": 75,
        "spa": 57,
        "spd": 75,
        "spe": 80
    },
    "Braviary-Hisui": {
        "hp": 110,
        "atk": 83,
        "def": 70,
        "spa": 112,
        "spd": 70,
        "spe": 65
    },
    "Vullaby": {
        "hp": 70,
        "atk": 55,
        "def": 75,
        "spa": 45,
        "spd": 65,
        "spe": 60
    },
    "Mandibuzz": {
        "hp": 110,
        "atk": 65,
        "def": 105,
        "spa": 55,
        "spd": 95,
        "spe": 80
    },
    "Heatmor": {
        "hp": 85,
        "atk": 97,
        "def": 66,
        "spa": 105,
        "spd": 66,
        "spe": 65
    },
    "Durant": {
        "hp": 58,
        "atk": 109,
        "def": 112,
        "spa": 48,
        "spd": 48,
        "spe": 109
    },
    "Deino": {
        "hp": 52,
        "atk": 65,
        "def": 50,
        "spa": 45,
        "spd": 50,
        "spe": 38
    },
    "Zweilous": {
        "hp": 72,
        "atk": 85,
        "def": 70,
        "spa": 65,
        "spd": 70,
        "spe": 58
    },
    "Hydreigon": {
        "hp": 92,
        "atk": 105,
        "def": 90,
        "spa": 125,
        "spd": 90,
        "spe": 98
    },
    "Larvesta": {
        "hp": 55,
        "atk": 85,
        "def": 55,
        "spa": 50,
        "spd": 55,
        "spe": 60
    },
    "Volcarona": {
        "hp": 85,
        "atk": 60,
        "def": 65,
        "spa": 135,
        "spd": 105,
        "spe": 100
    },
    "Cobalion": {
        "hp": 91,
        "atk": 90,
        "def": 129,
        "spa": 90,
        "spd": 72,
        "spe": 108
    },
    "Terrakion": {
        "hp": 91,
        "atk": 129,
        "def": 90,
        "spa": 72,
        "spd": 90,
        "spe": 108
    },
    "Virizion": {
        "hp": 91,
        "atk": 90,
        "def": 72,
        "spa": 90,
        "spd": 129,
        "spe": 108
    },
    "Tornadus": {
        "hp": 79,
        "atk": 115,
        "def": 70,
        "spa": 125,
        "spd": 80,
        "spe": 111
    },
    "Tornadus-Therian": {
        "hp": 79,
        "atk": 100,
        "def": 80,
        "spa": 110,
        "spd": 90,
        "spe": 121
    },
    "Thundurus": {
        "hp": 79,
        "atk": 115,
        "def": 70,
        "spa": 125,
        "spd": 80,
        "spe": 111
    },
    "Thundurus-Therian": {
        "hp": 79,
        "atk": 105,
        "def": 70,
        "spa": 145,
        "spd": 80,
        "spe": 101
    },
    "Reshiram": {
        "hp": 100,
        "atk": 120,
        "def": 100,
        "spa": 150,
        "spd": 120,
        "spe": 90
    },
    "Zekrom": {
        "hp": 100,
        "atk": 150,
        "def": 120,
        "spa": 120,
        "spd": 100,
        "spe": 90
    },
    "Landorus": {
        "hp": 89,
        "atk": 125,
        "def": 90,
        "spa": 115,
        "spd": 80,
        "spe": 101
    },
    "Landorus-Therian": {
        "hp": 89,
        "atk": 145,
        "def": 90,
        "spa": 105,
        "spd": 80,
        "spe": 91
    },
    "Kyurem": {
        "hp": 125,
        "atk": 130,
        "def": 90,
        "spa": 130,
        "spd": 90,
        "spe": 95
    },
    "Kyurem-Black": {
        "hp": 125,
        "atk": 170,
        "def": 100,
        "spa": 120,
        "spd": 90,
        "spe": 95
    },
    "Kyurem-White": {
        "hp": 125,
        "atk": 120,
        "def": 90,
        "spa": 170,
        "spd": 100,
        "spe": 95
    },
    "Keldeo": {
        "hp": 91,
        "atk": 72,
        "def": 90,
        "spa": 129,
        "spd": 90,
        "spe": 108
    },
    "Keldeo-Resolute": {
        "hp": 91,
        "atk": 72,
        "def": 90,
        "spa": 129,
        "spd": 90,
        "spe": 108
    },
    "Meloetta": {
        "hp": 100,
        "atk": 77,
        "def": 77,
        "spa": 128,
        "spd": 128,
        "spe": 90
    },
    "Meloetta-Pirouette": {
        "hp": 100,
        "atk": 128,
        "def": 90,
        "spa": 77,
        "spd": 77,
        "spe": 128
    },
    "Genesect": {
        "hp": 71,
        "atk": 120,
        "def": 95,
        "spa": 120,
        "spd": 95,
        "spe": 99
    },
    "Genesect-Douse": {
        "hp": 71,
        "atk": 120,
        "def": 95,
        "spa": 120,
        "spd": 95,
        "spe": 99
    },
    "Genesect-Shock": {
        "hp": 71,
        "atk": 120,
        "def": 95,
        "spa": 120,
        "spd": 95,
        "spe": 99
    },
    "Genesect-Burn": {
        "hp": 71,
        "atk": 120,
        "def": 95,
        "spa": 120,
        "spd": 95,
        "spe": 99
    },
    "Genesect-Chill": {
        "hp": 71,
        "atk": 120,
        "def": 95,
        "spa": 120,
        "spd": 95,
        "spe": 99
    },
    "Chespin": {
        "hp": 56,
        "atk": 61,
        "def": 65,
        "spa": 48,
        "spd": 45,
        "spe": 38
    },
    "Quilladin": {
        "hp": 61,
        "atk": 78,
        "def": 95,
        "spa": 56,
        "spd": 58,
        "spe": 57
    },
    "Chesnaught": {
        "hp": 88,
        "atk": 107,
        "def": 122,
        "spa": 74,
        "spd": 75,
        "spe": 64
    },
    "Fennekin": {
        "hp": 40,
        "atk": 45,
        "def": 40,
        "spa": 62,
        "spd": 60,
        "spe": 60
    },
    "Braixen": {
        "hp": 59,
        "atk": 59,
        "def": 58,
        "spa": 90,
        "spd": 70,
        "spe": 73
    },
    "Delphox": {
        "hp": 75,
        "atk": 69,
        "def": 72,
        "spa": 114,
        "spd": 100,
        "spe": 104
    },
    "Froakie": {
        "hp": 41,
        "atk": 56,
        "def": 40,
        "spa": 62,
        "spd": 44,
        "spe": 71
    },
    "Frogadier": {
        "hp": 54,
        "atk": 63,
        "def": 52,
        "spa": 83,
        "spd": 56,
        "spe": 97
    },
    "Greninja": {
        "hp": 72,
        "atk": 95,
        "def": 67,
        "spa": 103,
        "spd": 71,
        "spe": 122
    },
    "Greninja-Bond": {
        "hp": 72,
        "atk": 95,
        "def": 67,
        "spa": 103,
        "spd": 71,
        "spe": 122
    },
    "Greninja-Ash": {
        "hp": 72,
        "atk": 145,
        "def": 67,
        "spa": 153,
        "spd": 71,
        "spe": 132
    },
    "Bunnelby": {
        "hp": 38,
        "atk": 36,
        "def": 38,
        "spa": 32,
        "spd": 36,
        "spe": 57
    },
    "Diggersby": {
        "hp": 85,
        "atk": 56,
        "def": 77,
        "spa": 50,
        "spd": 77,
        "spe": 78
    },
    "Fletchling": {
        "hp": 45,
        "atk": 50,
        "def": 43,
        "spa": 40,
        "spd": 38,
        "spe": 62
    },
    "Fletchinder": {
        "hp": 62,
        "atk": 73,
        "def": 55,
        "spa": 56,
        "spd": 52,
        "spe": 84
    },
    "Talonflame": {
        "hp": 78,
        "atk": 81,
        "def": 71,
        "spa": 74,
        "spd": 69,
        "spe": 126
    },
    "Scatterbug": {
        "hp": 38,
        "atk": 35,
        "def": 40,
        "spa": 27,
        "spd": 25,
        "spe": 35
    },
    "Spewpa": {
        "hp": 45,
        "atk": 22,
        "def": 60,
        "spa": 27,
        "spd": 30,
        "spe": 29
    },
    "Vivillon": {
        "hp": 80,
        "atk": 52,
        "def": 50,
        "spa": 90,
        "spd": 50,
        "spe": 89
    },
    "Vivillon-Fancy": {
        "hp": 80,
        "atk": 52,
        "def": 50,
        "spa": 90,
        "spd": 50,
        "spe": 89
    },
    "Vivillon-Pokeball": {
        "hp": 80,
        "atk": 52,
        "def": 50,
        "spa": 90,
        "spd": 50,
        "spe": 89
    },
    "Litleo": {
        "hp": 62,
        "atk": 50,
        "def": 58,
        "spa": 73,
        "spd": 54,
        "spe": 72
    },
    "Pyroar": {
        "hp": 86,
        "atk": 68,
        "def": 72,
        "spa": 109,
        "spd": 66,
        "spe": 106
    },
    "Flabe\u0301be\u0301": {
        "hp": 44,
        "atk": 38,
        "def": 39,
        "spa": 61,
        "spd": 79,
        "spe": 42
    },
    "Floette": {
        "hp": 54,
        "atk": 45,
        "def": 47,
        "spa": 75,
        "spd": 98,
        "spe": 52
    },
    "Floette-Eternal": {
        "hp": 74,
        "atk": 65,
        "def": 67,
        "spa": 125,
        "spd": 128,
        "spe": 92
    },
    "Florges": {
        "hp": 78,
        "atk": 65,
        "def": 68,
        "spa": 112,
        "spd": 154,
        "spe": 75
    },
    "Skiddo": {
        "hp": 66,
        "atk": 65,
        "def": 48,
        "spa": 62,
        "spd": 57,
        "spe": 52
    },
    "Gogoat": {
        "hp": 123,
        "atk": 100,
        "def": 62,
        "spa": 97,
        "spd": 81,
        "spe": 68
    },
    "Pancham": {
        "hp": 67,
        "atk": 82,
        "def": 62,
        "spa": 46,
        "spd": 48,
        "spe": 43
    },
    "Pangoro": {
        "hp": 95,
        "atk": 124,
        "def": 78,
        "spa": 69,
        "spd": 71,
        "spe": 58
    },
    "Furfrou": {
        "hp": 75,
        "atk": 80,
        "def": 60,
        "spa": 65,
        "spd": 90,
        "spe": 102
    },
    "Espurr": {
        "hp": 62,
        "atk": 48,
        "def": 54,
        "spa": 63,
        "spd": 60,
        "spe": 68
    },
    "Meowstic": {
        "hp": 74,
        "atk": 48,
        "def": 76,
        "spa": 83,
        "spd": 81,
        "spe": 104
    },
    "Meowstic-F": {
        "hp": 74,
        "atk": 48,
        "def": 76,
        "spa": 83,
        "spd": 81,
        "spe": 104
    },
    "Honedge": {
        "hp": 45,
        "atk": 80,
        "def": 100,
        "spa": 35,
        "spd": 37,
        "spe": 28
    },
    "Doublade": {
        "hp": 59,
        "atk": 110,
        "def": 150,
        "spa": 45,
        "spd": 49,
        "spe": 35
    },
    "Aegislash": {
        "hp": 60,
        "atk": 50,
        "def": 140,
        "spa": 50,
        "spd": 140,
        "spe": 60
    },
    "Aegislash-Blade": {
        "hp": 60,
        "atk": 140,
        "def": 50,
        "spa": 140,
        "spd": 50,
        "spe": 60
    },
    "Spritzee": {
        "hp": 78,
        "atk": 52,
        "def": 60,
        "spa": 63,
        "spd": 65,
        "spe": 23
    },
    "Aromatisse": {
        "hp": 101,
        "atk": 72,
        "def": 72,
        "spa": 99,
        "spd": 89,
        "spe": 29
    },
    "Swirlix": {
        "hp": 62,
        "atk": 48,
        "def": 66,
        "spa": 59,
        "spd": 57,
        "spe": 49
    },
    "Slurpuff": {
        "hp": 82,
        "atk": 80,
        "def": 86,
        "spa": 85,
        "spd": 75,
        "spe": 72
    },
    "Inkay": {
        "hp": 53,
        "atk": 54,
        "def": 53,
        "spa": 37,
        "spd": 46,
        "spe": 45
    },
    "Malamar": {
        "hp": 86,
        "atk": 92,
        "def": 88,
        "spa": 68,
        "spd": 75,
        "spe": 73
    },
    "Binacle": {
        "hp": 42,
        "atk": 52,
        "def": 67,
        "spa": 39,
        "spd": 56,
        "spe": 50
    },
    "Barbaracle": {
        "hp": 72,
        "atk": 105,
        "def": 115,
        "spa": 54,
        "spd": 86,
        "spe": 68
    },
    "Skrelp": {
        "hp": 50,
        "atk": 60,
        "def": 60,
        "spa": 60,
        "spd": 60,
        "spe": 30
    },
    "Dragalge": {
        "hp": 65,
        "atk": 75,
        "def": 90,
        "spa": 97,
        "spd": 123,
        "spe": 44
    },
    "Clauncher": {
        "hp": 50,
        "atk": 53,
        "def": 62,
        "spa": 58,
        "spd": 63,
        "spe": 44
    },
    "Clawitzer": {
        "hp": 71,
        "atk": 73,
        "def": 88,
        "spa": 120,
        "spd": 89,
        "spe": 59
    },
    "Helioptile": {
        "hp": 44,
        "atk": 38,
        "def": 33,
        "spa": 61,
        "spd": 43,
        "spe": 70
    },
    "Heliolisk": {
        "hp": 62,
        "atk": 55,
        "def": 52,
        "spa": 109,
        "spd": 94,
        "spe": 109
    },
    "Tyrunt": {
        "hp": 58,
        "atk": 89,
        "def": 77,
        "spa": 45,
        "spd": 45,
        "spe": 48
    },
    "Tyrantrum": {
        "hp": 82,
        "atk": 121,
        "def": 119,
        "spa": 69,
        "spd": 59,
        "spe": 71
    },
    "Amaura": {
        "hp": 77,
        "atk": 59,
        "def": 50,
        "spa": 67,
        "spd": 63,
        "spe": 46
    },
    "Aurorus": {
        "hp": 123,
        "atk": 77,
        "def": 72,
        "spa": 99,
        "spd": 92,
        "spe": 58
    },
    "Sylveon": {
        "hp": 95,
        "atk": 65,
        "def": 65,
        "spa": 110,
        "spd": 130,
        "spe": 60
    },
    "Hawlucha": {
        "hp": 78,
        "atk": 92,
        "def": 75,
        "spa": 74,
        "spd": 63,
        "spe": 118
    },
    "Dedenne": {
        "hp": 67,
        "atk": 58,
        "def": 57,
        "spa": 81,
        "spd": 67,
        "spe": 101
    },
    "Carbink": {
        "hp": 50,
        "atk": 50,
        "def": 150,
        "spa": 50,
        "spd": 150,
        "spe": 50
    },
    "Goomy": {
        "hp": 45,
        "atk": 50,
        "def": 35,
        "spa": 55,
        "spd": 75,
        "spe": 40
    },
    "Sliggoo": {
        "hp": 68,
        "atk": 75,
        "def": 53,
        "spa": 83,
        "spd": 113,
        "spe": 60
    },
    "Sliggoo-Hisui": {
        "hp": 58,
        "atk": 75,
        "def": 83,
        "spa": 83,
        "spd": 113,
        "spe": 40
    },
    "Goodra": {
        "hp": 90,
        "atk": 100,
        "def": 70,
        "spa": 110,
        "spd": 150,
        "spe": 80
    },
    "Goodra-Hisui": {
        "hp": 80,
        "atk": 100,
        "def": 100,
        "spa": 110,
        "spd": 150,
        "spe": 60
    },
    "Klefki": {
        "hp": 57,
        "atk": 80,
        "def": 91,
        "spa": 80,
        "spd": 87,
        "spe": 75
    },
    "Phantump": {
        "hp": 43,
        "atk": 70,
        "def": 48,
        "spa": 50,
        "spd": 60,
        "spe": 38
    },
    "Trevenant": {
        "hp": 85,
        "atk": 110,
        "def": 76,
        "spa": 65,
        "spd": 82,
        "spe": 56
    },
    "Pumpkaboo": {
        "hp": 49,
        "atk": 66,
        "def": 70,
        "spa": 44,
        "spd": 55,
        "spe": 51
    },
    "Pumpkaboo-Small": {
        "hp": 44,
        "atk": 66,
        "def": 70,
        "spa": 44,
        "spd": 55,
        "spe": 56
    },
    "Pumpkaboo-Large": {
        "hp": 54,
        "atk": 66,
        "def": 70,
        "spa": 44,
        "spd": 55,
        "spe": 46
    },
    "Pumpkaboo-Super": {
        "hp": 59,
        "atk": 66,
        "def": 70,
        "spa": 44,
        "spd": 55,
        "spe": 41
    },
    "Gourgeist": {
        "hp": 65,
        "atk": 90,
        "def": 122,
        "spa": 58,
        "spd": 75,
        "spe": 84
    },
    "Gourgeist-Small": {
        "hp": 55,
        "atk": 85,
        "def": 122,
        "spa": 58,
        "spd": 75,
        "spe": 99
    },
    "Gourgeist-Large": {
        "hp": 75,
        "atk": 95,
        "def": 122,
        "spa": 58,
        "spd": 75,
        "spe": 69
    },
    "Gourgeist-Super": {
        "hp": 85,
        "atk": 100,
        "def": 122,
        "spa": 58,
        "spd": 75,
        "spe": 54
    },
    "Bergmite": {
        "hp": 55,
        "atk": 69,
        "def": 85,
        "spa": 32,
        "spd": 35,
        "spe": 28
    },
    "Avalugg": {
        "hp": 95,
        "atk": 117,
        "def": 184,
        "spa": 44,
        "spd": 46,
        "spe": 28
    },
    "Avalugg-Hisui": {
        "hp": 95,
        "atk": 127,
        "def": 184,
        "spa": 34,
        "spd": 36,
        "spe": 38
    },
    "Noibat": {
        "hp": 40,
        "atk": 30,
        "def": 35,
        "spa": 45,
        "spd": 40,
        "spe": 55
    },
    "Noivern": {
        "hp": 85,
        "atk": 70,
        "def": 80,
        "spa": 97,
        "spd": 80,
        "spe": 123
    },
    "Xerneas": {
        "hp": 126,
        "atk": 131,
        "def": 95,
        "spa": 131,
        "spd": 98,
        "spe": 99
    },
    "Xerneas-Neutral": {
        "hp": 126,
        "atk": 131,
        "def": 95,
        "spa": 131,
        "spd": 98,
        "spe": 99
    },
    "Yveltal": {
        "hp": 126,
        "atk": 131,
        "def": 95,
        "spa": 131,
        "spd": 98,
        "spe": 99
    },
    "Zygarde": {
        "hp": 108,
        "atk": 100,
        "def": 121,
        "spa": 81,
        "spd": 95,
        "spe": 95
    },
    "Zygarde-10%": {
        "hp": 54,
        "atk": 100,
        "def": 71,
        "spa": 61,
        "spd": 85,
        "spe": 115
    },
    "Zygarde-Complete": {
        "hp": 216,
        "atk": 100,
        "def": 121,
        "spa": 91,
        "spd": 95,
        "spe": 85
    },
    "Diancie": {
        "hp": 50,
        "atk": 100,
        "def": 150,
        "spa": 100,
        "spd": 150,
        "spe": 50
    },
    "Diancie-Mega": {
        "hp": 50,
        "atk": 160,
        "def": 110,
        "spa": 160,
        "spd": 110,
        "spe": 110
    },
    "Hoopa": {
        "hp": 80,
        "atk": 110,
        "def": 60,
        "spa": 150,
        "spd": 130,
        "spe": 70
    },
    "Hoopa-Unbound": {
        "hp": 80,
        "atk": 160,
        "def": 60,
        "spa": 170,
        "spd": 130,
        "spe": 80
    },
    "Volcanion": {
        "hp": 80,
        "atk": 110,
        "def": 120,
        "spa": 130,
        "spd": 90,
        "spe": 70
    },
    "Rowlet": {
        "hp": 68,
        "atk": 55,
        "def": 55,
        "spa": 50,
        "spd": 50,
        "spe": 42
    },
    "Dartrix": {
        "hp": 78,
        "atk": 75,
        "def": 75,
        "spa": 70,
        "spd": 70,
        "spe": 52
    },
    "Decidueye": {
        "hp": 78,
        "atk": 107,
        "def": 75,
        "spa": 100,
        "spd": 100,
        "spe": 70
    },
    "Decidueye-Hisui": {
        "hp": 88,
        "atk": 112,
        "def": 80,
        "spa": 95,
        "spd": 95,
        "spe": 60
    },
    "Litten": {
        "hp": 45,
        "atk": 65,
        "def": 40,
        "spa": 60,
        "spd": 40,
        "spe": 70
    },
    "Torracat": {
        "hp": 65,
        "atk": 85,
        "def": 50,
        "spa": 80,
        "spd": 50,
        "spe": 90
    },
    "Incineroar": {
        "hp": 95,
        "atk": 115,
        "def": 90,
        "spa": 80,
        "spd": 90,
        "spe": 60
    },
    "Popplio": {
        "hp": 50,
        "atk": 54,
        "def": 54,
        "spa": 66,
        "spd": 56,
        "spe": 40
    },
    "Brionne": {
        "hp": 60,
        "atk": 69,
        "def": 69,
        "spa": 91,
        "spd": 81,
        "spe": 50
    },
    "Primarina": {
        "hp": 80,
        "atk": 74,
        "def": 74,
        "spa": 126,
        "spd": 116,
        "spe": 60
    },
    "Pikipek": {
        "hp": 35,
        "atk": 75,
        "def": 30,
        "spa": 30,
        "spd": 30,
        "spe": 65
    },
    "Trumbeak": {
        "hp": 55,
        "atk": 85,
        "def": 50,
        "spa": 40,
        "spd": 50,
        "spe": 75
    },
    "Toucannon": {
        "hp": 80,
        "atk": 120,
        "def": 75,
        "spa": 75,
        "spd": 75,
        "spe": 60
    },
    "Yungoos": {
        "hp": 48,
        "atk": 70,
        "def": 30,
        "spa": 30,
        "spd": 30,
        "spe": 45
    },
    "Gumshoos": {
        "hp": 88,
        "atk": 110,
        "def": 60,
        "spa": 55,
        "spd": 60,
        "spe": 45
    },
    "Gumshoos-Totem": {
        "hp": 88,
        "atk": 110,
        "def": 60,
        "spa": 55,
        "spd": 60,
        "spe": 45
    },
    "Grubbin": {
        "hp": 47,
        "atk": 62,
        "def": 45,
        "spa": 55,
        "spd": 45,
        "spe": 46
    },
    "Charjabug": {
        "hp": 57,
        "atk": 82,
        "def": 95,
        "spa": 55,
        "spd": 75,
        "spe": 36
    },
    "Vikavolt": {
        "hp": 77,
        "atk": 70,
        "def": 90,
        "spa": 145,
        "spd": 75,
        "spe": 43
    },
    "Vikavolt-Totem": {
        "hp": 77,
        "atk": 70,
        "def": 90,
        "spa": 145,
        "spd": 75,
        "spe": 43
    },
    "Crabrawler": {
        "hp": 47,
        "atk": 82,
        "def": 57,
        "spa": 42,
        "spd": 47,
        "spe": 63
    },
    "Crabominable": {
        "hp": 97,
        "atk": 132,
        "def": 77,
        "spa": 62,
        "spd": 67,
        "spe": 43
    },
    "Oricorio": {
        "hp": 75,
        "atk": 70,
        "def": 70,
        "spa": 98,
        "spd": 70,
        "spe": 93
    },
    "Oricorio-Pom-Pom": {
        "hp": 75,
        "atk": 70,
        "def": 70,
        "spa": 98,
        "spd": 70,
        "spe": 93
    },
    "Oricorio-Pa'u": {
        "hp": 75,
        "atk": 70,
        "def": 70,
        "spa": 98,
        "spd": 70,
        "spe": 93
    },
    "Oricorio-Sensu": {
        "hp": 75,
        "atk": 70,
        "def": 70,
        "spa": 98,
        "spd": 70,
        "spe": 93
    },
    "Cutiefly": {
        "hp": 40,
        "atk": 45,
        "def": 40,
        "spa": 55,
        "spd": 40,
        "spe": 84
    },
    "Ribombee": {
        "hp": 60,
        "atk": 55,
        "def": 60,
        "spa": 95,
        "spd": 70,
        "spe": 124
    },
    "Ribombee-Totem": {
        "hp": 60,
        "atk": 55,
        "def": 60,
        "spa": 95,
        "spd": 70,
        "spe": 124
    },
    "Rockruff": {
        "hp": 45,
        "atk": 65,
        "def": 40,
        "spa": 30,
        "spd": 40,
        "spe": 60
    },
    "Lycanroc": {
        "hp": 75,
        "atk": 115,
        "def": 65,
        "spa": 55,
        "spd": 65,
        "spe": 112
    },
    "Lycanroc-Midnight": {
        "hp": 85,
        "atk": 115,
        "def": 75,
        "spa": 55,
        "spd": 75,
        "spe": 82
    },
    "Lycanroc-Dusk": {
        "hp": 75,
        "atk": 117,
        "def": 65,
        "spa": 55,
        "spd": 65,
        "spe": 110
    },
    "Wishiwashi": {
        "hp": 45,
        "atk": 20,
        "def": 20,
        "spa": 25,
        "spd": 25,
        "spe": 40
    },
    "Wishiwashi-School": {
        "hp": 45,
        "atk": 140,
        "def": 130,
        "spa": 140,
        "spd": 135,
        "spe": 30
    },
    "Mareanie": {
        "hp": 50,
        "atk": 53,
        "def": 62,
        "spa": 43,
        "spd": 52,
        "spe": 45
    },
    "Toxapex": {
        "hp": 50,
        "atk": 63,
        "def": 152,
        "spa": 53,
        "spd": 142,
        "spe": 35
    },
    "Mudbray": {
        "hp": 70,
        "atk": 100,
        "def": 70,
        "spa": 45,
        "spd": 55,
        "spe": 45
    },
    "Mudsdale": {
        "hp": 100,
        "atk": 125,
        "def": 100,
        "spa": 55,
        "spd": 85,
        "spe": 35
    },
    "Dewpider": {
        "hp": 38,
        "atk": 40,
        "def": 52,
        "spa": 40,
        "spd": 72,
        "spe": 27
    },
    "Araquanid": {
        "hp": 68,
        "atk": 70,
        "def": 92,
        "spa": 50,
        "spd": 132,
        "spe": 42
    },
    "Araquanid-Totem": {
        "hp": 68,
        "atk": 70,
        "def": 92,
        "spa": 50,
        "spd": 132,
        "spe": 42
    },
    "Fomantis": {
        "hp": 40,
        "atk": 55,
        "def": 35,
        "spa": 50,
        "spd": 35,
        "spe": 35
    },
    "Lurantis": {
        "hp": 70,
        "atk": 105,
        "def": 90,
        "spa": 80,
        "spd": 90,
        "spe": 45
    },
    "Lurantis-Totem": {
        "hp": 70,
        "atk": 105,
        "def": 90,
        "spa": 80,
        "spd": 90,
        "spe": 45
    },
    "Morelull": {
        "hp": 40,
        "atk": 35,
        "def": 55,
        "spa": 65,
        "spd": 75,
        "spe": 15
    },
    "Shiinotic": {
        "hp": 60,
        "atk": 45,
        "def": 80,
        "spa": 90,
        "spd": 100,
        "spe": 30
    },
    "Salandit": {
        "hp": 48,
        "atk": 44,
        "def": 40,
        "spa": 71,
        "spd": 40,
        "spe": 77
    },
    "Salazzle": {
        "hp": 68,
        "atk": 64,
        "def": 60,
        "spa": 111,
        "spd": 60,
        "spe": 117
    },
    "Salazzle-Totem": {
        "hp": 68,
        "atk": 64,
        "def": 60,
        "spa": 111,
        "spd": 60,
        "spe": 117
    },
    "Stufful": {
        "hp": 70,
        "atk": 75,
        "def": 50,
        "spa": 45,
        "spd": 50,
        "spe": 50
    },
    "Bewear": {
        "hp": 120,
        "atk": 125,
        "def": 80,
        "spa": 55,
        "spd": 60,
        "spe": 60
    },
    "Bounsweet": {
        "hp": 42,
        "atk": 30,
        "def": 38,
        "spa": 30,
        "spd": 38,
        "spe": 32
    },
    "Steenee": {
        "hp": 52,
        "atk": 40,
        "def": 48,
        "spa": 40,
        "spd": 48,
        "spe": 62
    },
    "Tsareena": {
        "hp": 72,
        "atk": 120,
        "def": 98,
        "spa": 50,
        "spd": 98,
        "spe": 72
    },
    "Comfey": {
        "hp": 51,
        "atk": 52,
        "def": 90,
        "spa": 82,
        "spd": 110,
        "spe": 100
    },
    "Oranguru": {
        "hp": 90,
        "atk": 60,
        "def": 80,
        "spa": 90,
        "spd": 110,
        "spe": 60
    },
    "Passimian": {
        "hp": 100,
        "atk": 120,
        "def": 90,
        "spa": 40,
        "spd": 60,
        "spe": 80
    },
    "Wimpod": {
        "hp": 25,
        "atk": 35,
        "def": 40,
        "spa": 20,
        "spd": 30,
        "spe": 80
    },
    "Golisopod": {
        "hp": 75,
        "atk": 125,
        "def": 140,
        "spa": 60,
        "spd": 90,
        "spe": 40
    },
    "Sandygast": {
        "hp": 55,
        "atk": 55,
        "def": 80,
        "spa": 70,
        "spd": 45,
        "spe": 15
    },
    "Palossand": {
        "hp": 85,
        "atk": 75,
        "def": 110,
        "spa": 100,
        "spd": 75,
        "spe": 35
    },
    "Pyukumuku": {
        "hp": 55,
        "atk": 60,
        "def": 130,
        "spa": 30,
        "spd": 130,
        "spe": 5
    },
    "Type: Null": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 59
    },
    "Silvally": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Silvally-Bug": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Silvally-Dark": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Silvally-Dragon": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Silvally-Electric": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Silvally-Fairy": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Silvally-Fighting": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Silvally-Fire": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Silvally-Flying": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Silvally-Ghost": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Silvally-Grass": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Silvally-Ground": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Silvally-Ice": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Silvally-Poison": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Silvally-Psychic": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Silvally-Rock": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Silvally-Steel": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Silvally-Water": {
        "hp": 95,
        "atk": 95,
        "def": 95,
        "spa": 95,
        "spd": 95,
        "spe": 95
    },
    "Minior": {
        "hp": 60,
        "atk": 100,
        "def": 60,
        "spa": 100,
        "spd": 60,
        "spe": 120
    },
    "Minior-Meteor": {
        "hp": 60,
        "atk": 60,
        "def": 100,
        "spa": 60,
        "spd": 100,
        "spe": 60
    },
    "Komala": {
        "hp": 65,
        "atk": 115,
        "def": 65,
        "spa": 75,
        "spd": 95,
        "spe": 65
    },
    "Turtonator": {
        "hp": 60,
        "atk": 78,
        "def": 135,
        "spa": 91,
        "spd": 85,
        "spe": 36
    },
    "Togedemaru": {
        "hp": 65,
        "atk": 98,
        "def": 63,
        "spa": 40,
        "spd": 73,
        "spe": 96
    },
    "Togedemaru-Totem": {
        "hp": 65,
        "atk": 98,
        "def": 63,
        "spa": 40,
        "spd": 73,
        "spe": 96
    },
    "Mimikyu": {
        "hp": 55,
        "atk": 90,
        "def": 80,
        "spa": 50,
        "spd": 105,
        "spe": 96
    },
    "Mimikyu-Busted": {
        "hp": 55,
        "atk": 90,
        "def": 80,
        "spa": 50,
        "spd": 105,
        "spe": 96
    },
    "Mimikyu-Totem": {
        "hp": 55,
        "atk": 90,
        "def": 80,
        "spa": 50,
        "spd": 105,
        "spe": 96
    },
    "Mimikyu-Busted-Totem": {
        "hp": 55,
        "atk": 90,
        "def": 80,
        "spa": 50,
        "spd": 105,
        "spe": 96
    },
    "Bruxish": {
        "hp": 68,
        "atk": 105,
        "def": 70,
        "spa": 70,
        "spd": 70,
        "spe": 92
    },
    "Drampa": {
        "hp": 78,
        "atk": 60,
        "def": 85,
        "spa": 135,
        "spd": 91,
        "spe": 36
    },
    "Dhelmise": {
        "hp": 70,
        "atk": 131,
        "def": 100,
        "spa": 86,
        "spd": 90,
        "spe": 40
    },
    "Jangmo-o": {
        "hp": 45,
        "atk": 55,
        "def": 65,
        "spa": 45,
        "spd": 45,
        "spe": 45
    },
    "Hakamo-o": {
        "hp": 55,
        "atk": 75,
        "def": 90,
        "spa": 65,
        "spd": 70,
        "spe": 65
    },
    "Kommo-o": {
        "hp": 75,
        "atk": 110,
        "def": 125,
        "spa": 100,
        "spd": 105,
        "spe": 85
    },
    "Kommo-o-Totem": {
        "hp": 75,
        "atk": 110,
        "def": 125,
        "spa": 100,
        "spd": 105,
        "spe": 85
    },
    "Tapu Koko": {
        "hp": 70,
        "atk": 115,
        "def": 85,
        "spa": 95,
        "spd": 75,
        "spe": 130
    },
    "Tapu Lele": {
        "hp": 70,
        "atk": 85,
        "def": 75,
        "spa": 130,
        "spd": 115,
        "spe": 95
    },
    "Tapu Bulu": {
        "hp": 70,
        "atk": 130,
        "def": 115,
        "spa": 85,
        "spd": 95,
        "spe": 75
    },
    "Tapu Fini": {
        "hp": 70,
        "atk": 75,
        "def": 115,
        "spa": 95,
        "spd": 130,
        "spe": 85
    },
    "Cosmog": {
        "hp": 43,
        "atk": 29,
        "def": 31,
        "spa": 29,
        "spd": 31,
        "spe": 37
    },
    "Cosmoem": {
        "hp": 43,
        "atk": 29,
        "def": 131,
        "spa": 29,
        "spd": 131,
        "spe": 37
    },
    "Solgaleo": {
        "hp": 137,
        "atk": 137,
        "def": 107,
        "spa": 113,
        "spd": 89,
        "spe": 97
    },
    "Lunala": {
        "hp": 137,
        "atk": 113,
        "def": 89,
        "spa": 137,
        "spd": 107,
        "spe": 97
    },
    "Nihilego": {
        "hp": 109,
        "atk": 53,
        "def": 47,
        "spa": 127,
        "spd": 131,
        "spe": 103
    },
    "Buzzwole": {
        "hp": 107,
        "atk": 139,
        "def": 139,
        "spa": 53,
        "spd": 53,
        "spe": 79
    },
    "Pheromosa": {
        "hp": 71,
        "atk": 137,
        "def": 37,
        "spa": 137,
        "spd": 37,
        "spe": 151
    },
    "Xurkitree": {
        "hp": 83,
        "atk": 89,
        "def": 71,
        "spa": 173,
        "spd": 71,
        "spe": 83
    },
    "Celesteela": {
        "hp": 97,
        "atk": 101,
        "def": 103,
        "spa": 107,
        "spd": 101,
        "spe": 61
    },
    "Kartana": {
        "hp": 59,
        "atk": 181,
        "def": 131,
        "spa": 59,
        "spd": 31,
        "spe": 109
    },
    "Guzzlord": {
        "hp": 223,
        "atk": 101,
        "def": 53,
        "spa": 97,
        "spd": 53,
        "spe": 43
    },
    "Necrozma": {
        "hp": 97,
        "atk": 107,
        "def": 101,
        "spa": 127,
        "spd": 89,
        "spe": 79
    },
    "Necrozma-Dusk-Mane": {
        "hp": 97,
        "atk": 157,
        "def": 127,
        "spa": 113,
        "spd": 109,
        "spe": 77
    },
    "Necrozma-Dawn-Wings": {
        "hp": 97,
        "atk": 113,
        "def": 109,
        "spa": 157,
        "spd": 127,
        "spe": 77
    },
    "Necrozma-Ultra": {
        "hp": 97,
        "atk": 167,
        "def": 97,
        "spa": 167,
        "spd": 97,
        "spe": 129
    },
    "Magearna": {
        "hp": 80,
        "atk": 95,
        "def": 115,
        "spa": 130,
        "spd": 115,
        "spe": 65
    },
    "Magearna-Original": {
        "hp": 80,
        "atk": 95,
        "def": 115,
        "spa": 130,
        "spd": 115,
        "spe": 65
    },
    "Marshadow": {
        "hp": 90,
        "atk": 125,
        "def": 80,
        "spa": 90,
        "spd": 90,
        "spe": 125
    },
    "Poipole": {
        "hp": 67,
        "atk": 73,
        "def": 67,
        "spa": 73,
        "spd": 67,
        "spe": 73
    },
    "Naganadel": {
        "hp": 73,
        "atk": 73,
        "def": 73,
        "spa": 127,
        "spd": 73,
        "spe": 121
    },
    "Stakataka": {
        "hp": 61,
        "atk": 131,
        "def": 211,
        "spa": 53,
        "spd": 101,
        "spe": 13
    },
    "Blacephalon": {
        "hp": 53,
        "atk": 127,
        "def": 53,
        "spa": 151,
        "spd": 79,
        "spe": 107
    },
    "Zeraora": {
        "hp": 88,
        "atk": 112,
        "def": 75,
        "spa": 102,
        "spd": 80,
        "spe": 143
    },
    "Meltan": {
        "hp": 46,
        "atk": 65,
        "def": 65,
        "spa": 55,
        "spd": 35,
        "spe": 34
    },
    "Melmetal": {
        "hp": 135,
        "atk": 143,
        "def": 143,
        "spa": 80,
        "spd": 65,
        "spe": 34
    },
    "Melmetal-Gmax": {
        "hp": 135,
        "atk": 143,
        "def": 143,
        "spa": 80,
        "spd": 65,
        "spe": 34
    },
    "Grookey": {
        "hp": 50,
        "atk": 65,
        "def": 50,
        "spa": 40,
        "spd": 40,
        "spe": 65
    },
    "Thwackey": {
        "hp": 70,
        "atk": 85,
        "def": 70,
        "spa": 55,
        "spd": 60,
        "spe": 80
    },
    "Rillaboom": {
        "hp": 100,
        "atk": 125,
        "def": 90,
        "spa": 60,
        "spd": 70,
        "spe": 85
    },
    "Rillaboom-Gmax": {
        "hp": 100,
        "atk": 125,
        "def": 90,
        "spa": 60,
        "spd": 70,
        "spe": 85
    },
    "Scorbunny": {
        "hp": 50,
        "atk": 71,
        "def": 40,
        "spa": 40,
        "spd": 40,
        "spe": 69
    },
    "Raboot": {
        "hp": 65,
        "atk": 86,
        "def": 60,
        "spa": 55,
        "spd": 60,
        "spe": 94
    },
    "Cinderace": {
        "hp": 80,
        "atk": 116,
        "def": 75,
        "spa": 65,
        "spd": 75,
        "spe": 119
    },
    "Cinderace-Gmax": {
        "hp": 80,
        "atk": 116,
        "def": 75,
        "spa": 65,
        "spd": 75,
        "spe": 119
    },
    "Sobble": {
        "hp": 50,
        "atk": 40,
        "def": 40,
        "spa": 70,
        "spd": 40,
        "spe": 70
    },
    "Drizzile": {
        "hp": 65,
        "atk": 60,
        "def": 55,
        "spa": 95,
        "spd": 55,
        "spe": 90
    },
    "Inteleon": {
        "hp": 70,
        "atk": 85,
        "def": 65,
        "spa": 125,
        "spd": 65,
        "spe": 120
    },
    "Inteleon-Gmax": {
        "hp": 70,
        "atk": 85,
        "def": 65,
        "spa": 125,
        "spd": 65,
        "spe": 120
    },
    "Skwovet": {
        "hp": 70,
        "atk": 55,
        "def": 55,
        "spa": 35,
        "spd": 35,
        "spe": 25
    },
    "Greedent": {
        "hp": 120,
        "atk": 95,
        "def": 95,
        "spa": 55,
        "spd": 75,
        "spe": 20
    },
    "Rookidee": {
        "hp": 38,
        "atk": 47,
        "def": 35,
        "spa": 33,
        "spd": 35,
        "spe": 57
    },
    "Corvisquire": {
        "hp": 68,
        "atk": 67,
        "def": 55,
        "spa": 43,
        "spd": 55,
        "spe": 77
    },
    "Corviknight": {
        "hp": 98,
        "atk": 87,
        "def": 105,
        "spa": 53,
        "spd": 85,
        "spe": 67
    },
    "Corviknight-Gmax": {
        "hp": 98,
        "atk": 87,
        "def": 105,
        "spa": 53,
        "spd": 85,
        "spe": 67
    },
    "Blipbug": {
        "hp": 25,
        "atk": 20,
        "def": 20,
        "spa": 25,
        "spd": 45,
        "spe": 45
    },
    "Dottler": {
        "hp": 50,
        "atk": 35,
        "def": 80,
        "spa": 50,
        "spd": 90,
        "spe": 30
    },
    "Orbeetle": {
        "hp": 60,
        "atk": 45,
        "def": 110,
        "spa": 80,
        "spd": 120,
        "spe": 90
    },
    "Orbeetle-Gmax": {
        "hp": 60,
        "atk": 45,
        "def": 110,
        "spa": 80,
        "spd": 120,
        "spe": 90
    },
    "Nickit": {
        "hp": 40,
        "atk": 28,
        "def": 28,
        "spa": 47,
        "spd": 52,
        "spe": 50
    },
    "Thievul": {
        "hp": 70,
        "atk": 58,
        "def": 58,
        "spa": 87,
        "spd": 92,
        "spe": 90
    },
    "Gossifleur": {
        "hp": 40,
        "atk": 40,
        "def": 60,
        "spa": 40,
        "spd": 60,
        "spe": 10
    },
    "Eldegoss": {
        "hp": 60,
        "atk": 50,
        "def": 90,
        "spa": 80,
        "spd": 120,
        "spe": 60
    },
    "Wooloo": {
        "hp": 42,
        "atk": 40,
        "def": 55,
        "spa": 40,
        "spd": 45,
        "spe": 48
    },
    "Dubwool": {
        "hp": 72,
        "atk": 80,
        "def": 100,
        "spa": 60,
        "spd": 90,
        "spe": 88
    },
    "Chewtle": {
        "hp": 50,
        "atk": 64,
        "def": 50,
        "spa": 38,
        "spd": 38,
        "spe": 44
    },
    "Drednaw": {
        "hp": 90,
        "atk": 115,
        "def": 90,
        "spa": 48,
        "spd": 68,
        "spe": 74
    },
    "Drednaw-Gmax": {
        "hp": 90,
        "atk": 115,
        "def": 90,
        "spa": 48,
        "spd": 68,
        "spe": 74
    },
    "Yamper": {
        "hp": 59,
        "atk": 45,
        "def": 50,
        "spa": 40,
        "spd": 50,
        "spe": 26
    },
    "Boltund": {
        "hp": 69,
        "atk": 90,
        "def": 60,
        "spa": 90,
        "spd": 60,
        "spe": 121
    },
    "Rolycoly": {
        "hp": 30,
        "atk": 40,
        "def": 50,
        "spa": 40,
        "spd": 50,
        "spe": 30
    },
    "Carkol": {
        "hp": 80,
        "atk": 60,
        "def": 90,
        "spa": 60,
        "spd": 70,
        "spe": 50
    },
    "Coalossal": {
        "hp": 110,
        "atk": 80,
        "def": 120,
        "spa": 80,
        "spd": 90,
        "spe": 30
    },
    "Coalossal-Gmax": {
        "hp": 110,
        "atk": 80,
        "def": 120,
        "spa": 80,
        "spd": 90,
        "spe": 30
    },
    "Applin": {
        "hp": 40,
        "atk": 40,
        "def": 80,
        "spa": 40,
        "spd": 40,
        "spe": 20
    },
    "Flapple": {
        "hp": 70,
        "atk": 110,
        "def": 80,
        "spa": 95,
        "spd": 60,
        "spe": 70
    },
    "Flapple-Gmax": {
        "hp": 70,
        "atk": 110,
        "def": 80,
        "spa": 95,
        "spd": 60,
        "spe": 70
    },
    "Appletun": {
        "hp": 110,
        "atk": 85,
        "def": 80,
        "spa": 100,
        "spd": 80,
        "spe": 30
    },
    "Appletun-Gmax": {
        "hp": 110,
        "atk": 85,
        "def": 80,
        "spa": 100,
        "spd": 80,
        "spe": 30
    },
    "Silicobra": {
        "hp": 52,
        "atk": 57,
        "def": 75,
        "spa": 35,
        "spd": 50,
        "spe": 46
    },
    "Sandaconda": {
        "hp": 72,
        "atk": 107,
        "def": 125,
        "spa": 65,
        "spd": 70,
        "spe": 71
    },
    "Sandaconda-Gmax": {
        "hp": 72,
        "atk": 107,
        "def": 125,
        "spa": 65,
        "spd": 70,
        "spe": 71
    },
    "Cramorant": {
        "hp": 70,
        "atk": 85,
        "def": 55,
        "spa": 85,
        "spd": 95,
        "spe": 85
    },
    "Cramorant-Gulping": {
        "hp": 70,
        "atk": 85,
        "def": 55,
        "spa": 85,
        "spd": 95,
        "spe": 85
    },
    "Cramorant-Gorging": {
        "hp": 70,
        "atk": 85,
        "def": 55,
        "spa": 85,
        "spd": 95,
        "spe": 85
    },
    "Arrokuda": {
        "hp": 41,
        "atk": 63,
        "def": 40,
        "spa": 40,
        "spd": 30,
        "spe": 66
    },
    "Barraskewda": {
        "hp": 61,
        "atk": 123,
        "def": 60,
        "spa": 60,
        "spd": 50,
        "spe": 136
    },
    "Toxel": {
        "hp": 40,
        "atk": 38,
        "def": 35,
        "spa": 54,
        "spd": 35,
        "spe": 40
    },
    "Toxtricity": {
        "hp": 75,
        "atk": 98,
        "def": 70,
        "spa": 114,
        "spd": 70,
        "spe": 75
    },
    "Toxtricity-Low-Key": {
        "hp": 75,
        "atk": 98,
        "def": 70,
        "spa": 114,
        "spd": 70,
        "spe": 75
    },
    "Toxtricity-Gmax": {
        "hp": 75,
        "atk": 98,
        "def": 70,
        "spa": 114,
        "spd": 70,
        "spe": 75
    },
    "Toxtricity-Low-Key-Gmax": {
        "hp": 75,
        "atk": 98,
        "def": 70,
        "spa": 114,
        "spd": 70,
        "spe": 75
    },
    "Sizzlipede": {
        "hp": 50,
        "atk": 65,
        "def": 45,
        "spa": 50,
        "spd": 50,
        "spe": 45
    },
    "Centiskorch": {
        "hp": 100,
        "atk": 115,
        "def": 65,
        "spa": 90,
        "spd": 90,
        "spe": 65
    },
    "Centiskorch-Gmax": {
        "hp": 100,
        "atk": 115,
        "def": 65,
        "spa": 90,
        "spd": 90,
        "spe": 65
    },
    "Clobbopus": {
        "hp": 50,
        "atk": 68,
        "def": 60,
        "spa": 50,
        "spd": 50,
        "spe": 32
    },
    "Grapploct": {
        "hp": 80,
        "atk": 118,
        "def": 90,
        "spa": 70,
        "spd": 80,
        "spe": 42
    },
    "Sinistea": {
        "hp": 40,
        "atk": 45,
        "def": 45,
        "spa": 74,
        "spd": 54,
        "spe": 50
    },
    "Sinistea-Antique": {
        "hp": 40,
        "atk": 45,
        "def": 45,
        "spa": 74,
        "spd": 54,
        "spe": 50
    },
    "Polteageist": {
        "hp": 60,
        "atk": 65,
        "def": 65,
        "spa": 134,
        "spd": 114,
        "spe": 70
    },
    "Polteageist-Antique": {
        "hp": 60,
        "atk": 65,
        "def": 65,
        "spa": 134,
        "spd": 114,
        "spe": 70
    },
    "Hatenna": {
        "hp": 42,
        "atk": 30,
        "def": 45,
        "spa": 56,
        "spd": 53,
        "spe": 39
    },
    "Hattrem": {
        "hp": 57,
        "atk": 40,
        "def": 65,
        "spa": 86,
        "spd": 73,
        "spe": 49
    },
    "Hatterene": {
        "hp": 57,
        "atk": 90,
        "def": 95,
        "spa": 136,
        "spd": 103,
        "spe": 29
    },
    "Hatterene-Gmax": {
        "hp": 57,
        "atk": 90,
        "def": 95,
        "spa": 136,
        "spd": 103,
        "spe": 29
    },
    "Impidimp": {
        "hp": 45,
        "atk": 45,
        "def": 30,
        "spa": 55,
        "spd": 40,
        "spe": 50
    },
    "Morgrem": {
        "hp": 65,
        "atk": 60,
        "def": 45,
        "spa": 75,
        "spd": 55,
        "spe": 70
    },
    "Grimmsnarl": {
        "hp": 95,
        "atk": 120,
        "def": 65,
        "spa": 95,
        "spd": 75,
        "spe": 60
    },
    "Grimmsnarl-Gmax": {
        "hp": 95,
        "atk": 120,
        "def": 65,
        "spa": 95,
        "spd": 75,
        "spe": 60
    },
    "Obstagoon": {
        "hp": 93,
        "atk": 90,
        "def": 101,
        "spa": 60,
        "spd": 81,
        "spe": 95
    },
    "Perrserker": {
        "hp": 70,
        "atk": 110,
        "def": 100,
        "spa": 50,
        "spd": 60,
        "spe": 50
    },
    "Cursola": {
        "hp": 60,
        "atk": 95,
        "def": 50,
        "spa": 145,
        "spd": 130,
        "spe": 30
    },
    "Sirfetch\u2019d": {
        "hp": 62,
        "atk": 135,
        "def": 95,
        "spa": 68,
        "spd": 82,
        "spe": 65
    },
    "Mr. Rime": {
        "hp": 80,
        "atk": 85,
        "def": 75,
        "spa": 110,
        "spd": 100,
        "spe": 70
    },
    "Runerigus": {
        "hp": 58,
        "atk": 95,
        "def": 145,
        "spa": 50,
        "spd": 105,
        "spe": 30
    },
    "Milcery": {
        "hp": 45,
        "atk": 40,
        "def": 40,
        "spa": 50,
        "spd": 61,
        "spe": 34
    },
    "Alcremie": {
        "hp": 65,
        "atk": 60,
        "def": 75,
        "spa": 110,
        "spd": 121,
        "spe": 64
    },
    "Alcremie-Gmax": {
        "hp": 65,
        "atk": 60,
        "def": 75,
        "spa": 110,
        "spd": 121,
        "spe": 64
    },
    "Falinks": {
        "hp": 65,
        "atk": 100,
        "def": 100,
        "spa": 70,
        "spd": 60,
        "spe": 75
    },
    "Pincurchin": {
        "hp": 48,
        "atk": 101,
        "def": 95,
        "spa": 91,
        "spd": 85,
        "spe": 15
    },
    "Snom": {
        "hp": 30,
        "atk": 25,
        "def": 35,
        "spa": 45,
        "spd": 30,
        "spe": 20
    },
    "Frosmoth": {
        "hp": 70,
        "atk": 65,
        "def": 60,
        "spa": 125,
        "spd": 90,
        "spe": 65
    },
    "Stonjourner": {
        "hp": 100,
        "atk": 125,
        "def": 135,
        "spa": 20,
        "spd": 20,
        "spe": 70
    },
    "Eiscue": {
        "hp": 75,
        "atk": 80,
        "def": 110,
        "spa": 65,
        "spd": 90,
        "spe": 50
    },
    "Eiscue-Noice": {
        "hp": 75,
        "atk": 80,
        "def": 70,
        "spa": 65,
        "spd": 50,
        "spe": 130
    },
    "Indeedee": {
        "hp": 60,
        "atk": 65,
        "def": 55,
        "spa": 105,
        "spd": 95,
        "spe": 95
    },
    "Indeedee-F": {
        "hp": 70,
        "atk": 55,
        "def": 65,
        "spa": 95,
        "spd": 105,
        "spe": 85
    },
    "Morpeko": {
        "hp": 58,
        "atk": 95,
        "def": 58,
        "spa": 70,
        "spd": 58,
        "spe": 97
    },
    "Morpeko-Hangry": {
        "hp": 58,
        "atk": 95,
        "def": 58,
        "spa": 70,
        "spd": 58,
        "spe": 97
    },
    "Cufant": {
        "hp": 72,
        "atk": 80,
        "def": 49,
        "spa": 40,
        "spd": 49,
        "spe": 40
    },
    "Copperajah": {
        "hp": 122,
        "atk": 130,
        "def": 69,
        "spa": 80,
        "spd": 69,
        "spe": 30
    },
    "Copperajah-Gmax": {
        "hp": 122,
        "atk": 130,
        "def": 69,
        "spa": 80,
        "spd": 69,
        "spe": 30
    },
    "Dracozolt": {
        "hp": 90,
        "atk": 100,
        "def": 90,
        "spa": 80,
        "spd": 70,
        "spe": 75
    },
    "Arctozolt": {
        "hp": 90,
        "atk": 100,
        "def": 90,
        "spa": 90,
        "spd": 80,
        "spe": 55
    },
    "Dracovish": {
        "hp": 90,
        "atk": 90,
        "def": 100,
        "spa": 70,
        "spd": 80,
        "spe": 75
    },
    "Arctovish": {
        "hp": 90,
        "atk": 90,
        "def": 100,
        "spa": 80,
        "spd": 90,
        "spe": 55
    },
    "Duraludon": {
        "hp": 70,
        "atk": 95,
        "def": 115,
        "spa": 120,
        "spd": 50,
        "spe": 85
    },
    "Duraludon-Gmax": {
        "hp": 70,
        "atk": 95,
        "def": 115,
        "spa": 120,
        "spd": 50,
        "spe": 85
    },
    "Dreepy": {
        "hp": 28,
        "atk": 60,
        "def": 30,
        "spa": 40,
        "spd": 30,
        "spe": 82
    },
    "Drakloak": {
        "hp": 68,
        "atk": 80,
        "def": 50,
        "spa": 60,
        "spd": 50,
        "spe": 102
    },
    "Dragapult": {
        "hp": 88,
        "atk": 120,
        "def": 75,
        "spa": 100,
        "spd": 75,
        "spe": 142
    },
    "Zacian": {
        "hp": 92,
        "atk": 120,
        "def": 115,
        "spa": 80,
        "spd": 115,
        "spe": 138
    },
    "Zacian-Crowned": {
        "hp": 92,
        "atk": 150,
        "def": 115,
        "spa": 80,
        "spd": 115,
        "spe": 148
    },
    "Zamazenta": {
        "hp": 92,
        "atk": 120,
        "def": 115,
        "spa": 80,
        "spd": 115,
        "spe": 138
    },
    "Zamazenta-Crowned": {
        "hp": 92,
        "atk": 120,
        "def": 140,
        "spa": 80,
        "spd": 140,
        "spe": 128
    },
    "Eternatus": {
        "hp": 140,
        "atk": 85,
        "def": 95,
        "spa": 145,
        "spd": 95,
        "spe": 130
    },
    "Eternatus-Eternamax": {
        "hp": 255,
        "atk": 115,
        "def": 250,
        "spa": 125,
        "spd": 250,
        "spe": 130
    },
    "Kubfu": {
        "hp": 60,
        "atk": 90,
        "def": 60,
        "spa": 53,
        "spd": 50,
        "spe": 72
    },
    "Urshifu": {
        "hp": 100,
        "atk": 130,
        "def": 100,
        "spa": 63,
        "spd": 60,
        "spe": 97
    },
    "Urshifu-Rapid-Strike": {
        "hp": 100,
        "atk": 130,
        "def": 100,
        "spa": 63,
        "spd": 60,
        "spe": 97
    },
    "Urshifu-Gmax": {
        "hp": 100,
        "atk": 130,
        "def": 100,
        "spa": 63,
        "spd": 60,
        "spe": 97
    },
    "Urshifu-Rapid-Strike-Gmax": {
        "hp": 100,
        "atk": 130,
        "def": 100,
        "spa": 63,
        "spd": 60,
        "spe": 97
    },
    "Zarude": {
        "hp": 105,
        "atk": 120,
        "def": 105,
        "spa": 70,
        "spd": 95,
        "spe": 105
    },
    "Zarude-Dada": {
        "hp": 105,
        "atk": 120,
        "def": 105,
        "spa": 70,
        "spd": 95,
        "spe": 105
    },
    "Regieleki": {
        "hp": 80,
        "atk": 100,
        "def": 50,
        "spa": 100,
        "spd": 50,
        "spe": 200
    },
    "Regidrago": {
        "hp": 200,
        "atk": 100,
        "def": 50,
        "spa": 100,
        "spd": 50,
        "spe": 80
    },
    "Glastrier": {
        "hp": 100,
        "atk": 145,
        "def": 130,
        "spa": 65,
        "spd": 110,
        "spe": 30
    },
    "Spectrier": {
        "hp": 100,
        "atk": 65,
        "def": 60,
        "spa": 145,
        "spd": 80,
        "spe": 130
    },
    "Calyrex": {
        "hp": 100,
        "atk": 80,
        "def": 80,
        "spa": 80,
        "spd": 80,
        "spe": 80
    },
    "Calyrex-Ice": {
        "hp": 100,
        "atk": 165,
        "def": 150,
        "spa": 85,
        "spd": 130,
        "spe": 50
    },
    "Calyrex-Shadow": {
        "hp": 100,
        "atk": 85,
        "def": 80,
        "spa": 165,
        "spd": 100,
        "spe": 150
    },
    "Wyrdeer": {
        "hp": 103,
        "atk": 105,
        "def": 72,
        "spa": 105,
        "spd": 75,
        "spe": 65
    },
    "Kleavor": {
        "hp": 70,
        "atk": 135,
        "def": 95,
        "spa": 45,
        "spd": 70,
        "spe": 85
    },
    "Ursaluna": {
        "hp": 130,
        "atk": 140,
        "def": 105,
        "spa": 45,
        "spd": 80,
        "spe": 50
    },
    "Ursaluna-Bloodmoon": {
        "hp": 113,
        "atk": 70,
        "def": 120,
        "spa": 135,
        "spd": 65,
        "spe": 52
    },
    "Basculegion": {
        "hp": 120,
        "atk": 112,
        "def": 65,
        "spa": 80,
        "spd": 75,
        "spe": 78
    },
    "Basculegion-F": {
        "hp": 120,
        "atk": 92,
        "def": 65,
        "spa": 100,
        "spd": 75,
        "spe": 78
    },
    "Sneasler": {
        "hp": 80,
        "atk": 130,
        "def": 60,
        "spa": 40,
        "spd": 80,
        "spe": 120
    },
    "Overqwil": {
        "hp": 85,
        "atk": 115,
        "def": 95,
        "spa": 65,
        "spd": 65,
        "spe": 85
    },
    "Enamorus": {
        "hp": 74,
        "atk": 115,
        "def": 70,
        "spa": 135,
        "spd": 80,
        "spe": 106
    },
    "Enamorus-Therian": {
        "hp": 74,
        "atk": 115,
        "def": 110,
        "spa": 135,
        "spd": 100,
        "spe": 46
    },
    "Sprigatito": {
        "hp": 40,
        "atk": 61,
        "def": 54,
        "spa": 45,
        "spd": 45,
        "spe": 65
    },
    "Floragato": {
        "hp": 61,
        "atk": 80,
        "def": 63,
        "spa": 60,
        "spd": 63,
        "spe": 83
    },
    "Meowscarada": {
        "hp": 76,
        "atk": 110,
        "def": 70,
        "spa": 81,
        "spd": 70,
        "spe": 123
    },
    "Fuecoco": {
        "hp": 67,
        "atk": 45,
        "def": 59,
        "spa": 63,
        "spd": 40,
        "spe": 36
    },
    "Crocalor": {
        "hp": 81,
        "atk": 55,
        "def": 78,
        "spa": 90,
        "spd": 58,
        "spe": 49
    },
    "Skeledirge": {
        "hp": 104,
        "atk": 75,
        "def": 100,
        "spa": 110,
        "spd": 75,
        "spe": 66
    },
    "Quaxly": {
        "hp": 55,
        "atk": 65,
        "def": 45,
        "spa": 50,
        "spd": 45,
        "spe": 50
    },
    "Quaxwell": {
        "hp": 70,
        "atk": 85,
        "def": 65,
        "spa": 65,
        "spd": 60,
        "spe": 65
    },
    "Quaquaval": {
        "hp": 85,
        "atk": 120,
        "def": 80,
        "spa": 85,
        "spd": 75,
        "spe": 85
    },
    "Lechonk": {
        "hp": 54,
        "atk": 45,
        "def": 40,
        "spa": 35,
        "spd": 45,
        "spe": 35
    },
    "Oinkologne": {
        "hp": 110,
        "atk": 100,
        "def": 75,
        "spa": 59,
        "spd": 80,
        "spe": 65
    },
    "Oinkologne-F": {
        "hp": 115,
        "atk": 90,
        "def": 70,
        "spa": 59,
        "spd": 90,
        "spe": 65
    },
    "Tarountula": {
        "hp": 35,
        "atk": 41,
        "def": 45,
        "spa": 29,
        "spd": 40,
        "spe": 20
    },
    "Spidops": {
        "hp": 60,
        "atk": 79,
        "def": 92,
        "spa": 52,
        "spd": 86,
        "spe": 35
    },
    "Nymble": {
        "hp": 33,
        "atk": 46,
        "def": 40,
        "spa": 21,
        "spd": 25,
        "spe": 45
    },
    "Lokix": {
        "hp": 71,
        "atk": 102,
        "def": 78,
        "spa": 52,
        "spd": 55,
        "spe": 92
    },
    "Pawmi": {
        "hp": 45,
        "atk": 50,
        "def": 20,
        "spa": 40,
        "spd": 25,
        "spe": 60
    },
    "Pawmo": {
        "hp": 60,
        "atk": 75,
        "def": 40,
        "spa": 50,
        "spd": 40,
        "spe": 85
    },
    "Pawmot": {
        "hp": 70,
        "atk": 115,
        "def": 70,
        "spa": 70,
        "spd": 60,
        "spe": 105
    },
    "Tandemaus": {
        "hp": 50,
        "atk": 50,
        "def": 45,
        "spa": 40,
        "spd": 45,
        "spe": 75
    },
    "Maushold": {
        "hp": 74,
        "atk": 75,
        "def": 70,
        "spa": 65,
        "spd": 75,
        "spe": 111
    },
    "Maushold-Four": {
        "hp": 74,
        "atk": 75,
        "def": 70,
        "spa": 65,
        "spd": 75,
        "spe": 111
    },
    "Fidough": {
        "hp": 37,
        "atk": 55,
        "def": 70,
        "spa": 30,
        "spd": 55,
        "spe": 65
    },
    "Dachsbun": {
        "hp": 57,
        "atk": 80,
        "def": 115,
        "spa": 50,
        "spd": 80,
        "spe": 95
    },
    "Smoliv": {
        "hp": 41,
        "atk": 35,
        "def": 45,
        "spa": 58,
        "spd": 51,
        "spe": 30
    },
    "Dolliv": {
        "hp": 52,
        "atk": 53,
        "def": 60,
        "spa": 78,
        "spd": 78,
        "spe": 33
    },
    "Arboliva": {
        "hp": 78,
        "atk": 69,
        "def": 90,
        "spa": 125,
        "spd": 109,
        "spe": 39
    },
    "Squawkabilly": {
        "hp": 82,
        "atk": 96,
        "def": 51,
        "spa": 45,
        "spd": 51,
        "spe": 92
    },
    "Squawkabilly-Blue": {
        "hp": 82,
        "atk": 96,
        "def": 51,
        "spa": 45,
        "spd": 51,
        "spe": 92
    },
    "Squawkabilly-Yellow": {
        "hp": 82,
        "atk": 96,
        "def": 51,
        "spa": 45,
        "spd": 51,
        "spe": 92
    },
    "Squawkabilly-White": {
        "hp": 82,
        "atk": 96,
        "def": 51,
        "spa": 45,
        "spd": 51,
        "spe": 92
    },
    "Nacli": {
        "hp": 55,
        "atk": 55,
        "def": 75,
        "spa": 35,
        "spd": 35,
        "spe": 25
    },
    "Naclstack": {
        "hp": 60,
        "atk": 60,
        "def": 100,
        "spa": 35,
        "spd": 65,
        "spe": 35
    },
    "Garganacl": {
        "hp": 100,
        "atk": 100,
        "def": 130,
        "spa": 45,
        "spd": 90,
        "spe": 35
    },
    "Charcadet": {
        "hp": 40,
        "atk": 50,
        "def": 40,
        "spa": 50,
        "spd": 40,
        "spe": 35
    },
    "Armarouge": {
        "hp": 85,
        "atk": 60,
        "def": 100,
        "spa": 125,
        "spd": 80,
        "spe": 75
    },
    "Ceruledge": {
        "hp": 75,
        "atk": 125,
        "def": 80,
        "spa": 60,
        "spd": 100,
        "spe": 85
    },
    "Tadbulb": {
        "hp": 61,
        "atk": 31,
        "def": 41,
        "spa": 59,
        "spd": 35,
        "spe": 45
    },
    "Bellibolt": {
        "hp": 109,
        "atk": 64,
        "def": 91,
        "spa": 103,
        "spd": 83,
        "spe": 45
    },
    "Wattrel": {
        "hp": 40,
        "atk": 40,
        "def": 35,
        "spa": 55,
        "spd": 40,
        "spe": 70
    },
    "Kilowattrel": {
        "hp": 70,
        "atk": 70,
        "def": 60,
        "spa": 105,
        "spd": 60,
        "spe": 125
    },
    "Maschiff": {
        "hp": 60,
        "atk": 78,
        "def": 60,
        "spa": 40,
        "spd": 51,
        "spe": 51
    },
    "Mabosstiff": {
        "hp": 80,
        "atk": 120,
        "def": 90,
        "spa": 60,
        "spd": 70,
        "spe": 85
    },
    "Shroodle": {
        "hp": 40,
        "atk": 65,
        "def": 35,
        "spa": 40,
        "spd": 35,
        "spe": 75
    },
    "Grafaiai": {
        "hp": 63,
        "atk": 95,
        "def": 65,
        "spa": 80,
        "spd": 72,
        "spe": 110
    },
    "Bramblin": {
        "hp": 40,
        "atk": 65,
        "def": 30,
        "spa": 45,
        "spd": 35,
        "spe": 60
    },
    "Brambleghast": {
        "hp": 55,
        "atk": 115,
        "def": 70,
        "spa": 80,
        "spd": 70,
        "spe": 90
    },
    "Toedscool": {
        "hp": 40,
        "atk": 40,
        "def": 35,
        "spa": 50,
        "spd": 100,
        "spe": 70
    },
    "Toedscruel": {
        "hp": 80,
        "atk": 70,
        "def": 65,
        "spa": 80,
        "spd": 120,
        "spe": 100
    },
    "Klawf": {
        "hp": 70,
        "atk": 100,
        "def": 115,
        "spa": 35,
        "spd": 55,
        "spe": 75
    },
    "Capsakid": {
        "hp": 50,
        "atk": 62,
        "def": 40,
        "spa": 62,
        "spd": 40,
        "spe": 50
    },
    "Scovillain": {
        "hp": 65,
        "atk": 108,
        "def": 65,
        "spa": 108,
        "spd": 65,
        "spe": 75
    },
    "Rellor": {
        "hp": 41,
        "atk": 50,
        "def": 60,
        "spa": 31,
        "spd": 58,
        "spe": 30
    },
    "Rabsca": {
        "hp": 75,
        "atk": 50,
        "def": 85,
        "spa": 115,
        "spd": 100,
        "spe": 45
    },
    "Flittle": {
        "hp": 30,
        "atk": 35,
        "def": 30,
        "spa": 55,
        "spd": 30,
        "spe": 75
    },
    "Espathra": {
        "hp": 95,
        "atk": 60,
        "def": 60,
        "spa": 101,
        "spd": 60,
        "spe": 105
    },
    "Tinkatink": {
        "hp": 50,
        "atk": 45,
        "def": 45,
        "spa": 35,
        "spd": 64,
        "spe": 58
    },
    "Tinkatuff": {
        "hp": 65,
        "atk": 55,
        "def": 55,
        "spa": 45,
        "spd": 82,
        "spe": 78
    },
    "Tinkaton": {
        "hp": 85,
        "atk": 75,
        "def": 77,
        "spa": 70,
        "spd": 105,
        "spe": 94
    },
    "Wiglett": {
        "hp": 10,
        "atk": 55,
        "def": 25,
        "spa": 35,
        "spd": 25,
        "spe": 95
    },
    "Wugtrio": {
        "hp": 35,
        "atk": 100,
        "def": 50,
        "spa": 50,
        "spd": 70,
        "spe": 120
    },
    "Bombirdier": {
        "hp": 70,
        "atk": 103,
        "def": 85,
        "spa": 60,
        "spd": 85,
        "spe": 82
    },
    "Finizen": {
        "hp": 70,
        "atk": 45,
        "def": 40,
        "spa": 45,
        "spd": 40,
        "spe": 75
    },
    "Palafin": {
        "hp": 100,
        "atk": 70,
        "def": 72,
        "spa": 53,
        "spd": 62,
        "spe": 100
    },
    "Palafin-Hero": {
        "hp": 100,
        "atk": 160,
        "def": 97,
        "spa": 106,
        "spd": 87,
        "spe": 100
    },
    "Varoom": {
        "hp": 45,
        "atk": 70,
        "def": 63,
        "spa": 30,
        "spd": 45,
        "spe": 47
    },
    "Revavroom": {
        "hp": 80,
        "atk": 119,
        "def": 90,
        "spa": 54,
        "spd": 67,
        "spe": 90
    },
    "Cyclizar": {
        "hp": 70,
        "atk": 95,
        "def": 65,
        "spa": 85,
        "spd": 65,
        "spe": 121
    },
    "Orthworm": {
        "hp": 70,
        "atk": 85,
        "def": 145,
        "spa": 60,
        "spd": 55,
        "spe": 65
    },
    "Glimmet": {
        "hp": 48,
        "atk": 35,
        "def": 42,
        "spa": 105,
        "spd": 60,
        "spe": 60
    },
    "Glimmora": {
        "hp": 83,
        "atk": 55,
        "def": 90,
        "spa": 130,
        "spd": 81,
        "spe": 86
    },
    "Greavard": {
        "hp": 50,
        "atk": 61,
        "def": 60,
        "spa": 30,
        "spd": 55,
        "spe": 34
    },
    "Houndstone": {
        "hp": 72,
        "atk": 101,
        "def": 100,
        "spa": 50,
        "spd": 97,
        "spe": 68
    },
    "Flamigo": {
        "hp": 82,
        "atk": 115,
        "def": 74,
        "spa": 75,
        "spd": 64,
        "spe": 90
    },
    "Cetoddle": {
        "hp": 108,
        "atk": 68,
        "def": 45,
        "spa": 30,
        "spd": 40,
        "spe": 43
    },
    "Cetitan": {
        "hp": 170,
        "atk": 113,
        "def": 65,
        "spa": 45,
        "spd": 55,
        "spe": 73
    },
    "Veluza": {
        "hp": 90,
        "atk": 102,
        "def": 73,
        "spa": 78,
        "spd": 65,
        "spe": 70
    },
    "Dondozo": {
        "hp": 150,
        "atk": 100,
        "def": 115,
        "spa": 65,
        "spd": 65,
        "spe": 35
    },
    "Tatsugiri": {
        "hp": 68,
        "atk": 50,
        "def": 60,
        "spa": 120,
        "spd": 95,
        "spe": 82
    },
    "Tatsugiri-Stretchy": {
        "hp": 68,
        "atk": 50,
        "def": 60,
        "spa": 120,
        "spd": 95,
        "spe": 82
    },
    "Tatsugiri-Droopy": {
        "hp": 68,
        "atk": 50,
        "def": 60,
        "spa": 120,
        "spd": 95,
        "spe": 82
    },
    "Annihilape": {
        "hp": 110,
        "atk": 115,
        "def": 80,
        "spa": 50,
        "spd": 90,
        "spe": 90
    },
    "Clodsire": {
        "hp": 130,
        "atk": 75,
        "def": 60,
        "spa": 45,
        "spd": 100,
        "spe": 20
    },
    "Farigiraf": {
        "hp": 120,
        "atk": 90,
        "def": 70,
        "spa": 110,
        "spd": 70,
        "spe": 60
    },
    "Dudunsparce": {
        "hp": 125,
        "atk": 100,
        "def": 80,
        "spa": 85,
        "spd": 75,
        "spe": 55
    },
    "Dudunsparce-Three-Segment": {
        "hp": 125,
        "atk": 100,
        "def": 80,
        "spa": 85,
        "spd": 75,
        "spe": 55
    },
    "Kingambit": {
        "hp": 100,
        "atk": 135,
        "def": 120,
        "spa": 60,
        "spd": 85,
        "spe": 50
    },
    "Great Tusk": {
        "hp": 115,
        "atk": 131,
        "def": 131,
        "spa": 53,
        "spd": 53,
        "spe": 87
    },
    "Scream Tail": {
        "hp": 115,
        "atk": 65,
        "def": 99,
        "spa": 65,
        "spd": 115,
        "spe": 111
    },
    "Brute Bonnet": {
        "hp": 111,
        "atk": 127,
        "def": 99,
        "spa": 79,
        "spd": 99,
        "spe": 55
    },
    "Flutter Mane": {
        "hp": 55,
        "atk": 55,
        "def": 55,
        "spa": 135,
        "spd": 135,
        "spe": 135
    },
    "Slither Wing": {
        "hp": 85,
        "atk": 135,
        "def": 79,
        "spa": 85,
        "spd": 105,
        "spe": 81
    },
    "Sandy Shocks": {
        "hp": 85,
        "atk": 81,
        "def": 97,
        "spa": 121,
        "spd": 85,
        "spe": 101
    },
    "Iron Treads": {
        "hp": 90,
        "atk": 112,
        "def": 120,
        "spa": 72,
        "spd": 70,
        "spe": 106
    },
    "Iron Bundle": {
        "hp": 56,
        "atk": 80,
        "def": 114,
        "spa": 124,
        "spd": 60,
        "spe": 136
    },
    "Iron Hands": {
        "hp": 154,
        "atk": 140,
        "def": 108,
        "spa": 50,
        "spd": 68,
        "spe": 50
    },
    "Iron Jugulis": {
        "hp": 94,
        "atk": 80,
        "def": 86,
        "spa": 122,
        "spd": 80,
        "spe": 108
    },
    "Iron Moth": {
        "hp": 80,
        "atk": 70,
        "def": 60,
        "spa": 140,
        "spd": 110,
        "spe": 110
    },
    "Iron Thorns": {
        "hp": 100,
        "atk": 134,
        "def": 110,
        "spa": 70,
        "spd": 84,
        "spe": 72
    },
    "Frigibax": {
        "hp": 65,
        "atk": 75,
        "def": 45,
        "spa": 35,
        "spd": 45,
        "spe": 55
    },
    "Arctibax": {
        "hp": 90,
        "atk": 95,
        "def": 66,
        "spa": 45,
        "spd": 65,
        "spe": 62
    },
    "Baxcalibur": {
        "hp": 115,
        "atk": 145,
        "def": 92,
        "spa": 75,
        "spd": 86,
        "spe": 87
    },
    "Gimmighoul": {
        "hp": 45,
        "atk": 30,
        "def": 70,
        "spa": 75,
        "spd": 70,
        "spe": 10
    },
    "Gimmighoul-Roaming": {
        "hp": 45,
        "atk": 30,
        "def": 25,
        "spa": 75,
        "spd": 45,
        "spe": 80
    },
    "Gholdengo": {
        "hp": 87,
        "atk": 60,
        "def": 95,
        "spa": 133,
        "spd": 91,
        "spe": 84
    },
    "Wo-Chien": {
        "hp": 85,
        "atk": 85,
        "def": 100,
        "spa": 95,
        "spd": 135,
        "spe": 70
    },
    "Chien-Pao": {
        "hp": 80,
        "atk": 120,
        "def": 80,
        "spa": 90,
        "spd": 65,
        "spe": 135
    },
    "Ting-Lu": {
        "hp": 155,
        "atk": 110,
        "def": 125,
        "spa": 55,
        "spd": 80,
        "spe": 45
    },
    "Chi-Yu": {
        "hp": 55,
        "atk": 80,
        "def": 80,
        "spa": 135,
        "spd": 120,
        "spe": 100
    },
    "Roaring Moon": {
        "hp": 105,
        "atk": 139,
        "def": 71,
        "spa": 55,
        "spd": 101,
        "spe": 119
    },
    "Iron Valiant": {
        "hp": 74,
        "atk": 130,
        "def": 90,
        "spa": 120,
        "spd": 60,
        "spe": 116
    },
    "Koraidon": {
        "hp": 100,
        "atk": 135,
        "def": 115,
        "spa": 85,
        "spd": 100,
        "spe": 135
    },
    "Miraidon": {
        "hp": 100,
        "atk": 85,
        "def": 100,
        "spa": 135,
        "spd": 115,
        "spe": 135
    },
    "Walking Wake": {
        "hp": 99,
        "atk": 83,
        "def": 91,
        "spa": 125,
        "spd": 83,
        "spe": 109
    },
    "Iron Leaves": {
        "hp": 90,
        "atk": 130,
        "def": 88,
        "spa": 70,
        "spd": 108,
        "spe": 104
    },
    "Dipplin": {
        "hp": 80,
        "atk": 80,
        "def": 110,
        "spa": 95,
        "spd": 80,
        "spe": 40
    },
    "Poltchageist": {
        "hp": 40,
        "atk": 45,
        "def": 45,
        "spa": 74,
        "spd": 54,
        "spe": 50
    },
    "Poltchageist-Artisan": {
        "hp": 40,
        "atk": 45,
        "def": 45,
        "spa": 74,
        "spd": 54,
        "spe": 50
    },
    "Sinistcha": {
        "hp": 71,
        "atk": 60,
        "def": 106,
        "spa": 121,
        "spd": 80,
        "spe": 70
    },
    "Sinistcha-Masterpiece": {
        "hp": 71,
        "atk": 60,
        "def": 106,
        "spa": 121,
        "spd": 80,
        "spe": 70
    },
    "Okidogi": {
        "hp": 88,
        "atk": 128,
        "def": 115,
        "spa": 58,
        "spd": 86,
        "spe": 80
    },
    "Munkidori": {
        "hp": 88,
        "atk": 75,
        "def": 66,
        "spa": 130,
        "spd": 90,
        "spe": 106
    },
    "Fezandipiti": {
        "hp": 88,
        "atk": 91,
        "def": 82,
        "spa": 70,
        "spd": 125,
        "spe": 99
    },
    "Ogerpon": {
        "hp": 80,
        "atk": 120,
        "def": 84,
        "spa": 60,
        "spd": 96,
        "spe": 110
    },
    "Ogerpon-Wellspring": {
        "hp": 80,
        "atk": 120,
        "def": 84,
        "spa": 60,
        "spd": 96,
        "spe": 110
    },
    "Ogerpon-Hearthflame": {
        "hp": 80,
        "atk": 120,
        "def": 84,
        "spa": 60,
        "spd": 96,
        "spe": 110
    },
    "Ogerpon-Cornerstone": {
        "hp": 80,
        "atk": 120,
        "def": 84,
        "spa": 60,
        "spd": 96,
        "spe": 110
    },
    "Ogerpon-Teal-Tera": {
        "hp": 80,
        "atk": 120,
        "def": 84,
        "spa": 60,
        "spd": 96,
        "spe": 110
    },
    "Ogerpon-Wellspring-Tera": {
        "hp": 80,
        "atk": 120,
        "def": 84,
        "spa": 60,
        "spd": 96,
        "spe": 110
    },
    "Ogerpon-Hearthflame-Tera": {
        "hp": 80,
        "atk": 120,
        "def": 84,
        "spa": 60,
        "spd": 96,
        "spe": 110
    },
    "Ogerpon-Cornerstone-Tera": {
        "hp": 80,
        "atk": 120,
        "def": 84,
        "spa": 60,
        "spd": 96,
        "spe": 110
    },
    "Archaludon": {
        "hp": 90,
        "atk": 105,
        "def": 130,
        "spa": 125,
        "spd": 65,
        "spe": 85
    },
    "Hydrapple": {
        "hp": 106,
        "atk": 80,
        "def": 110,
        "spa": 120,
        "spd": 80,
        "spe": 44
    },
    "Gouging Fire": {
        "hp": 105,
        "atk": 115,
        "def": 121,
        "spa": 65,
        "spd": 93,
        "spe": 91
    },
    "Raging Bolt": {
        "hp": 125,
        "atk": 73,
        "def": 91,
        "spa": 137,
        "spd": 89,
        "spe": 75
    },
    "Iron Boulder": {
        "hp": 90,
        "atk": 120,
        "def": 80,
        "spa": 68,
        "spd": 108,
        "spe": 124
    },
    "Iron Crown": {
        "hp": 90,
        "atk": 72,
        "def": 100,
        "spa": 122,
        "spd": 108,
        "spe": 98
    },
    "Terapagos": {
        "hp": 90,
        "atk": 65,
        "def": 85,
        "spa": 65,
        "spd": 85,
        "spe": 60
    },
    "Terapagos-Terastal": {
        "hp": 95,
        "atk": 95,
        "def": 110,
        "spa": 105,
        "spd": 110,
        "spe": 85
    },
    "Terapagos-Stellar": {
        "hp": 160,
        "atk": 105,
        "def": 110,
        "spa": 130,
        "spd": 110,
        "spe": 85
    },
    "Pecharunt": {
        "hp": 88,
        "atk": 88,
        "def": 160,
        "spa": 88,
        "spd": 88,
        "spe": 88
    }
}

export default pokedex;